import React, { useState, useRef, useEffect, useCallback, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import Confetti from 'react-confetti';
import './App.css';
import PricingPage from './PricingPage';
import FeaturesPage from './FeaturesPage';
import LoginPage from './LoginPage';
import PolicyPage from './PolicyPage';
import TermsPage from './TermsPage';
import RefundPage from './RefundPage';
const BlogPage = lazy(() => import('./blog/BlogPage'));
const AlternativesPage = lazy(() => import('./alternative/AlternativesPage'));
const AlternativesComingSoonPost = lazy(() => import('./alternative/AlternativesComingSoonPost'));
const AlternativePostOpusclip = lazy(() => import('./alternative/AlternativePostOpusclip'));
const AlternativePostKlap = lazy(() => import('./alternative/AlternativePostKlap'));
const AlternativePostQuso = lazy(() => import('./alternative/AlternativePostQuso'));
const AlternativePostSubmagic = lazy(() => import('./alternative/AlternativePostSubmagic'));
const AlternativePostCapcut = lazy(() => import('./alternative/AlternativePostCapcut'));
const AlternativePostVizard = lazy(() => import('./alternative/AlternativePostVizard'));
const AlternativePostVeed = lazy(() => import('./alternative/AlternativePostVeed'));
const AlternativePostDescript = lazy(() => import('./alternative/AlternativePostDescript'));
const BlogPostAddHinglishSubtitles = lazy(() => import('./blog/BlogPostAddHinglishSubtitles'));
const BlogPostAiReelMakerIndiaCheap = lazy(() => import('./blog/BlogPostAiReelMakerIndiaCheap'));
const BlogPostConvertYoutubeToReels = lazy(() => import('./blog/BlogPostConvertYoutubeToReels'));
const BlogPostAiSeVideoEditingKaiseKare = lazy(() => import('./blog/BlogPostAiSeVideoEditingKaiseKare'));
const BlogPostReelsKoViralKaiseKare = lazy(() => import('./blog/BlogPostReelsKoViralKaiseKare'));
const BlogPostTurnPodcastIntoShortsAi = lazy(() => import('./blog/BlogPostTurnPodcastIntoShortsAi'));
const BlogPostViralReelsBananeWalaApp = lazy(() => import('./blog/BlogPostViralReelsBananeWalaApp'));
const BlogPostContentCreationTipsHindi = lazy(() => import('./blog/BlogPostContentCreationTipsHindi'));
const BlogPostInstagramUploadingGuide2026 = lazy(() => import('./blog/BlogPostInstagramUploadingGuide2026'));
const BlogPostHowToAddCaptionsToYoutubeShorts = lazy(() => import('./blog/BlogPostHowToAddCaptionsToYoutubeShorts'));
const BlogPostHowToMakeReelsWithExistingVideo = lazy(() => import('./blog/BlogPostHowToMakeReelsWithExistingVideo'));
const BlogPostLongVideoToShortClips = lazy(() => import('./blog/BlogPostLongVideoToShortClips'));
const BlogPostVideoToViralShorts = lazy(() => import('./blog/BlogPostVideoToViralShorts'));
const BlogPostVideoAShortsVirales = lazy(() => import('./blog/BlogPostVideoAShortsVirales'));
const BlogPostVideoEnShortsViraux = lazy(() => import('./blog/BlogPostVideoEnShortsViraux'));
const BlogPostVideoParaShortsVirais = lazy(() => import('./blog/BlogPostVideoParaShortsVirais'));
const BlogPostVideoZuViralenShorts = lazy(() => import('./blog/BlogPostVideoZuViralenShorts'));
const BlogPostVideoSeViralShortsHindi = lazy(() => import('./blog/BlogPostVideoSeViralShortsHindi'));
const BlogPostVideoSeViralShortsHinglish = lazy(() => import('./blog/BlogPostVideoSeViralShortsHinglish'));
const BlogPostVideoNunchiViralShorts = lazy(() => import('./blog/BlogPostVideoNunchiViralShorts'));
const BlogPostVideoIrunduViralShorts = lazy(() => import('./blog/BlogPostVideoIrunduViralShorts'));
const BlogPostVideoPasunViralShorts = lazy(() => import('./blog/BlogPostVideoPasunViralShorts'));
const BlogPostZoomRecordingToShorts = lazy(() => import('./blog/BlogPostZoomRecordingToShorts'));
const BlogPostGrabacionesDeZoomAShorts = lazy(() => import('./blog/BlogPostGrabacionesDeZoomAShorts'));
const BlogPostGravacaoZoomEmShorts = lazy(() => import('./blog/BlogPostGravacaoZoomEmShorts'));
const BlogPostZoomAufzeichnungZuShorts = lazy(() => import('./blog/BlogPostZoomAufzeichnungZuShorts'));
const BlogPostZoomRecordingToShortsFrench = lazy(() => import('./blog/BlogPostZoomRecordingToShortsFrench'));
const BlogPostZoomRecordingSeShortsHindi = lazy(() => import('./blog/BlogPostZoomRecordingSeShortsHindi'));
const BlogPostZoomRecordingKoShortsMeinBadlo = lazy(() => import('./blog/BlogPostZoomRecordingKoShortsMeinBadlo'));
const BlogPostZoomRecordingNunchiShorts = lazy(() => import('./blog/BlogPostZoomRecordingNunchiShorts'));
const BlogPostZoomRecordingToShortsTamil = lazy(() => import('./blog/BlogPostZoomRecordingToShortsTamil'));
const BlogPostZoomRecordingTeShorts = lazy(() => import('./blog/BlogPostZoomRecordingTeShorts'));
const BlogPostInterviewToShortClips = lazy(() => import('./blog/BlogPostInterviewToShortClips'));
const BlogPostEntrevistasAClipsCortos = lazy(() => import('./blog/BlogPostEntrevistasAClipsCortos'));
const BlogPostEntrevistaEmClipesCurtos = lazy(() => import('./blog/BlogPostEntrevistaEmClipesCurtos'));
const BlogPostInterviewZuKurzclips = lazy(() => import('./blog/BlogPostInterviewZuKurzclips'));
const BlogPostInterviewEnClipsCourts = lazy(() => import('./blog/BlogPostInterviewEnClipsCourts'));
const BlogPostInterviewSeShortClipsHindi = lazy(() => import('./blog/BlogPostInterviewSeShortClipsHindi'));
const BlogPostInterviewKoShortClipsMeinBadlo = lazy(() => import('./blog/BlogPostInterviewKoShortClipsMeinBadlo'));
const BlogPostInterviewNunchiShortClips = lazy(() => import('./blog/BlogPostInterviewNunchiShortClips'));
const BlogPostInterviewToShortClipsTamil = lazy(() => import('./blog/BlogPostInterviewToShortClipsTamil'));
const BlogPostInterviewSeShortClipsMarathi = lazy(() => import('./blog/BlogPostInterviewSeShortClipsMarathi'));
const BlogPostMeetingRecordingToShorts = lazy(() => import('./blog/BlogPostMeetingRecordingToShorts'));
const BlogPostGrabacionesDeReunionesAShorts = lazy(() => import('./blog/BlogPostGrabacionesDeReunionesAShorts'));
const BlogPostGravacaoDeReuniaoEmShorts = lazy(() => import('./blog/BlogPostGravacaoDeReuniaoEmShorts'));
const BlogPostMeetingAufzeichnungZuShorts = lazy(() => import('./blog/BlogPostMeetingAufzeichnungZuShorts'));
const BlogPostEnregistrementDeReunionEnShorts = lazy(() => import('./blog/BlogPostEnregistrementDeReunionEnShorts'));
const BlogPostMeetingRecordingSeShortsHindi = lazy(() => import('./blog/BlogPostMeetingRecordingSeShortsHindi'));
const BlogPostMeetingRecordingKoShortsMeinBadlo = lazy(() => import('./blog/BlogPostMeetingRecordingKoShortsMeinBadlo'));
const BlogPostMeetingRecordingNunchiShorts = lazy(() => import('./blog/BlogPostMeetingRecordingNunchiShorts'));
const BlogPostMeetingRecordingToShortsTamil = lazy(() => import('./blog/BlogPostMeetingRecordingToShortsTamil'));
const BlogPostMeetingRecordingSeShortsMarathi = lazy(() => import('./blog/BlogPostMeetingRecordingSeShortsMarathi'));
const BlogPostOnlineCourseToReels = lazy(() => import('./blog/BlogPostOnlineCourseToReels'));
const BlogPostCursoOnlineAReels = lazy(() => import('./blog/BlogPostCursoOnlineAReels'));
const BlogPostCursoOnlineEmReels = lazy(() => import('./blog/BlogPostCursoOnlineEmReels'));
const BlogPostOnlineKursZuReels = lazy(() => import('./blog/BlogPostOnlineKursZuReels'));
const BlogPostCoursEnLigneEnReels = lazy(() => import('./blog/BlogPostCoursEnLigneEnReels'));
const BlogPostOnlineCourseSeReelsHindi = lazy(() => import('./blog/BlogPostOnlineCourseSeReelsHindi'));
const BlogPostOnlineCourseKoReelsMeinBadlo = lazy(() => import('./blog/BlogPostOnlineCourseKoReelsMeinBadlo'));
const BlogPostOnlineCourseNunchiReels = lazy(() => import('./blog/BlogPostOnlineCourseNunchiReels'));
const BlogPostOnlineCourseToReelsTamil = lazy(() => import('./blog/BlogPostOnlineCourseToReelsTamil'));
const BlogPostOnlineCourseTeReelsMarathi = lazy(() => import('./blog/BlogPostOnlineCourseTeReelsMarathi'));
const BlogPostAiInstagramReelsGrowth2026 = lazy(() => import('./blog/BlogPostAiInstagramReelsGrowth2026'));
const BlogPostVideoToShortsConverterMakereels = lazy(() => import('./blog/BlogPostVideoToShortsConverterMakereels'));
const BlogPostAiShortsGenerator = lazy(() => import('./blog/BlogPostAiShortsGenerator'));
const BlogPostGeneradorDeShortsConIa = lazy(() => import('./blog/BlogPostGeneradorDeShortsConIa'));
const BlogPostVideoLargoAClipsCortos = lazy(() => import('./blog/BlogPostVideoLargoAClipsCortos'));
const BlogPostVideoLongoParaClipesCurtos = lazy(() => import('./blog/BlogPostVideoLongoParaClipesCurtos'));
const BlogPostClipsCourtsDepuisLongueVideo = lazy(() => import('./blog/BlogPostClipsCourtsDepuisLongueVideo'));
const BlogPostLangesVideoInKurzeClips = lazy(() => import('./blog/BlogPostLangesVideoInKurzeClips'));
const BlogPostLambaVideoSeChoteClips = lazy(() => import('./blog/BlogPostLambaVideoSeChoteClips'));
const BlogPostLambaVideoSeChoteClipsHinglish = lazy(() => import('./blog/BlogPostLambaVideoSeChoteClipsHinglish'));
const BlogPostPodavainaVideoNunchiChinnaClips = lazy(() => import('./blog/BlogPostPodavainaVideoNunchiChinnaClips'));
const BlogPostNeendaVideoSiriyaClips = lazy(() => import('./blog/BlogPostNeendaVideoSiriyaClips'));
const BlogPostLambVideoPasunChoteClips = lazy(() => import('./blog/BlogPostLambVideoPasunChoteClips'));
const BlogPostRepurposeContentIntoShorts = lazy(() => import('./blog/BlogPostContentNiShortsGaMaarchu'));
const BlogPostConvertirContenidoEnShorts = lazy(() => import('./blog/BlogPostConvertirContenidoEnShorts'));
const BlogPostTransformarConteudoEmShorts = lazy(() => import('./blog/BlogPostTransformarConteudoEmShorts'));
const BlogPostContentInShortsUmwandeln = lazy(() => import('./blog/BlogPostContentInShortsUmwandeln'));
const BlogPostTransformerContenuEnShorts = lazy(() => import('./blog/BlogPostTransformerContenuEnShorts'));
const BlogPostContentKoShortsMeinRepurposeKareinHindi = lazy(() => import('./blog/BlogPostContentKoShortsMeinRepurposeKareinHindi'));
const BlogPostContentKoShortsMeinRepurposeKareinHinglish = lazy(() => import('./blog/BlogPostContentKoShortsMeinRepurposeKareinHinglish'));
const BlogPostContentNiShortsGaMaarchu = lazy(() => import('./blog/BlogPostContentNiShortsGaMaarchu'));
const BlogPostContentShortsAgaMaatrunga = lazy(() => import('./blog/BlogPostContentShortsAgaMaatrunga'));
const BlogPostContentShortsMadheRepurposeKara = lazy(() => import('./blog/BlogPostContentShortsMadheRepurposeKara'));
const BlogPostGeradorDeShortsComIa = lazy(() => import('./blog/BlogPostGeradorDeShortsComIa'));
const BlogPostKiShortsGenerator = lazy(() => import('./blog/BlogPostKiShortsGenerator'));
const BlogPostGenerateurDeShortsIa = lazy(() => import('./blog/BlogPostGenerateurDeShortsIa'));
const BlogPostAiShortsGeneratorHiIn = lazy(() => import('./blog/BlogPostAiShortsGeneratorHiIn'));
const BlogPostAiShortsGeneratorHinglish = lazy(() => import('./blog/BlogPostAiShortsGeneratorHinglish'));
const BlogPostKratrimMedhasshuShortsGenerator = lazy(() => import('./blog/BlogPostKratrimMedhasshuShortsGenerator'));
const BlogPostSeyrkaiNunnarivuKurumpadamUruvakki = lazy(() => import('./blog/BlogPostSeyrkaiNunnarivuKurumpadamUruvakki'));
const BlogPostKratrimBuddhimattaShortsGenerator = lazy(() => import('./blog/BlogPostKratrimBuddhimattaShortsGenerator'));
const BlogPostHowToMakeMoneyWithAPodcast2026 = lazy(() => import('./blog/BlogPostHowToMakeMoneyWithAPodcast2026'));
const BlogPostMakereelsMarketingAgenciesGrowth = lazy(() => import('./blog/BlogPostMakereelsMarketingAgenciesGrowth'));
const BlogPostReelsNeInstagramGrowKara = lazy(() => import('./blog/BlogPostReelsNeInstagramGrowKara'));
const BlogPostReelsMoolamInstagramGrowTamil = lazy(() => import('./blog/BlogPostReelsMoolamInstagramGrowTamil'));
const BlogPostReelsThoInstagramPenchukovali = lazy(() => import('./blog/BlogPostReelsThoInstagramPenchukovali'));
const BlogPostInstagramKoReelsSeGrowKaro = lazy(() => import('./blog/BlogPostInstagramKoReelsSeGrowKaro'));
const BlogPostReelsSeInstagramGrowKaroHindi = lazy(() => import('./blog/BlogPostReelsSeInstagramGrowKaroHindi'));
const BlogPostFaireCroitreInstagramAvecReels = lazy(() => import('./blog/BlogPostFaireCroitreInstagramAvecReels'));
const BlogPostInstagramMitReelsWachsen = lazy(() => import('./blog/BlogPostInstagramMitReelsWachsen'));
const BlogPostCrescerInstagramComReels = lazy(() => import('./blog/BlogPostCrescerInstagramComReels'));
const BlogPostCrecerInstagramConReels = lazy(() => import('./blog/BlogPostCrecerInstagramConReels'));
const BlogPostGrowInstagramWithReels = lazy(() => import('./blog/BlogPostGrowInstagramWithReels'));
const BlogPostMofatUpshirshakNirmaata = lazy(() => import('./blog/BlogPostMofatUpshirshakNirmaata'));
const BlogPostIlavasaVasanaVariUruvaakki = lazy(() => import('./blog/BlogPostIlavasaVasanaVariUruvaakki'));
const BlogPostUchitaSubtitleGenerator = lazy(() => import('./blog/BlogPostUchitaSubtitleGenerator'));
const BlogPostFreeSubtitleGeneratorHinglish = lazy(() => import('./blog/BlogPostFreeSubtitleGeneratorHinglish'));
const BlogPostFreeSubtitleGeneratorHindi = lazy(() => import('./blog/BlogPostFreeSubtitleGeneratorHindi'));
const BlogPostGenerateurSousTitresGratuit = lazy(() => import('./blog/BlogPostGenerateurSousTitresGratuit'));
const BlogPostKostenloserUntertitelGenerator = lazy(() => import('./blog/BlogPostKostenloserUntertitelGenerator'));
const BlogPostGeradorLegendasGratuito = lazy(() => import('./blog/BlogPostGeradorLegendasGratuito'));
const BlogPostGeneradorSubtitulosGratuito = lazy(() => import('./blog/BlogPostGeneradorSubtitulosGratuito'));
const BlogPostFreeSubtitleGenerator = lazy(() => import('./blog/BlogPostFreeSubtitleGenerator'));
const BlogPostMofatMathalaNirmaata = lazy(() => import('./blog/BlogPostMofatMathalaNirmaata'));
const BlogPostIlavasaThalaippuraiUruvaakki = lazy(() => import('./blog/BlogPostIlavasaThalaippuraiUruvaakki'));
const BlogPostUchitaCaptionGenerator = lazy(() => import('./blog/BlogPostUchitaCaptionGenerator'));
const BlogPostFreeCaptionGeneratorHinglish = lazy(() => import('./blog/BlogPostFreeCaptionGeneratorHinglish'));
const BlogPostFreeCaptionGeneratorHindi = lazy(() => import('./blog/BlogPostFreeCaptionGeneratorHindi'));
const BlogPostGenerateurLegendesGratuit = lazy(() => import('./blog/BlogPostGenerateurLegendesGratuit'));
const BlogPostKostenloserCaptionGenerator = lazy(() => import('./blog/BlogPostKostenloserCaptionGenerator'));
const BlogPostGeradorLegendasGratuitoVideos = lazy(() => import('./blog/BlogPostGeradorLegendasGratuitoVideos'));
const BlogPostGeneradorSubtitulosGratuitoVideos = lazy(() => import('./blog/BlogPostGeneradorSubtitulosGratuitoVideos'));
const BlogPostFreeCaptionGenerator = lazy(() => import('./blog/BlogPostFreeCaptionGenerator'));
const BlogPostViralHookGeneratorMarathi = lazy(() => import('./blog/BlogPostViralHookGeneratorMarathi'));
const BlogPostViralKokkiUruvaakki = lazy(() => import('./blog/BlogPostViralKokkiUruvaakki'));
const BlogPostViralHookGeneratorTelugu = lazy(() => import('./blog/BlogPostViralHookGeneratorTelugu'));
const BlogPostViralHookGeneratorHinglish = lazy(() => import('./blog/BlogPostViralHookGeneratorHinglish'));
const BlogPostViralHookGeneratorHindi = lazy(() => import('./blog/BlogPostViralHookGeneratorHindi'));
const BlogPostGenerateurAccrochesVirales = lazy(() => import('./blog/BlogPostGenerateurAccrochesVirales'));
const BlogPostViralerHookGenerator = lazy(() => import('./blog/BlogPostViralerHookGenerator'));
const BlogPostGeradorGanchosVirais = lazy(() => import('./blog/BlogPostGeradorGanchosVirais'));
const BlogPostGeneradorGanchosVirales = lazy(() => import('./blog/BlogPostGeneradorGanchosVirales'));
const BlogPostViralHookGenerator = lazy(() => import('./blog/BlogPostViralHookGenerator'));
const BlogPostYouTubeShortsVarJastViews = lazy(() => import('./blog/BlogPostYouTubeShortsVarJastViews'));
const BlogPostYouTubeShortsAdhigaViewsTamil = lazy(() => import('./blog/BlogPostYouTubeShortsAdhigaViewsTamil'));
const BlogPostYouTubeShortsMoreViewsTelugu = lazy(() => import('./blog/BlogPostYouTubeShortsMoreViewsTelugu'));
const BlogPostYouTubeShortsPeZyadaViews = lazy(() => import('./blog/BlogPostYouTubeShortsPeZyadaViews'));
const BlogPostYouTubeShortsParJyadaViews = lazy(() => import('./blog/BlogPostYouTubeShortsParJyadaViews'));
const BlogPostPlusDeVuesSurYouTubeShorts = lazy(() => import('./blog/BlogPostPlusDeVuesSurYouTubeShorts'));
const BlogPostMehrAufrufeAufYouTubeShorts = lazy(() => import('./blog/BlogPostMehrAufrufeAufYouTubeShorts'));
const BlogPostMaisVisualizacoesNoYouTubeShorts = lazy(() => import('./blog/BlogPostMaisVisualizacoesNoYouTubeShorts'));
const BlogPostMasVistasEnYouTubeShorts = lazy(() => import('./blog/BlogPostMasVistasEnYouTubeShorts'));
const BlogPostGetMoreViewsOnYouTubeShorts = lazy(() => import('./blog/BlogPostGetMoreViewsOnYouTubeShorts'));
const BlogPostVideoAapaapVishanujanBanava = lazy(() => import('./blog/BlogPostVideoAapaapVishanujanBanava'));
const BlogPostKaanoligalaiThaanagaveViral = lazy(() => import('./blog/BlogPostKaanoligalaiThaanagaveViral'));
const BlogPostVideoIuSwayanchalakangaViral = lazy(() => import('./blog/BlogPostVideoIuSwayanchalakangaViral'));
const BlogPostVideosKoAutomaticallyViralKaro = lazy(() => import('./blog/BlogPostVideosKoAutomaticallyViralKaro'));
const BlogPostVideosKoAutomaticallyViralBanaye = lazy(() => import('./blog/BlogPostVideosKoAutomaticallyViralBanaye'));
const BlogPostRendreVideosViralesAutomatiquement = lazy(() => import('./blog/BlogPostRendreVideosViralesAutomatiquement'));
const BlogPostVideosAutomatischViralMachen = lazy(() => import('./blog/BlogPostVideosAutomatischViralMachen'));
const BlogPostVideosViralizaremAutomaticamente = lazy(() => import('./blog/BlogPostVideosViralizaremAutomaticamente'));
const BlogPostVideosViralesAutomaticamente = lazy(() => import('./blog/BlogPostVideosViralesAutomaticamente'));
const BlogPostMakeVideosGoViralAutomatically = lazy(() => import('./blog/BlogPostMakeVideosGoViralAutomatically'));
const BlogPostLaghuSvarupVideoPahanyachaVelVadhava = lazy(() => import('./blog/BlogPostLaghuSvarupVideoPahanyachaVelVadhava'));
const BlogPostKurumKaanoligalilPaarvaiNeram = lazy(() => import('./blog/BlogPostKurumKaanoligalilPaarvaiNeram'));
const BlogPostChinnaVideolaloVeekshanaSamayam = lazy(() => import('./blog/BlogPostChinnaVideolaloVeekshanaSamayam'));
const BlogPostShortFormVideoWatchTimeBadhao = lazy(() => import('./blog/BlogPostShortFormVideoWatchTimeBadhao'));
const BlogPostShortVideoWatchTimeBadhayeHindi = lazy(() => import('./blog/BlogPostShortVideoWatchTimeBadhayeHindi'));
const BlogPostAugmenterTempsVisionnageVideoCourt = lazy(() => import('./blog/BlogPostAugmenterTempsVisionnageVideoCourt'));
const BlogPostWiedergabezeitShortFormVideoErhoehen = lazy(() => import('./blog/BlogPostWiedergabezeitShortFormVideoErhoehen'));
const BlogPostAumentarTempoVisualizacaoVideoCurto = lazy(() => import('./blog/BlogPostAumentarTempoVisualizacaoVideoCurto'));
const BlogPostAumentarTiempoVisualizacionVideoCorto = lazy(() => import('./blog/BlogPostAumentarTiempoVisualizacionVideoCorto'));
const BlogPostIncreaseWatchTimeShortFormVideo = lazy(() => import('./blog/BlogPostIncreaseWatchTimeShortFormVideo'));
const BlogPostAiVideoMarketingGuide = lazy(() => import('./blog/BlogPostAiVideoMarketingGuide'));
const BlogPostAiVideoMarketingGuideHindi = lazy(() => import('./blog/BlogPostAiVideoMarketingGuideHindi'));
const BlogPostAiVideoMarketingGuideHinglish = lazy(() => import('./blog/BlogPostAiVideoMarketingGuideHinglish'));
const BlogPostAiVideoMarketingGuideMarathi = lazy(() => import('./blog/BlogPostAiVideoMarketingGuideMarathi'));
const BlogPostAiVideoMarketingGuideTamil = lazy(() => import('./blog/BlogPostAiVideoMarketingGuideTamil'));
const BlogPostAiVideoMarketingGuideTelugu = lazy(() => import('./blog/BlogPostAiVideoMarketingGuideTelugu'));
const BlogPostGuiaMarketingVideoComIA = lazy(() => import('./blog/BlogPostGuiaMarketingVideoComIA'));
const BlogPostGuiaMarketingVideoIA = lazy(() => import('./blog/BlogPostGuiaMarketingVideoIA'));
const BlogPostGuideMarketingVideoIA = lazy(() => import('./blog/BlogPostGuideMarketingVideoIA'));
const BlogPostKiVideoMarketingLeitfaden = lazy(() => import('./blog/BlogPostKiVideoMarketingLeitfaden'));
const BlogPostAiVideoClippingTool = lazy(() => import('./blog/BlogPostAiVideoClippingTool'));
const BlogPostAiVideoClippingToolHindi = lazy(() => import('./blog/BlogPostAiVideoClippingToolHindi'));
const BlogPostAiVideoClippingToolHinglish = lazy(() => import('./blog/BlogPostAiVideoClippingToolHinglish'));
const BlogPostAiVideoClippingToolMarathi = lazy(() => import('./blog/BlogPostAiVideoClippingToolMarathi'));
const BlogPostAiVideoClippingToolTamil = lazy(() => import('./blog/BlogPostAiVideoClippingToolTamil'));
const BlogPostAiVideoClippingToolTelugu = lazy(() => import('./blog/BlogPostAiVideoClippingToolTelugu'));
const BlogPostFerramentaClippingVideoIA = lazy(() => import('./blog/BlogPostFerramentaClippingVideoIA'));
const BlogPostHerramientaRecorteVideoIA = lazy(() => import('./blog/BlogPostHerramientaRecorteVideoIA'));
const BlogPostKiVideoClippingTool = lazy(() => import('./blog/BlogPostKiVideoClippingTool'));
const BlogPostOutilDecoupeVideoIA = lazy(() => import('./blog/BlogPostOutilDecoupeVideoIA'));
const BlogPostConvertVideoToVerticalFormat = lazy(() => import('./blog/BlogPostConvertVideoToVerticalFormat'));
const BlogPostConverterVideoParaFormatoVertical = lazy(() => import('./blog/BlogPostConverterVideoParaFormatoVertical'));
const BlogPostConvertirVideoAFormatoVertical = lazy(() => import('./blog/BlogPostConvertirVideoAFormatoVertical'));
const BlogPostConvertirVideoAuFormatVertical = lazy(() => import('./blog/BlogPostConvertirVideoAuFormatVertical'));
const BlogPostKaanoliyaiSenguthuVadivamagaMaatru = lazy(() => import('./blog/BlogPostKaanoliyaiSenguthuVadivamagaMaatru'));
const BlogPostVideoInsVertikaleFormatKonvertieren = lazy(() => import('./blog/BlogPostVideoInsVertikaleFormatKonvertieren'));
const BlogPostVideoKoVerticalFormatMeinConvertKarein = lazy(() => import('./blog/BlogPostVideoKoVerticalFormatMeinConvertKarein'));
const BlogPostVideoKoVerticalFormatMeinConvertKaro = lazy(() => import('./blog/BlogPostVideoKoVerticalFormatMeinConvertKaro'));
const BlogPostVideoNiluvaNirmitanikiMarchandi = lazy(() => import('./blog/BlogPostVideoNiluvaNirmitanikiMarchandi'));
const BlogPostVideoUbhaSwarupatRupantaritKara = lazy(() => import('./blog/BlogPostVideoUbhaSwarupatRupantaritKara'));
const BlogPostAutoCutSilenceFromVideo = lazy(() => import('./blog/BlogPostAutoCutSilenceFromVideo'));
const BlogPostCortarSilencioVideoAutomaticamente = lazy(() => import('./blog/BlogPostCortarSilencioVideoAutomaticamente'));
const BlogPostCorteAutomaticoSilenciosVideo = lazy(() => import('./blog/BlogPostCorteAutomaticoSilenciosVideo'));
const BlogPostCouperAutomatiquementSilencesVideos = lazy(() => import('./blog/BlogPostCouperAutomatiquementSilencesVideos'));
const BlogPostKaanoliyilirundhuMavunamVettu = lazy(() => import('./blog/BlogPostKaanoliyilirundhuMavunamVettu'));
const BlogPostStilleAutomatischAusVideosSchneiden = lazy(() => import('./blog/BlogPostStilleAutomatischAusVideosSchneiden'));
const BlogPostVideoMadhunMaunSwayanchalitKadha = lazy(() => import('./blog/BlogPostVideoMadhunMaunSwayanchalitKadha'));
const BlogPostVideoNundiNisshabdamCut = lazy(() => import('./blog/BlogPostVideoNundiNisshabdamCut'));
const BlogPostVideoSeSilenceAutoCutKarein = lazy(() => import('./blog/BlogPostVideoSeSilenceAutoCutKarein'));
const BlogPostVideoSeSilenceAutoCutKaro = lazy(() => import('./blog/BlogPostVideoSeSilenceAutoCutKaro'));
const BlogPostFaceTrackingVideoeditor = lazy(() => import('./blog/BlogPostFaceTrackingVideoeditor'));
const BlogPostGermanFaceTrackingVideoeditor = lazy(() => import('./blog/BlogPostGermanFaceTrackingVideoeditor'));
const BlogPostChehraTrackingVideoSampadak = lazy(() => import('./blog/BlogPostChehraTrackingVideoSampadak'));
const BlogPostEditeurVideoSuiviVisage = lazy(() => import('./blog/BlogPostEditeurVideoSuiviVisage'));
const BlogPostEditorVideoRastreamentoFacial = lazy(() => import('./blog/BlogPostEditorVideoRastreamentoFacial'));
const BlogPostEditorVideoSeguimientoFacial = lazy(() => import('./blog/BlogPostEditorVideoSeguimientoFacial'));
const BlogPostFaceTrackingVideoEditorHindi = lazy(() => import('./blog/BlogPostFaceTrackingVideoEditorHindi'));
const BlogPostFaceTrackingVideoEditorHinglish = lazy(() => import('./blog/BlogPostFaceTrackingVideoEditorHinglish'));
const BlogPostFaceTrackingVideoEditorTelugu = lazy(() => import('./blog/BlogPostFaceTrackingVideoEditorTelugu'));
const BlogPostMugamKankaanippuKaanoliThoguppi = lazy(() => import('./blog/BlogPostMugamKankaanippuKaanoliThoguppi'));
const BlogPostBatchCreateYouTubeShorts = lazy(() => import('./blog/BlogPostBatchCreateYouTubeShorts'));
const BlogPostBatchCreateYouTubeShortsHinglish = lazy(() => import('./blog/BlogPostBatchCreateYouTubeShortsHinglish'));
const BlogPostCrearYouTubeShortsEnLote = lazy(() => import('./blog/BlogPostCrearYouTubeShortsEnLote'));
const BlogComingSoonPost = lazy(() => import('./blog/BlogComingSoonPost'));
import ReelsAdminPage from './ReelsAdminPage';
import NotFoundPage from './NotFoundPage';
import ScrollToTop from './ScrollToTop';
import ReferralReturnCouponModal from './ReferralReturnCouponModal';
import WhatsAppSupportFab from './WhatsAppSupportFab';
import HeroWipe from './HeroWipe';
import HomeDashboardCards from './HomeDashboardCards';
import VideoBadgeProgress, {
  getBadgeProgress,
  BADGE_TIERS,
  getTierOverlayThemeStyle,
  readStoredBadgeTierIndex,
  writeStoredBadgeTierIndex,
} from './VideoBadgeProgress';
import HomeSignedInIdleShell from './HomeSignedInIdleShell';
import BadgeOverlayScreen from './BadgeOverlayScreen';
import PastProjects from './PastProjects';
import PublishToSocialBar from './PublishToSocialBar';
import DailyContentIdeaBar from './DailyContentIdeaBar';
import ResultPublishButton from './ResultPublishButton';
import ClipThumbnail from './ClipThumbnail';
import CalendarPage from './CalendarPage';
import IdeationPage from './IdeationPage';
import ProjectsPage from './ProjectsPage';
import StreakOverlayScreen from './StreakOverlayScreen';
import StreakPerfectHeadline from './StreakPerfectHeadline';
import { useAuth, updateUserTimeSaved, updateUserStreak, updateUserPush } from './useAuth';
import { enableStreakPushReminders, getNotificationPermission } from './pushNotifications';
import { usePushAttribution } from './usePushAttribution';
import { trackPageVisit, trackButtonClick, trackNamedEvent, trackUserLogin, trackUserLogout, trackVideoSelected, trackVideoUrlAdded, trackClickedAddPhoneDuringProcessing, trackProvidedPhoneDuringProcessing, trackClickedAddPhoneDuringDownload, trackProvidedPhoneDuringDownload, trackVideoTooLong, trackVideoTooLarge, trackResultPageVisit, trackCheckoutSuccessPageVisit, trackYoutubeStartDuringProcessing, trackYoutubePauseDuringProcessing, trackUploadAnotherVideoClick, trackClipPreviewPlayed, trackDailyContentIdeaClick, BUTTON_ENUMS, EVENT_ENUMS } from './userJourneyTracker';
import { prefetchVisitorCountry } from './visitorCountry';
import { validateVideoUrl } from './utils/videoUrlValidation';
import { FREE_DAILY_PROCESSING_LIMIT } from './userProfile';

const ROTATING_WORDS = ['Views', 'Followers', 'Subscribers'];

const BG_SHORTS_MP4 = '/bgshorts.mp4';
const BG_SHORTS_POSTER = '/static_bgshorts.png';
const CANONICAL_ORIGIN = 'https://makereels.live';
const HREFLANG_ROUTE_MAP = {
  '/blog/ai-shorts-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/es/blog/generador-de-shorts-con-ia': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/pt-BR/blog/gerador-de-shorts-com-ia': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/de-DE/blog/ki-shorts-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/fr-FR/blog/generateur-de-shorts-ia': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/hi-IN/blog/ai-shorts-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/en-IN/blog/ai-shorts-generator-hinglish': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/te-IN/blog/kratrim-medhasshu-shorts-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/mr-IN/blog/kratrim-buddhimatta-shorts-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-shorts-con-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-shorts-com-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-shorts-generator` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/generateur-de-shorts-ia` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-shorts-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-shorts-generator-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/kratrim-medhasshu-shorts-generator` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/kratrim-buddhimatta-shorts-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-shorts-generator` },
  ],
  '/blog/long-video-to-short-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/es/blog/video-largo-a-clips-cortos': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/pt-BR/blog/video-longo-para-clipes-curtos': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/fr-FR/blog/clips-courts-depuis-longue-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/de-DE/blog/langes-video-in-kurze-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/hi-IN/blog/lamba-video-se-chote-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/en-IN/blog/lamba-video-se-chote-clips-hinglish': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/te-IN/blog/podavaina-video-nunchi-chinna-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/ta-IN/blog/neenda-video-siriya-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/mr-IN/blog/lamb-video-pasun-chote-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-largo-a-clips-cortos` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-longo-para-clipes-curtos` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/clips-courts-depuis-longue-video` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/langes-video-in-kurze-clips` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/lamba-video-se-chote-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/lamba-video-se-chote-clips-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/podavaina-video-nunchi-chinna-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/neenda-video-siriya-clips` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/lamb-video-pasun-chote-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/long-video-to-short-clips` },
  ],
  '/blog/video-to-viral-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/es/blog/video-a-shorts-virales': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/pt-BR/blog/video-para-shorts-virais': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/fr-FR/blog/video-en-shorts-viraux': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/de-DE/blog/video-zu-viralen-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/hi-IN/blog/video-se-viral-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/en-IN/blog/video-se-viral-shorts-hinglish': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/te-IN/blog/video-nunchi-viral-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/ta-IN/blog/video-irundu-viral-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/mr-IN/blog/video-pasun-viral-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/video-a-shorts-virales` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/video-para-shorts-virais` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/video-en-shorts-viraux` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-zu-viralen-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/video-se-viral-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/video-se-viral-shorts-hinglish` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/video-nunchi-viral-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/video-irundu-viral-shorts` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-pasun-viral-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/video-to-viral-shorts` },
  ],
  '/blog/zoom-recording-to-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/es/blog/grabaciones-de-zoom-a-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/pt-BR/blog/gravacao-zoom-em-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/de-DE/blog/zoom-aufzeichnung-zu-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/fr-FR/blog/zoom-recording-to-shorts-french': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/hi-IN/blog/zoom-recording-se-shorts-hindi': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/en-IN/blog/zoom-recording-ko-shorts-mein-badlo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/te-IN/blog/zoom-recording-nunchi-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/ta-IN/blog/zoom-recording-to-shorts-tamil': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/mr-IN/blog/zoom-recording-te-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/grabaciones-de-zoom-a-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-zoom-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/zoom-aufzeichnung-zu-shorts` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/zoom-recording-to-shorts-french` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/zoom-recording-se-shorts-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/zoom-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/zoom-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/zoom-recording-to-shorts-tamil` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/zoom-recording-te-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/zoom-recording-to-shorts` },
  ],
  '/blog/interview-to-short-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/pt-BR/blog/entrevista-em-clipes-curtos': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/hi-IN/blog/interview-se-short-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/en-IN/blog/interview-ko-short-clips-mein-badlo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/te-IN/blog/interview-nunchi-short-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/ta-IN/blog/interview-to-short-clips-moments-platform-grow': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/mr-IN/blog/interview-se-short-clips': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/entrevista-em-clipes-curtos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/interview-se-short-clips` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/interview-ko-short-clips-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/interview-nunchi-short-clips` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/interview-to-short-clips-moments-platform-grow` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/interview-se-short-clips` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/interview-to-short-clips` },
  ],
  '/blog/meeting-recording-to-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/pt-BR/blog/gravacao-de-reuniao-em-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/hi-IN/blog/meeting-recording-se-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/en-IN/blog/meeting-recording-ko-shorts-mein-badlo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/te-IN/blog/meeting-recording-nunchi-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/ta-IN/blog/meeting-recording-to-shorts-record-calls-content': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/mr-IN/blog/meeting-recording-se-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gravacao-de-reuniao-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/meeting-recording-ko-shorts-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/meeting-recording-nunchi-shorts` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/meeting-recording-to-shorts-record-calls-content` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/meeting-recording-se-shorts` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/meeting-recording-to-shorts` },
  ],
  '/blog/online-course-to-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/pt-BR/blog/curso-online-em-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/hi-IN/blog/online-course-se-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/en-IN/blog/online-course-ko-reels-mein-badlo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/te-IN/blog/online-course-nunchi-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/mr-IN/blog/online-course-te-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/curso-online-em-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/online-course-se-reels` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/online-course-ko-reels-mein-badlo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/online-course-nunchi-reels` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/online-course-te-reels` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/online-course-to-reels` },
  ],
  '/blog/repurpose-content-into-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/es/blog/convertir-contenido-en-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/pt-BR/blog/transformar-conteudo-em-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/de-DE/blog/content-in-shorts-umwandeln': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/fr-FR/blog/transformer-contenu-en-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/hi-IN/blog/content-ko-shorts-mein-repurpose-karein': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/en-IN/blog/content-ko-shorts-mein-repurpose-karein': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/te-IN/blog/content-ni-shorts-ga-maarchu': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/ta-IN/blog/content-shorts-aga-maatrunga': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/mr-IN/blog/content-shorts-madhe-repurpose-kara': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-contenido-en-shorts` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/transformar-conteudo-em-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/content-in-shorts-umwandeln` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/transformer-contenu-en-shorts` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/content-ko-shorts-mein-repurpose-karein` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/content-ni-shorts-ga-maarchu` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/content-shorts-aga-maatrunga` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/content-shorts-madhe-repurpose-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/repurpose-content-into-shorts` },
  ],
  '/blog/increase-watch-time-short-form-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/hi-IN/blog/short-video-watch-time-badhaye': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/te-IN/blog/increase-watch-time-short-form-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/ta-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/short-video-watch-time-badhaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/increase-watch-time-short-form-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/increase-watch-time-short-form-video` },
  ],
  '/blog/make-videos-go-viral-automatically': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/pt-BR/blog/fazer-videos-viralizarem-automaticamente': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/hi-IN/blog/videos-ko-automatically-viral-banaye': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/en-IN/blog/videos-ko-automatically-viral-karo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/te-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/ta-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/mr-IN/blog/video-aapaapa-vishanujan-banava': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/fazer-videos-viralizarem-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/videos-ko-automatically-viral-banaye` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/videos-ko-automatically-viral-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/video-aapaapa-vishanujan-banava` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/make-videos-go-viral-automatically` },
  ],
  '/blog/get-more-views-on-youtube-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/hi-IN/blog/youtube-shorts-par-jyada-views': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/ta-IN/blog/youtube-shorts-views-2026-complete-guide': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/mr-IN/blog/youtube-shorts-var-jast-views': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/youtube-shorts-par-jyada-views` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/youtube-shorts-views-2026-complete-guide` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/youtube-shorts-var-jast-views` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/get-more-views-on-youtube-shorts` },
  ],
  '/blog/viral-hook-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/pt-BR/blog/gerador-de-ganchos-virais': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/hi-IN/blog/viral-hook-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/te-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/ta-IN/blog/viral-hook-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/mr-IN/blog/viral-hook-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-ganchos-virais` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/viral-hook-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/viral-hook-generator` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/viral-hook-generator` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/viral-hook-generator` },
  ],
  '/blog/free-caption-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/pt-BR/blog/gerador-de-legendas-gratuito-para-videos': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/hi-IN/blog/free-caption-generator-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/en-IN/blog/free-caption-generator-best-tools-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/te-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/ta-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/mr-IN/blog/mofat-mathala-nirmaata': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/gerador-de-legendas-gratuito-para-videos` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-caption-generator-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-caption-generator-best-tools-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-mathala-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-caption-generator` },
  ],
  '/blog/free-subtitle-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/pt-BR/blog/generador-de-subtitulos-gratuito': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/hi-IN/blog/free-subtitle-generator': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/en-IN/blog/free-subtitle-generator-best-options-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/te-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/ta-IN/blog/2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/mr-IN/blog/mofat-upshirshak-nirmaata': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/generador-de-subtitulos-gratuito` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/free-subtitle-generator` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/free-subtitle-generator-best-options-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/mofat-upshirshak-nirmaata` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/free-subtitle-generator` },
  ],
  '/blog/grow-instagram-with-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/pt-BR/blog/como-crescer-no-instagram-com-reels': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/hi-IN/blog/reels-se-instagram-grow-karo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/te-IN/blog/reels-tho-instagram-ela-penchukovaali': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/ta-IN/blog/reels-instagram-grow-2026-complete-strategy': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/mr-IN/blog/reels-ne-instagram-grow-kara': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/como-crescer-no-instagram-com-reels` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/reels-se-instagram-grow-karo` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/reels-tho-instagram-ela-penchukovaali` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/reels-instagram-grow-2026-complete-strategy` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/reels-ne-instagram-grow-kara` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/grow-instagram-with-reels` },
  ],
  '/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/es/blog/guia-marketing-video-ia-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/pt-BR/blog/guia-marketing-video-ia-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/de-DE/blog/ki-video-marketing-leitfaden-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/hi-IN/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/en-IN/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/te-IN/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/ta-IN/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/mr-IN/blog/ai-video-marketing-guide-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/guia-marketing-video-ia-2026` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-marketing-leitfaden-2026` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-marketing-guide-2026` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-marketing-guide-2026` },
  ],
  '/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/es/blog/herramienta-recorte-video-ia': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/pt-BR/blog/ferramenta-clipping-video-ia': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/de-DE/blog/ki-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/hi-IN/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/en-IN/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/te-IN/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/ta-IN/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/mr-IN/blog/ai-video-clipping-tool': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/herramienta-recorte-video-ia` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/ferramenta-clipping-video-ia` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/ki-video-clipping-tool` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/ai-video-clipping-tool` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/ai-video-clipping-tool` },
  ],
  '/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/es/blog/convertir-video-a-formato-vertical': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/pt-BR/blog/converter-video-para-formato-vertical': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/de-DE/blog/video-ins-vertikale-format-konvertieren': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/hi-IN/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/en-IN/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/te-IN/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/ta-IN/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/mr-IN/blog/convert-video-to-vertical-format': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/convertir-video-a-formato-vertical` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/converter-video-para-formato-vertical` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/video-ins-vertikale-format-konvertieren` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/convert-video-to-vertical-format` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/convert-video-to-vertical-format` },
  ],
  '/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/es/blog/corte-automatico-silencios-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/pt-BR/blog/cortar-silencio-video-automaticamente': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/de-DE/blog/stille-automatisch-aus-videos-schneiden': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/hi-IN/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/en-IN/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/te-IN/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/ta-IN/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/mr-IN/blog/auto-cut-silence-from-video': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/corte-automatico-silencios-video` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/cortar-silencio-video-automaticamente` },
    { hreflang: 'de-DE', href: `${CANONICAL_ORIGIN}/de-DE/blog/stille-automatisch-aus-videos-schneiden` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'mr-IN', href: `${CANONICAL_ORIGIN}/mr-IN/blog/auto-cut-silence-from-video` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/auto-cut-silence-from-video` },
  ],
  '/blog/face-tracking-videoeditor': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/es/blog/editor-video-seguimiento-facial': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/pt-BR/blog/editor-video-rastreamento-facial': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/fr-FR/blog/editeur-video-suivi-visage': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/hi-IN/blog/face-tracking-video-editor-hindi': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/en-IN/blog/face-tracking-video-editor': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/te-IN/blog/face-tracking-video-editor': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/editor-video-seguimiento-facial` },
    { hreflang: 'pt-BR', href: `${CANONICAL_ORIGIN}/pt-BR/blog/editor-video-rastreamento-facial` },
    { hreflang: 'fr-FR', href: `${CANONICAL_ORIGIN}/fr-FR/blog/editeur-video-suivi-visage` },
    { hreflang: 'hi-IN', href: `${CANONICAL_ORIGIN}/hi-IN/blog/face-tracking-video-editor-hindi` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/face-tracking-video-editor` },
    { hreflang: 'te-IN', href: `${CANONICAL_ORIGIN}/te-IN/blog/face-tracking-video-editor` },
    { hreflang: 'ta-IN', href: `${CANONICAL_ORIGIN}/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/face-tracking-videoeditor` },
  ],
  '/blog/batch-create-youtube-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/batch-create-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/crear-youtube-shorts-en-lote` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
  ],
  '/en-IN/blog/batch-create-youtube-shorts': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/batch-create-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/crear-youtube-shorts-en-lote` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
  ],
  '/es/blog/crear-youtube-shorts-en-lote': [
    { hreflang: 'en', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
    { hreflang: 'en-IN', href: `${CANONICAL_ORIGIN}/en-IN/blog/batch-create-youtube-shorts` },
    { hreflang: 'es', href: `${CANONICAL_ORIGIN}/es/blog/crear-youtube-shorts-en-lote` },
    { hreflang: 'x-default', href: `${CANONICAL_ORIGIN}/blog/batch-create-youtube-shorts` },
  ],
};

/** Footer strip below the fold: poster until section is near viewport, then load MP4. */
function HomeBgShortsVideo() {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin: '200px 0px', threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!shouldLoad || !videoRef.current) {
      return undefined;
    }
    const v = videoRef.current;
    v.load();
    const p = v.play();
    if (p !== undefined) {
      p.catch(() => {});
    }
    return undefined;
  }, [shouldLoad]);

  return (
    <div ref={sectionRef} className="bg-video-section">
      <video
        ref={videoRef}
        className="bg-video"
        poster={BG_SHORTS_POSTER}
        preload="none"
        muted
        loop
        playsInline
        autoPlay
      >
        {shouldLoad ? <source src={BG_SHORTS_MP4} type="video/mp4" /> : null}
      </video>
      <div className="bg-video-fade" />
    </div>
  );
}

/** Renders inside `Router`; omits the WhatsApp FAB on `/reelsadmin`. */
function WhatsAppSupportFabForRoute({ supportNumber, isPremiumUser }) {
  const { pathname } = useLocation();
  if (pathname === '/reelsadmin') {
    return null;
  }
  return <WhatsAppSupportFab supportNumber={supportNumber} isPremiumUser={isPremiumUser} />;
}

function CanonicalTagForRoute() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalPath = pathname || '/';
    const canonicalHref = `${CANONICAL_ORIGIN}${canonicalPath}`;
    let canonicalLink = document.querySelector('link[rel="canonical"]');

    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    canonicalLink.setAttribute('href', canonicalHref);
  }, [pathname]);

  return null;
}

function HreflangTagsForRoute() {
  const { pathname } = useLocation();

  useEffect(() => {
    const managedSelector = 'link[data-hreflang-managed="true"]';
    document.querySelectorAll(managedSelector).forEach((node) => node.remove());

    const alternates = HREFLANG_ROUTE_MAP[pathname] || [];
    alternates.forEach(({ hreflang, href }) => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', hreflang);
      link.setAttribute('href', href);
      link.setAttribute('data-hreflang-managed', 'true');
      document.head.appendChild(link);
    });
  }, [pathname]);

  return null;
}

const PENDING_SIGNIN_STORAGE_KEY = 'makereels_pending_signin';

function SignInRedirectHandler({ onOpenSignIn }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const message = sessionStorage.getItem(PENDING_SIGNIN_STORAGE_KEY);
    if (!message || pathname !== '/') return;
    sessionStorage.removeItem(PENDING_SIGNIN_STORAGE_KEY);
    onOpenSignIn(message);
  }, [pathname, onOpenSignIn]);

  return null;
}

/** Local-only streak overlay preview (?streakPreview=day1|extend|restart on localhost). */
const STREAK_OVERLAY_DURATION_MS = 5200;
const STREAK_OVERLAY_FAST_DURATION_MS = 900;
/** Celebration card size vs home streak card (flies down to 1 / scale at end). */
const STREAK_OVERLAY_DISPLAY_SCALE = 1.85;
const STREAK_PREVIEW_PRESETS = {
  day1: { from: 0, to: 1 },
  extend: { from: 2, to: 3 },
  restart: { from: 5, to: 1 },
};

function isLocalStreakPreviewHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

function readStreakPreviewFromUrl() {
  if (!isLocalStreakPreviewHost()) return null;
  const params = new URLSearchParams(window.location.search);
  const variant = (params.get('streakPreview') || '').trim().toLowerCase();
  if (!variant || !STREAK_PREVIEW_PRESETS[variant]) return null;
  const fastRaw = (params.get('streakFast') || '').trim().toLowerCase();
  const fast = fastRaw === '1' || fastRaw === 'true';
  return { variant, fast };
}

/** Local-only badge bar preview (?badgePreview=<count> on localhost). */
function readBadgePreviewCountFromUrl() {
  if (!isLocalStreakPreviewHost()) return null;
  const params = new URLSearchParams(window.location.search);
  if (!params.has('badgePreview')) return null;
  const n = parseInt(params.get('badgePreview'), 10);
  return Number.isNaN(n) ? null : Math.max(0, n);
}

/** Local-only badge unlock overlay preview (?badgeUnlockPreview=bronze|silver|... on localhost). */
const BADGE_OVERLAY_DURATION_MS = 5200;
const BADGE_OVERLAY_FAST_DURATION_MS = 900;
/** Celebration card size vs home badge medal slot. */
const BADGE_OVERLAY_DISPLAY_SCALE = 5.2;
const BADGE_UNLOCK_PREVIEW_TIERS = new Set(['bronze', 'silver', 'gold', 'platinum', 'diamond']);

function readBadgeUnlockPreviewFromUrl() {
  if (!isLocalStreakPreviewHost()) return null;
  const params = new URLSearchParams(window.location.search);
  const tierKey = (params.get('badgeUnlockPreview') || '').trim().toLowerCase();
  if (!tierKey || !BADGE_UNLOCK_PREVIEW_TIERS.has(tierKey)) return null;
  const fastRaw = (params.get('badgeFast') || params.get('streakFast') || '').trim().toLowerCase();
  const fast = fastRaw === '1' || fastRaw === 'true';
  return { tierKey, fast };
}

function fetchBlobWithProgress(url, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Accept', 'video/mp4, video/*, */*');

    let fallbackInterval = null;
    let hasRealProgress = false;
    let fallbackProgress = 0;

    const clearFallback = () => {
      if (fallbackInterval) {
        clearInterval(fallbackInterval);
        fallbackInterval = null;
      }
    };

    xhr.addEventListener('progress', (event) => {
      if (event.lengthComputable && event.total > 0) {
        hasRealProgress = true;
        clearFallback();
        onProgress(Math.min(Math.round((event.loaded / event.total) * 100), 99));
      }
    });

    xhr.addEventListener('loadstart', () => {
      onProgress(0);
      fallbackInterval = setInterval(() => {
        if (hasRealProgress) return;
        fallbackProgress = Math.min(fallbackProgress + 2, 90);
        onProgress(fallbackProgress);
      }, 200);
    });

    xhr.addEventListener('load', () => {
      clearFallback();
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(100);
        resolve(xhr.response);
      } else {
        reject(new Error(`Download failed: ${xhr.status} ${xhr.statusText}`));
      }
    });

    xhr.addEventListener('error', () => {
      clearFallback();
      reject(new Error('Download failed. Please check your connection.'));
    });

    xhr.addEventListener('abort', () => {
      clearFallback();
      reject(new Error('Download cancelled.'));
    });

    xhr.send();
  });
}

const PROCESSING_PROGRESS_MILESTONES = [0, 25, 30, 45, 55, 90, 100];
/** Visual overshoot past the next milestone while waiting for backend confirmation. */
const PROCESSING_MILESTONE_BUFFER = 5;

function getNextProcessingMilestone(confirmedPercent) {
  for (let i = 0; i < PROCESSING_PROGRESS_MILESTONES.length; i += 1) {
    if (PROCESSING_PROGRESS_MILESTONES[i] > confirmedPercent) {
      return PROCESSING_PROGRESS_MILESTONES[i];
    }
  }
  return 100;
}

function getConfirmedProcessingMilestone(confirmedPercent) {
  let floor = 0;
  for (let i = 0; i < PROCESSING_PROGRESS_MILESTONES.length; i += 1) {
    if (PROCESSING_PROGRESS_MILESTONES[i] <= confirmedPercent) {
      floor = PROCESSING_PROGRESS_MILESTONES[i];
    }
  }
  return floor;
}

/** Segment floor, next backend milestone, and visual ceiling (milestone + buffer). */
function getProcessingSegmentBounds(confirmedPercent) {
  const floor = getConfirmedProcessingMilestone(confirmedPercent);
  const next = getNextProcessingMilestone(confirmedPercent);
  const bufferCap = next >= 100
    ? 99.99
    : roundProcessingProgress(Math.min(next + PROCESSING_MILESTONE_BUFFER, 99.99));
  return { floor, next, bufferCap };
}

function roundProcessingProgress(value) {
  return Math.round(value * 100) / 100;
}

const PROCESSING_PROGRESS_MAX = 99;

/** Set true to keep the processing UI mounted for live CSS/layout iteration. Revert before commit. */
const DEV_FORCE_PROCESSING_VIEW = false;

function computeCapMicroStep(current, floor, cap) {
  if (current >= cap || cap <= floor) return 0;
  const headroom = cap - floor;
  const traveled = Math.max(0, current - floor);
  const ratio = headroom > 0 ? Math.min(traveled / headroom, 1) : 1;
  const speedFactor = Math.max(0.03, 1 - ratio * ratio);
  return Math.min(0.08 * speedFactor, cap - current);
}

/** Buffer-zone step: slow micro-creep with guaranteed 0.01 ticks at 2-decimal display. */
function computeBufferZoneStep(current, bufferStart, ceiling) {
  const remaining = roundProcessingProgress(ceiling - current);
  if (remaining <= 0) return 0;
  if (remaining <= 0.01) return remaining;

  const micro = computeCapMicroStep(current, bufferStart, ceiling);
  const step = Math.max(0.01, micro > 0 ? micro : 0.01);
  return Math.min(step, remaining);
}

/**
 * Segment progress: normal speed to midpoint, ease to milestone, slow buffer creep (+5%).
 * Never snaps to backend milestones or moves backward.
 */
function computeProcessingProgressStep(current, confirmedPercent, elapsedMs, etaMs) {
  const { floor, next, bufferCap } = getProcessingSegmentBounds(confirmedPercent);
  const midpoint = floor + (next - floor) / 2;
  const safeEtaMs = Math.max(etaMs, 60000);
  const etaRatePerTick = (PROCESSING_PROGRESS_MAX / safeEtaMs) * 150;
  const timeTarget = roundProcessingProgress(
    Math.min((elapsedMs / safeEtaMs) * PROCESSING_PROGRESS_MAX, bufferCap),
  );

  if (current >= bufferCap) return current;

  if (current < timeTarget - 0.001) {
    let step = Math.max(0.03, Math.min(timeTarget - current, etaRatePerTick));

    if (current < midpoint) {
      const distToMid = midpoint - current;
      if (distToMid > 0 && distToMid < 2) {
        step = Math.min(step, Math.max(0.02, etaRatePerTick * (distToMid / 2)));
      }
    } else if (current < next) {
      const span = Math.max(next - midpoint, 0.01);
      const t = Math.min(1, Math.max(0, (current - midpoint) / span));
      const easeFactor = Math.max(0.12, 1 - t * t);
      step = Math.max(0.01, step * easeFactor);
    } else {
      const step = computeBufferZoneStep(current, next, Math.min(timeTarget, bufferCap));
      return roundProcessingProgress(Math.min(current + step, timeTarget, bufferCap));
    }

    return roundProcessingProgress(Math.min(current + step, timeTarget, bufferCap));
  }

  if (current >= next - 0.02 && current < bufferCap) {
    const step = computeBufferZoneStep(current, next, bufferCap);
    if (step > 0) {
      return roundProcessingProgress(Math.min(current + step, bufferCap));
    }
  }

  return current;
}

function App() {
  const { user, loading: authLoading, idToken, signInWithGoogle, triggerGoogleOneTap, logout, isAuthenticated, getFreshToken, userProfileReady } = useAuth();
  const getFreshTokenRef = useRef(getFreshToken);
  useEffect(() => {
    getFreshTokenRef.current = getFreshToken;
  }, [getFreshToken]);
  usePushAttribution(isAuthenticated, idToken);
  const isPremiumUser = user?.plan_tier === 'premium';
  const freeRunsRemaining = isPremiumUser
    ? null
    : (typeof user?.free_runs_remaining === 'number'
        ? user.free_runs_remaining
        : FREE_DAILY_PROCESSING_LIMIT);
  const isFreeDailyLimitReached = !isPremiumUser && freeRunsRemaining === 0;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userPhoneNumber, setUserPhoneNumber] = useState(null); // Store user's phone from Firebase
  const [showGetNotified, setShowGetNotified] = useState(false); // Show "get notified" message after 5 seconds
  const [showPhonePopup, setShowPhonePopup] = useState(false); // Show phone number popup
  const [phonePopupMode, setPhonePopupMode] = useState(null); // 'notify' or 'download'
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthPlatforms = [
      { key: 'youtube', label: 'YouTube channel' },
      { key: 'instagram', label: 'Instagram account' },
      { key: 'facebook', label: 'Facebook Page' },
      { key: 'linkedin', label: 'LinkedIn profile' },
    ];
    let changed = false;
    for (const { key, label } of oauthPlatforms) {
      if (params.get(key) === 'connected') {
        setUploadStatus({ type: 'success', message: `${label} connected.` });
        params.delete(key);
        changed = true;
        break;
      }
      if (params.get(key) === 'error') {
        setUploadStatus({
          type: 'error',
          message: params.get('message') || `${label} connection failed.`,
        });
        params.delete(key);
        params.delete('message');
        changed = true;
        break;
      }
    }
    if (changed) {
      const next = `${window.location.pathname}${params.toString() ? `?${params}` : ''}`;
      window.history.replaceState({}, '', next);
    }
  }, []);

  const [currentTask, setCurrentTask] = useState(null);
  const [processingStatus, setProcessingStatus] = useState(null);
  const [resultFiles, setResultFiles] = useState([]);
  const [downloadProgressByFile, setDownloadProgressByFile] = useState({});
  const [sharingFiles, setSharingFiles] = useState(new Set());
  const [uploadedVideo, setUploadedVideo] = useState(null);
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [dummyProgress, setDummyProgress] = useState(0);
  const [eta, setEta] = useState(null);
  const [videoDuration, setVideoDuration] = useState(null);
  const [localVideoResolution, setLocalVideoResolution] = useState(null);
  const progressCreepRef = useRef(null);
  const confirmedProgressRef = useRef(0);
  const dummyProgressRef = useRef(0);
  const progressStartTimeRef = useRef(Date.now());
  const progressEtaMsRef = useRef(6 * 60 * 1000);
  const timeSavedBeforeProcessingRef = useRef(0);
  const [videoThumbnail, setVideoThumbnail] = useState(null);
  const [youtubeThumbnail, setYoutubeThumbnail] = useState(null);
  const [youtubeMetadata, setYoutubeMetadata] = useState(null);
  const [isFetchingMetadata, setIsFetchingMetadata] = useState(false);
  const [youtubeMetadataError, setYoutubeMetadataError] = useState(false);
  const [youtubeMetadataErrorMessage, setYoutubeMetadataErrorMessage] = useState('');
  const [selectedFontTemplate, setSelectedFontTemplate] = useState('sporty_remotion');
  const [selectedLanguage, setSelectedLanguage] = useState('auto');
  const [backgroundOptions, setBackgroundOptions] = useState([{ id: 'auto', name: 'Auto', type: 'auto' }]);
  const [selectedBackground, setSelectedBackground] = useState('auto');
  const [customBackgroundError, setCustomBackgroundError] = useState('');
  const [isStagingBackground, setIsStagingBackground] = useState(false);
  const [stagedBackgroundPreviewUrl, setStagedBackgroundPreviewUrl] = useState('');
  const [stagedBackgroundPreviewType, setStagedBackgroundPreviewType] = useState('');
  const customBgFileInputRef = useRef(null);
  const [trimSilence, setTrimSilence] = useState(true);
  const [includeBroll, setIncludeBroll] = useState(true);
  const [addCaptions, setAddCaptions] = useState(true);
  const [aiHooks, setAiHooks] = useState(true);
  const [selectedHookTemplate, setSelectedHookTemplate] = useState('auto');
  const [premiumBadgeJitter, setPremiumBadgeJitter] = useState(null);
  const premiumBadgeJitterTimerRef = useRef(null);
  const [showFreeQuotaInfo, setShowFreeQuotaInfo] = useState(false);
  const freeQuotaInfoRef = useRef(null);
  const [playingVideo, setPlayingVideo] = useState(null);
  const [showPauseButton, setShowPauseButton] = useState({});
  const [timeSavedSecondsDisplay, setTimeSavedSecondsDisplay] = useState(0);
  const [timeSavedDelta, setTimeSavedDelta] = useState(0);
  const [showTimeSavedOverlay, setShowTimeSavedOverlay] = useState(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('session') === 'success';
  });
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [loginMode, setLoginMode] = useState('signup'); // 'signup' or 'signin'

  const openSignInForFeature = useCallback((message) => {
    if (message) {
      setUploadStatus({
        type: 'error',
        message,
      });
    }
    setLoginMode('signup');
    setIsSignupModalOpen(true);
  }, []);

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [youtubeUrlError, setYoutubeUrlError] = useState('');
  const [youtubeUrlEnabled, setYoutubeUrlEnabled] = useState(true);
  const [requirePhoneForDownload, setRequirePhoneForDownload] = useState(true);
  const [taskRequirePhoneForDownload, setTaskRequirePhoneForDownload] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [rotatingWord, setRotatingWord] = useState(0);
  const [isRolling, setIsRolling] = useState(false);
  const fileInputRef = useRef(null);
  const selectedFileRef = useRef(null); // mirror of selectedFile for visibility handler (avoids stale closure)
  const fileInputPollRef = useRef(null); // interval id for iOS picker polling
  const userMenuRef = useRef(null);
  const videoRefs = useRef({});
  const timeSavedWidgetRef = useRef(null);
  const streakCardRef = useRef(null);
  const badgeMedalRef = useRef(null);
  const [overlayTargetCoords, setOverlayTargetCoords] = useState({ x: 0, y: 0 });
  const [highlightTimeSaved, setHighlightTimeSaved] = useState(false);
  const [streakCountDisplay, setStreakCountDisplay] = useState(1);
  const [showStreakOverlay, setShowStreakOverlay] = useState(false);
  const [streakOverlayFrom, setStreakOverlayFrom] = useState(1);
  const [streakOverlayTo, setStreakOverlayTo] = useState(1);
  const [streakFlyCoords, setStreakFlyCoords] = useState({ x: 0, y: 0 });
  const [streakOverlayFast, setStreakOverlayFast] = useState(false);
  const [streakOverlaySize, setStreakOverlaySize] = useState({ width: 280, height: 280 });
  const [streakFlyEndScale, setStreakFlyEndScale] = useState(1);
  const [streakCardHighlight, setStreakCardHighlight] = useState(false);
  const [badgeCountDisplay, setBadgeCountDisplay] = useState(0);
  const [showBadgeOverlay, setShowBadgeOverlay] = useState(false);
  const [badgeOverlayTier, setBadgeOverlayTier] = useState(null);
  const [badgeOverlayPrevCount, setBadgeOverlayPrevCount] = useState(0);
  const [badgeFlyCoords, setBadgeFlyCoords] = useState({ x: 0, y: 0 });
  const [badgeOverlayFast, setBadgeOverlayFast] = useState(false);
  const [badgeOverlaySize, setBadgeOverlaySize] = useState({ width: 200, height: 220 });
  const [badgeFlyEndScale, setBadgeFlyEndScale] = useState(1);
  const [badgeMedalHighlight, setBadgeMedalHighlight] = useState(false);
  const badgeOverlayTimeoutRef = useRef(null);
  const badgeUnlockPreviewPendingRef = useRef(readBadgeUnlockPreviewFromUrl());
  const hasRunBadgeUnlockPreviewRef = useRef(false);
  const badgeTierCelebrationStartedRef = useRef(false);
  const isSignedInIdleHomeRef = useRef(false);
  const hasCalledStreakCheckInRef = useRef(false);
  const isHomeStreakVisibleRef = useRef(false);
  const streakOverlayTimeoutRef = useRef(null);
  const streakPreviewPendingRef = useRef(readStreakPreviewFromUrl());
  const badgePreviewCount = useRef(readBadgePreviewCountFromUrl()).current;
  const skipStreakCheckInForPreviewRef = useRef(!!streakPreviewPendingRef.current);
  const hasRunStreakPreviewRef = useRef(false);
  const hasRestoredFilesRef = useRef(false);
  const isRestoringFilesRef = useRef(false);
  const hasTrackedLoginRef = useRef(false);
  const hasTrackedResultVisitRef = useRef(false);
  const hasTrackedCheckoutSuccessPageVisitRef = useRef(false);
  const wasProcessingRef = useRef(false);
  const [uploadLimits, setUploadLimits] = useState({ max_size_mb: 2048, max_duration_minutes: 60 });
  const [whatsAppSupportNumber, setWhatsAppSupportNumber] = useState('2104196594');
  const [showClipFeedbackBubble, setShowClipFeedbackBubble] = useState(false);
  const [clipFeedbackStep, setClipFeedbackStep] = useState('rating'); // 'rating' | 'improvement'
  const [clipFeedbackId, setClipFeedbackId] = useState('');
  const [clipFeedbackTriggerAction, setClipFeedbackTriggerAction] = useState('');
  const [clipFeedbackClipFilename, setClipFeedbackClipFilename] = useState('');
  const [clipFeedbackStars, setClipFeedbackStars] = useState(0);
  const [clipFeedbackText, setClipFeedbackText] = useState('');
  const [submittingClipFeedback, setSubmittingClipFeedback] = useState(false);
  const [clipFeedbackError, setClipFeedbackError] = useState('');
  const clipFeedbackTimerRef = useRef(null);
  const clipFeedbackAutoHideTimerRef = useRef(null);
  const clipFeedbackInteractedRef = useRef(false);

  const resolveBackgroundPreviewSrc = useCallback((bg) => {
    if (!bg || !bg.id) return null;
    if (String(bg.id).startsWith('staging:')) return null;

    const id = String(bg.id);
    const lower = id.toLowerCase();

    if (lower === 'blur_video' || lower === 'auto') return null;

    let publicName = id;
    if (publicName.toLowerCase().endsWith('.mp4')) {
      publicName = publicName.replace(/\.[^.]+$/, '.png');
    }

    const staticPath = `/${publicName}`;
    return staticPath || bg.preview_url || null;
  }, []);

  // Fetch upload limits from backend (master_config upload_limits)
  useEffect(() => {
    fetch('/api/limits')
      .then((res) => res.ok ? res.json() : null)
      .then((data) => {
        if (data && data.upload_limits) {
          setUploadLimits({
            max_size_mb: data.upload_limits.max_size_mb ?? 2048,
            max_duration_minutes: data.upload_limits.max_duration_minutes ?? 60
          });
        }
        if (data?.whatsapp?.support_number) {
          setWhatsAppSupportNumber(String(data.whatsapp.support_number));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetch('/api/background-options')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data || !Array.isArray(data.options)) return;
        const hasAuto = data.options.some((opt) => opt && opt.id === 'auto');
        const normalized = hasAuto ? data.options : [{ id: 'auto', name: 'Auto', type: 'auto' }, ...data.options];
        setBackgroundOptions(normalized);
      })
      .catch(() => {});
  }, []);

  useEffect(() => () => {
    if (stagedBackgroundPreviewUrl && stagedBackgroundPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(stagedBackgroundPreviewUrl);
    }
  }, [stagedBackgroundPreviewUrl]);

  useEffect(() => () => {
    if (clipFeedbackTimerRef.current) {
      clearTimeout(clipFeedbackTimerRef.current);
      clipFeedbackTimerRef.current = null;
    }
    if (clipFeedbackAutoHideTimerRef.current) {
      clearTimeout(clipFeedbackAutoHideTimerRef.current);
      clipFeedbackAutoHideTimerRef.current = null;
    }
  }, []);

  // Warm pricing geo cache on first paint (any route) so /pricing matches sessionStorage immediately.
  useEffect(() => {
    prefetchVisitorCountry().catch(() => {});
  }, []);

  // Capture landing URL for attribution — overwrite each load so we store the
  // URL that led to signup (campaign or direct/organic).
  useEffect(() => {
    try {
      sessionStorage.setItem('referral_source_url', window.location.href);
    } catch (_) {}
  }, []);

  // Clean query param after success screen trigger is read.
  useEffect(() => {
    if (!showSuccessScreen) {
      return undefined;
    }

    window.history.replaceState({}, '', window.location.pathname);
    return undefined;
  }, [showSuccessScreen]);

  // Auto-dismiss success screen after hold + fade-out.
  useEffect(() => {
    if (!showSuccessScreen) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setShowSuccessScreen(false);
    }, 5600);

    return () => clearTimeout(timeoutId);
  }, [showSuccessScreen]);

  // User journey: post-checkout success overlay (/?session=success).
  useEffect(() => {
    if (!showSuccessScreen || hasTrackedCheckoutSuccessPageVisitRef.current) {
      return undefined;
    }
    if (authLoading) {
      return undefined;
    }
    hasTrackedCheckoutSuccessPageVisitRef.current = true;
    const meta = user?.email ? { email: user.email } : {};
    trackCheckoutSuccessPageVisit(meta);
    return undefined;
  }, [showSuccessScreen, authLoading, user?.email]);

  useEffect(() => {
    if (isPremiumUser) return;
    setAiHooks(false);
    setIncludeBroll(false);
  }, [isPremiumUser]);

  useEffect(() => () => {
    if (premiumBadgeJitterTimerRef.current) {
      clearTimeout(premiumBadgeJitterTimerRef.current);
    }
  }, []);

  useEffect(() => {
    if (!showFreeQuotaInfo) return undefined;
    const handlePointerDown = (event) => {
      if (freeQuotaInfoRef.current && !freeQuotaInfoRef.current.contains(event.target)) {
        setShowFreeQuotaInfo(false);
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
    };
  }, [showFreeQuotaInfo]);

  const triggerPremiumBadgeJitter = useCallback((featureKey) => {
    if (isPremiumUser) return;
    setPremiumBadgeJitter(featureKey);
    if (premiumBadgeJitterTimerRef.current) {
      clearTimeout(premiumBadgeJitterTimerRef.current);
    }
    premiumBadgeJitterTimerRef.current = window.setTimeout(() => {
      setPremiumBadgeJitter(null);
      premiumBadgeJitterTimerRef.current = null;
    }, 480);
  }, [isPremiumUser]);

  // Post-checkout premium sync: Firestore user snapshot in useAuth updates plan_tier when webhook writes.

  // Auto-refresh mechanism removed - modern browsers handle GIF looping well

  // Helper function to collect device metadata (simplified - only 6 fields)
  const collectDeviceMetadata = () => {
    // Use require for CommonJS module compatibility
    const UAParser = require('ua-parser-js').UAParser;
    const parser = new UAParser();
    const result = parser.getResult();
    
    // Get device type (default to 'desktop' if not detected)
    const deviceType = result.device.type || 'desktop';
    
    // Get device model
    const deviceModel = result.device.model || 'Unknown';
    
    // Get OS name and version
    const osName = result.os.name || 'Unknown';
    const osVersion = result.os.version || '';
    const deviceOs = osVersion ? `${osName} ${osVersion}` : osName;
    
    // Get browser name and version
    const browserName = result.browser.name || 'Unknown';
    const browserVersion = result.browser.version || '';
    const deviceBrowser = browserVersion ? `${browserName} ${browserVersion}` : browserName;
    
    // Get screen resolution
    const deviceScreenResolution = `${window.screen.width}x${window.screen.height}`;
    
    // Get referrer URL
    const referrerUrl = document.referrer || 'Direct visit / No referrer';
    
    return {
      device_type: deviceType,
      device_model: deviceModel,
      device_os: deviceOs,
      device_browser: deviceBrowser,
      device_screen_resolution: deviceScreenResolution,
      referrer_url: referrerUrl
    };
  };

  // Device detection and referrer tracking - log details to console
  useEffect(() => {
    // Check if this is the first visit in this session
    const isFirstVisit = !sessionStorage.getItem('hasVisited');
    if (isFirstVisit) {
      sessionStorage.setItem('hasVisited', 'true');
      // Track page visit on first load
      trackPageVisit();
    }
    
    // Device metadata is collected but not logged to console in production
    collectDeviceMetadata();
  }, []);

  useEffect(() => {
    const inResultState = processingStatus === 'completed' && resultFiles.length > 0;
    if (inResultState && !hasTrackedResultVisitRef.current) {
      trackResultPageVisit();
      hasTrackedResultVisitRef.current = true;
    }
    if (!inResultState) {
      hasTrackedResultVisitRef.current = false;
    }
  }, [processingStatus, resultFiles.length]);

  useEffect(() => {
    if (processingStatus === 'PROCESSING') {
      if (!wasProcessingRef.current) {
        trackYoutubeStartDuringProcessing();
        wasProcessingRef.current = true;
      }
      return;
    }

    if (wasProcessingRef.current) {
      trackYoutubePauseDuringProcessing();
      wasProcessingRef.current = false;
    }
  }, [processingStatus]);

  // Keep ref in sync for visibility handler (avoids stale closure when checking "do we already have a file?")
  useEffect(() => {
    selectedFileRef.current = selectedFile;
  }, [selectedFile]);

  useEffect(() => {
    return () => {
      if (fileInputPollRef.current) {
        clearInterval(fileInputPollRef.current);
        fileInputPollRef.current = null;
      }
    };
  }, []);

  // Sync displayed time saved with user value when auth changes
  useEffect(() => {
    if (user) {
      // Track user login when user becomes authenticated (only once per session)
      if (user.email && !hasTrackedLoginRef.current) {
        trackUserLogin(user.email);
        hasTrackedLoginRef.current = true;
      }
      
      // Always sync when user object changes, including when time_saved_seconds is 0
      if ('time_saved_seconds' in user) {
        setTimeSavedSecondsDisplay(user.time_saved_seconds || 0);
      } else {
        setTimeSavedSecondsDisplay(0);
      }
      if ('creator_streak_count' in user) {
        const c = Math.max(1, user.creator_streak_count || 1);
        setStreakCountDisplay(c);
      }
    } else {
      // User logged out - reset login tracking flag
      setTimeSavedSecondsDisplay(0);
      setStreakCountDisplay(1);
      hasTrackedLoginRef.current = false;
    }
  }, [user]);

  const getLocalStreakCheckinKey = () => {
    try {
      return `streak_checkin_${new Date().toLocaleDateString('en-CA')}`;
    } catch {
      return `streak_checkin_${new Date().toISOString().slice(0, 10)}`;
    }
  };

  const isHomeStreakVisible =
    isAuthenticated &&
    !selectedFile &&
    !youtubeThumbnail &&
    !(processingStatus === 'completed' && resultFiles.length > 0) &&
    processingStatus !== 'PROCESSING';

  const isSignedInIdleHome = isAuthenticated
    && !(processingStatus === 'completed' && resultFiles.length > 0)
    && !(DEV_FORCE_PROCESSING_VIEW || processingStatus === 'PROCESSING')
    && !selectedFile
    && !youtubeThumbnail;

  useEffect(() => {
    isHomeStreakVisibleRef.current = isHomeStreakVisible;
  }, [isHomeStreakVisible]);

  useEffect(() => {
    isSignedInIdleHomeRef.current = isSignedInIdleHome;
  }, [isSignedInIdleHome]);

  const showStreakCelebrationOverlay = useCallback((from, to, { fast = false, previewVariant } = {}) => {
    if (streakOverlayTimeoutRef.current) {
      clearTimeout(streakOverlayTimeoutRef.current);
      streakOverlayTimeoutRef.current = null;
    }
    const next = Math.max(1, to || 1);
    const fromNum = Number(from);
    const prev = next === 1 && fromNum === 0 ? 0 : Math.max(1, fromNum || 1);
    trackNamedEvent(EVENT_ENUMS.STREAK_OVERLAY_SHOWN, {
      streak_from: prev,
      streak_to: next,
      ...(previewVariant ? { preview_variant: previewVariant } : {}),
    });
    setStreakOverlayFrom(prev);
    setStreakOverlayTo(next);
    setStreakOverlayFast(fast);
    setStreakCardHighlight(false);
    setShowStreakOverlay(true);
    if (streakCardRef.current) {
      const rect = streakCardRef.current.getBoundingClientRect();
      const viewportCenterX = window.innerWidth / 2;
      const viewportCenterY = window.innerHeight / 2;
      const displayW = Math.round(rect.width * STREAK_OVERLAY_DISPLAY_SCALE);
      const displayH = Math.round(rect.height * STREAK_OVERLAY_DISPLAY_SCALE);
      setStreakOverlaySize({ width: displayW, height: displayH });
      setStreakFlyEndScale(rect.width / displayW);
      setStreakFlyCoords({
        x: rect.left + rect.width / 2 - viewportCenterX,
        y: rect.top + rect.height / 2 - viewportCenterY,
      });
    }
    const durationMs = fast ? STREAK_OVERLAY_FAST_DURATION_MS : STREAK_OVERLAY_DURATION_MS;
    streakOverlayTimeoutRef.current = window.setTimeout(() => {
      setShowStreakOverlay(false);
      setStreakOverlayFast(false);
      setStreakCountDisplay(next);
      setStreakCardHighlight(true);
      streakOverlayTimeoutRef.current = null;
      window.setTimeout(() => setStreakCardHighlight(false), 800);
    }, durationMs);
  }, []);

  const showBadgeCelebrationOverlay = useCallback((tier, { fast = false, previewVariant, uid = null, tierIndex = null } = {}) => {
    if (!tier || tier.key === 'none') return;
    if (badgeOverlayTimeoutRef.current) {
      clearTimeout(badgeOverlayTimeoutRef.current);
      badgeOverlayTimeoutRef.current = null;
    }
    const prevCount = Math.max(0, (tier.start || 1) - 1);
    setBadgeOverlayPrevCount(prevCount);
    setBadgeOverlayTier(tier);
    setBadgeOverlayFast(fast);
    setBadgeMedalHighlight(false);
    setShowBadgeOverlay(true);
    if (badgeMedalRef.current) {
      const rect = badgeMedalRef.current.getBoundingClientRect();
      const viewportCenterX = window.innerWidth / 2;
      const viewportCenterY = window.innerHeight / 2;
      const displayW = Math.round(rect.width * BADGE_OVERLAY_DISPLAY_SCALE);
      const displayH = Math.round(displayW * 1.12);
      setBadgeOverlaySize({ width: displayW, height: displayH });
      setBadgeFlyEndScale(rect.width / displayW);
      setBadgeFlyCoords({
        x: rect.left + rect.width / 2 - viewportCenterX,
        y: rect.top + rect.height / 2 - viewportCenterY,
      });
    }
    const durationMs = fast ? BADGE_OVERLAY_FAST_DURATION_MS : BADGE_OVERLAY_DURATION_MS;
    badgeOverlayTimeoutRef.current = window.setTimeout(() => {
      setShowBadgeOverlay(false);
      setBadgeOverlayFast(false);
      setBadgeOverlayTier(null);
      setBadgeMedalHighlight(true);
      badgeOverlayTimeoutRef.current = null;
      badgeTierCelebrationStartedRef.current = false;
      if (uid != null && tierIndex != null) {
        writeStoredBadgeTierIndex(uid, tierIndex);
      }
      window.setTimeout(() => setBadgeMedalHighlight(false), 800);
    }, durationMs);
  }, []);

  // Show badge unlock overlay when user lands on signed-in idle home with a new tier.
  useEffect(() => {
    if (!isSignedInIdleHome || !user?.uid || !userProfileReady) {
      badgeTierCelebrationStartedRef.current = false;
      return undefined;
    }
    if (showBadgeOverlay || badgeTierCelebrationStartedRef.current) return undefined;
    if (badgePreviewCount != null) return undefined;
    if (badgeUnlockPreviewPendingRef.current) return undefined;

    const count = Math.max(0, user.total_videos_uploaded || 0);
    const { tierIndex } = getBadgeProgress(count);

    const stored = readStoredBadgeTierIndex(user.uid);
    if (stored == null) {
      // First home visit: record current tier without celebrating existing progress.
      writeStoredBadgeTierIndex(user.uid, tierIndex);
      return undefined;
    }
    if (tierIndex <= stored) return undefined;

    const tier = BADGE_TIERS[tierIndex];
    if (!tier || tier.key === 'none') return undefined;

    // Mark seen before animation so refresh won't replay while profile is loading.
    writeStoredBadgeTierIndex(user.uid, tierIndex);
    badgeTierCelebrationStartedRef.current = true;
    const uid = user.uid;
    const runCelebration = () => {
      showBadgeCelebrationOverlay(tier, { uid, tierIndex });
    };
    const frameId = window.requestAnimationFrame(() => {
      if (badgeMedalRef.current) {
        runCelebration();
        return;
      }
      window.requestAnimationFrame(runCelebration);
    });
    return () => window.cancelAnimationFrame(frameId);
  }, [
    isSignedInIdleHome,
    user?.uid,
    user?.total_videos_uploaded,
    userProfileReady,
    showBadgeOverlay,
    badgePreviewCount,
    showBadgeCelebrationOverlay,
  ]);

  useEffect(() => {
    if (badgePreviewCount != null) {
      setBadgeCountDisplay(badgePreviewCount);
      return;
    }
    if (user && 'total_videos_uploaded' in user) {
      setBadgeCountDisplay(Math.max(0, user.total_videos_uploaded || 0));
    } else if (!user) {
      setBadgeCountDisplay(0);
    }
  }, [user, badgePreviewCount]);

  useEffect(() => () => {
    if (streakOverlayTimeoutRef.current) {
      clearTimeout(streakOverlayTimeoutRef.current);
    }
    if (badgeOverlayTimeoutRef.current) {
      clearTimeout(badgeOverlayTimeoutRef.current);
    }
  }, []);

  // Strip ?streakPreview / ?streakFast after reading (localhost only).
  useEffect(() => {
    if (!streakPreviewPendingRef.current) return undefined;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('streakPreview') && !params.has('streakFast')) return undefined;
    params.delete('streakPreview');
    params.delete('streakFast');
    const qs = params.toString();
    window.history.replaceState({}, '', qs ? `${window.location.pathname}?${qs}` : window.location.pathname);
    return undefined;
  }, []);

  // Strip ?badgeUnlockPreview / ?badgeFast after reading (localhost only).
  useEffect(() => {
    if (!badgeUnlockPreviewPendingRef.current) return undefined;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('badgeUnlockPreview') && !params.has('badgeFast')) return undefined;
    params.delete('badgeUnlockPreview');
    params.delete('badgeFast');
    const qs = params.toString();
    window.history.replaceState({}, '', qs ? `${window.location.pathname}?${qs}` : window.location.pathname);
    return undefined;
  }, []);

  // Dev preview: animation only — no check-in API (localhost + logged-in home).
  useEffect(() => {
    const pending = streakPreviewPendingRef.current;
    if (!pending || hasRunStreakPreviewRef.current || !isHomeStreakVisible) return undefined;

    const preset = STREAK_PREVIEW_PRESETS[pending.variant];
    if (!preset) return undefined;

    hasRunStreakPreviewRef.current = true;
    streakPreviewPendingRef.current = null;
    hasCalledStreakCheckInRef.current = true;

    const frameId = window.requestAnimationFrame(() => {
      showStreakCelebrationOverlay(preset.from, preset.to, {
        fast: pending.fast,
        previewVariant: pending.variant,
      });
    });
    return () => window.cancelAnimationFrame(frameId);
  }, [isHomeStreakVisible, showStreakCelebrationOverlay]);

  // Dev preview: badge unlock overlay (localhost + signed-in idle home).
  useEffect(() => {
    const pending = badgeUnlockPreviewPendingRef.current;
    if (!pending || hasRunBadgeUnlockPreviewRef.current || !isSignedInIdleHome) return undefined;

    const tier = BADGE_TIERS.find((t) => t.key === pending.tierKey);
    if (!tier) return undefined;

    hasRunBadgeUnlockPreviewRef.current = true;
    badgeUnlockPreviewPendingRef.current = null;

    const frameId = window.requestAnimationFrame(() => {
      showBadgeCelebrationOverlay(tier, {
        fast: pending.fast,
        previewVariant: pending.tierKey,
      });
    });
    return () => window.cancelAnimationFrame(frameId);
  }, [isSignedInIdleHome, showBadgeCelebrationOverlay]);

  useEffect(() => {
    if (!isAuthenticated || !idToken) return;
    if (!isHomeStreakVisible) return;
    if (skipStreakCheckInForPreviewRef.current) return;

    const todayKey = getLocalStreakCheckinKey();
    if (sessionStorage.getItem(todayKey)) return;
    if (hasCalledStreakCheckInRef.current) return;

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    const runCheckIn = async () => {
      try {
        const res = await fetch('/api/creator-streak/check-in', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ timezone }),
        });
        const data = res.ok ? await res.json() : await res.json().catch(() => ({}));
        if (!res.ok) {
          hasCalledStreakCheckInRef.current = false;
          return;
        }
        sessionStorage.setItem(todayKey, '1');
        hasCalledStreakCheckInRef.current = true;
        updateUserStreak(data.streak_count, data.streak_last_date);
        if (data.incremented && isHomeStreakVisibleRef.current) {
          const prevRaw = Number(data.previous_count);
          const next = Math.max(1, data.streak_count || 1);
          const overlayFrom = next === 1 && prevRaw === 0 ? 0 : Math.max(1, prevRaw || 1);
          showStreakCelebrationOverlay(overlayFrom, next);
        } else {
          setStreakCountDisplay(Math.max(1, data.streak_count || 1));
        }
      } catch (e) {
        hasCalledStreakCheckInRef.current = false;
        console.debug('Streak check-in failed:', e);
      }
    };

    runCheckIn();
  }, [isAuthenticated, idToken, isHomeStreakVisible, showStreakCelebrationOverlay]);

  const handleTurnOnStreakReminders = async () => {
    if (!idToken) return { ok: false, error: 'not_authenticated' };
    try {
      trackButtonClick(BUTTON_ENUMS.STREAK_REMINDERS_CTA);
      const result = await enableStreakPushReminders(idToken);
      if (result.ok) {
        updateUserPush({
          reminders_enabled: true,
          push_status: result.push_status || 'granted',
        });
        trackNamedEvent(EVENT_ENUMS.STREAK_REMINDERS_ENABLED);
      } else if (result.permission === 'denied') {
        trackNamedEvent(EVENT_ENUMS.STREAK_REMINDERS_DENIED);
      }
      return result;
    } catch (e) {
      console.debug('Turn on reminders failed:', e);
      return { ok: false, error: String(e?.message || e) };
    }
  };

  const handleAnalyseSocial = async ({ instagramHandle, youtubeHandle }) => {
    const freshToken = await getFreshToken();
    if (!freshToken) {
      throw new Error('Authentication required. Please sign in again.');
    }

    const response = await fetch('/api/user/social-handles', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${freshToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        instagram_handle: instagramHandle || '',
        youtube_handle: youtubeHandle || '',
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to save your handles. Please try again.');
    }
  };

  // Check for ongoing task when user is authenticated
  useEffect(() => {
    const checkOngoingTask = async () => {
      if (!isAuthenticated || !idToken) {
        return; // Don't check if not authenticated
      }
      
      // Don't check if we already have a task and it's completed
      if (processingStatus === 'completed' || processingStatus === 'failed') {
        return;
      }
      
      // Don't check if we're already polling a task
      if (currentTask && processingStatus === 'PROCESSING') {
        return;
      }
      
      try {
        const response = await fetch('/api/user/ongoing-task', {
          headers: {
            'Authorization': `Bearer ${idToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.has_ongoing_task && data.task_id) {
            // User has an ongoing task - show progress screen
            setCurrentTask(data.task_id);
            setProcessingStatus('PROCESSING');
            
            // Start polling for this task (seed with backend progress if available)
            startStatusPolling(data.task_id, data.progress || 0, 6, { restoreElapsed: true });
          }
        }
      } catch (error) {
        // Silently fail - don't show error to user
        console.error('Error checking ongoing task:', error);
      }
    };
    
    // Only check if user is authenticated and not already processing
    if (isAuthenticated && idToken && !processingStatus) {
      checkOngoingTask();
    }
  }, [isAuthenticated, idToken, processingStatus]);

  // Note: User data is pushed to dataLayer in useAuth hook's global listener
  // No need to push here to avoid duplicates

  // Auto-hide pause button after 2 seconds when video starts playing
  useEffect(() => {
    if (playingVideo) {
      // Show pause button initially
      setShowPauseButton(prev => ({ ...prev, [playingVideo]: true }));
      
      // Hide after 2 seconds
      const timer = setTimeout(() => {
        setShowPauseButton(prev => ({ ...prev, [playingVideo]: false }));
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [playingVideo]);

  // Close language dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isLanguageDropdownOpen && !event.target.closest('.language-dropdown-container')) {
        setIsLanguageDropdownOpen(false);
      }
      if (isUserMenuOpen && userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
      if (isMobileMenuOpen && !event.target.closest('.mobile-menu-container')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLanguageDropdownOpen, isUserMenuOpen, isMobileMenuOpen]);

  // Rotating text effect for headline
  useEffect(() => {
    const interval = setInterval(() => {
      setIsRolling(true);
      
      // After animation starts, change the word
      setTimeout(() => {
        setRotatingWord((prev) => (prev + 1) % ROTATING_WORDS.length);
        setIsRolling(false);
      }, 300); // Half of animation duration
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);


  // Clear upload error status when user successfully authenticates
  useEffect(() => {
    if (isAuthenticated && uploadStatus?.type === 'error') {
      const errorMessagesToClear = [
        'Please sign in to upload videos',
        'Please sign in to use YouTube URL',
        'Please sign in to download videos'
      ];
      if (errorMessagesToClear.includes(uploadStatus.message)) {
        setUploadStatus(null);
      }
    }
  }, [isAuthenticated, uploadStatus]);

  // Restore processed files state on login or page refresh
  useEffect(() => {
    try {
      // Reset restoration flag when user logs out
      if (!isAuthenticated || !user?.uid) {
        hasRestoredFilesRef.current = false;
        setResultFiles([]);
        setProcessingStatus(null);
        setTaskRequirePhoneForDownload(null);
        return;
      }

      // Prevent multiple simultaneous calls or if already restored
      if (isRestoringFilesRef.current || hasRestoredFilesRef.current) {
        return;
      }

      // Don't restore if currently processing (check current state)
      if (processingStatus === 'PROCESSING') {
        return;
      }

      // Don't restore if we already have completed files displayed
      if (resultFiles.length > 0 && processingStatus === 'completed') {
        hasRestoredFilesRef.current = true;
        return;
      }

      // Start restoration
      isRestoringFilesRef.current = true;

      const restoreFiles = async () => {
        try {
          if (!fetchUserProcessedFiles || typeof fetchUserProcessedFiles !== 'function') {
            console.error('fetchUserProcessedFiles is not available');
            hasRestoredFilesRef.current = true;
            isRestoringFilesRef.current = false;
            return;
          }

          const processedFiles = await fetchUserProcessedFiles();
          
          if (processedFiles && Array.isArray(processedFiles) && processedFiles.length > 0) {
            // Transform processed files to match expected format
            const transformedClips = processedFiles
              .map(file => {
                try {
                  return {
                    filename: file.filename || 'unknown',
                    file_stem: file.file_stem || '',
                    size: (file.size || 0) * 1024 * 1024, // Convert MB to bytes
                    download_url: file.url || '',
                    isProcessedVideo: file.file_stem ? false : true,
                    viralityScore: Math.floor(Math.random() * 36) + 60
                  };
                } catch (err) {
                  console.error('Error transforming file:', file, err);
                  return null;
                }
              })
              .filter(file => file && file.download_url); // Filter out invalid files and files without URLs
            
            if (transformedClips.length > 0) {
              setResultFiles(transformedClips);
              setProcessingStatus('completed');
              hasRestoredFilesRef.current = true;
            } else {
              hasRestoredFilesRef.current = true; // Mark as attempted even if no files
            }
        } else {
          hasRestoredFilesRef.current = true; // Mark as attempted even if no files
        }
        } catch (error) {
          // Log error but don't break the app
          console.error('Error restoring processed files:', error);
          // Mark as attempted so we don't keep retrying
          hasRestoredFilesRef.current = true;
        } finally {
          isRestoringFilesRef.current = false;
        }
      };

      restoreFiles();
    } catch (error) {
      // Catch any synchronous errors in the effect itself
      console.error('Error in restore processed files effect:', error);
      hasRestoredFilesRef.current = true;
      isRestoringFilesRef.current = false;
    }
  }, [isAuthenticated, user?.uid]);

  // Font template options
  const fontTemplates = [
    {
      id: 'sporty_remotion',
      name: 'Sporty',
      style: 'Remotion',
      description: 'Bold uppercase text with black outline, 3-word window',
      preview: '/Sporty.mp4'
    },
    {
      id: 'premium_remotion',
      name: 'Premium',
      style: 'Remotion',
      description: 'Gradient text, 4-word blocks, pulse on change',
      preview: '/premium.mp4'
    },
    {
      id: 'focus_remotion',
      name: 'Focus',
      style: 'Remotion',
      description: 'Top / hero / bottom layout with spring entrance on center word',
      preview: '/Focus.mp4'
    },
    {
      id: 'food_remotion',
      name: 'Food',
      style: 'Remotion',
      description: 'Warm cream main text + golden highlight with pop-in',
      preview: '/Food.mp4'
    },
    {
      id: 'motivational_remotion',
      name: 'Motivational',
      style: 'Remotion',
      description: '3 words per cue, white neon + colored active word with wavy motion',
      preview: '/Motivational.mp4'
    },
    {
      id: 'green_highlight_remotion',
      name: 'Green Highlight',
      style: 'Remotion',
      description: 'Single line, green word highlight',
      preview: '/green_highlight.mp4'
    },
    {
      id: 'karaoke_remotion',
      name: 'Karaoke',
      style: 'Remotion',
      description: 'Karaoke-style word-by-word highlight (same pipeline as Multi Text)',
      preview: '/karaoke.mp4'
    },
    {
      id: 'one_word_remotion',
      name: 'One Word',
      style: 'Remotion',
      description: 'One word at a time, large and bold',
      preview: '/one_word.mp4'
    },
    {
      id: 'minimal_remotion',
      name: 'Minimal',
      style: 'Remotion',
      description: 'Clean white box with black text, optional red highlight',
      preview: '/minimal.mp4'
    },
    {
      id: 'glow_remotion',
      name: 'Glow',
      style: 'Remotion',
      description: 'Lead-in words + highlighted word with glow effect',
      preview: '/Glow.mp4'
    },
    {
      id: 'subtitle_remotion',
      name: 'Subtitle',
      style: 'Remotion',
      description: 'Netflix-style semi-transparent box, 3-word window, white text',
      preview: '/subtitle.mp4'
    },
    {
      id: 'transparent_text_remotion',
      name: 'Transparent Text',
      style: 'Remotion',
      description: 'Subtitle line in a semi-transparent rounded box',
      preview: '/transparent_text.mp4'
    }
  ];

  // Language options
  const languageOptions = [
    { id: 'auto', name: 'Auto', flag: '🌍', description: 'Auto-detect language' },
    { id: 'en', name: 'English', flag: '🇺🇸', description: 'English' },
    { id: 'hi', name: 'Hindi', flag: '🇮🇳', description: 'हिन्दी' },
    { id: 'hinglish', name: 'Hinglish', flag: '🇮🇳', description: 'Hindi + English' },
    { id: 'es', name: 'Spanish', flag: '🇪🇸', description: 'Español' },
    { id: 'fr', name: 'French', flag: '🇫🇷', description: 'Français' },
    { id: 'de', name: 'German', flag: '🇩🇪', description: 'Deutsch' },
    { id: 'it', name: 'Italian', flag: '🇮🇹', description: 'Italiano' },
    { id: 'pt', name: 'Portuguese', flag: '🇵🇹', description: 'Português' },
    { id: 'nl', name: 'Dutch', flag: '🇳🇱', description: 'Nederlands' },
    { id: 'ru', name: 'Russian', flag: '🇷🇺', description: 'Русский' },
    { id: 'zh', name: 'Chinese', flag: '🇨🇳', description: '中文' },
    { id: 'ja', name: 'Japanese', flag: '🇯🇵', description: '日本語' },
    { id: 'ko', name: 'Korean', flag: '🇰🇷', description: '한국어' }
  ];

  const hookTemplateOptions = [
    { id: 'auto', name: 'Auto', preview: '/auto_preview.png' },
    { id: 'fading_text_trail', name: 'Fading text trail', preview: '/fading_text_trail_preview.png' },
    { id: 'outline_bleed', name: 'Outline bleed', preview: '/outline_bleed_preview.png' },
    { id: 'behind_text', name: 'Behind text', preview: '/behind_text_preview.png' },
    { id: 'windowed_portrait_center', name: 'Windowed (center)', preview: '/windowed_portrait_center_preview.png' },
    { id: 'windowed_portrait_bottom', name: 'Windowed (bottom)', preview: '/windowed_portrait_bottom_preview.png' }
  ];

  // Phone number validation function
  // Format required: +countrycode + at least 10 digits
  // Example: +1234567890 or +1 234567890
  const validatePhoneNumber = (phone) => {
    if (!phone || !phone.trim()) {
      return { isValid: false, message: 'Please enter your phone number' };
    }
    
    // Remove spaces for validation
    const cleanPhone = phone.replace(/\s/g, '');
    
    // Must start with +
    if (!cleanPhone.startsWith('+')) {
      return { 
        isValid: false, 
        message: 'Phone number must start with + followed by country code. Example: +1234567890' 
      };
    }
    
    // After +, must have only digits
    const digitsOnly = cleanPhone.substring(1);
    if (!/^\d+$/.test(digitsOnly)) {
      return { 
        isValid: false, 
        message: 'Phone number must contain only digits after +. Example: +1234567890' 
      };
    }
    
    // Must have at least country code (1-3 digits) + 10 digits = minimum 11 digits total
    // Maximum reasonable length is 15 digits (country code + number)
    if (digitsOnly.length < 11) {
      return { 
        isValid: false, 
        message: 'Phone number is too short. Please include country code and number. Example: +1234567890' 
      };
    }
    
    if (digitsOnly.length > 15) {
      return { 
        isValid: false, 
        message: 'Phone number is too long. Maximum 15 digits after country code.' 
      };
    }
    
    return { isValid: true, message: '' };
  };

  const MAX_DISPLAY_ETA_MINUTES = 9;
  // ETA during processing: duration (minutes) * 2, rounded up, capped for UI. e.g. 0:24 -> 1, 5:28 -> 11, long -> 9 max
  const calculateETA = (durationInSeconds) => {
    const durationInMinutes = durationInSeconds / 60;
    const etaMinutes = Math.ceil(durationInMinutes * 2);
    return Math.min(etaMinutes, MAX_DISPLAY_ETA_MINUTES);
  };

  const stopProgressCreep = useCallback(() => {
    if (progressCreepRef.current) {
      clearInterval(progressCreepRef.current);
      progressCreepRef.current = null;
    }
  }, []);

  const applyConfirmedProgress = useCallback((completedPercent) => {
    const confirmed = roundProcessingProgress(completedPercent);
    if (confirmed > confirmedProgressRef.current) {
      confirmedProgressRef.current = confirmed;
    }
  }, []);

  const startProgressCreep = useCallback(() => {
    stopProgressCreep();
    progressCreepRef.current = setInterval(() => {
      const confirmed = confirmedProgressRef.current;
      const elapsed = Date.now() - progressStartTimeRef.current;
      const current = dummyProgressRef.current;
      const next = computeProcessingProgressStep(
        current,
        confirmed,
        elapsed,
        progressEtaMsRef.current,
      );
      if (next <= current) return;
      dummyProgressRef.current = next;
      setDummyProgress(next);
    }, 150);
  }, [stopProgressCreep]);

  const beginProcessingProgress = useCallback((initialConfirmed = 0, etaMinutes = 6, { restoreElapsed = false } = {}) => {
    stopProgressCreep();
    const confirmed = roundProcessingProgress(initialConfirmed);
    confirmedProgressRef.current = confirmed;
    const etaMs = Math.max(etaMinutes, 1) * 60 * 1000;
    progressEtaMsRef.current = etaMs;
    let elapsed = 0;
    if (restoreElapsed && confirmed > 0) {
      elapsed = (confirmed / PROCESSING_PROGRESS_MAX) * etaMs;
      progressStartTimeRef.current = Date.now() - elapsed;
    } else {
      progressStartTimeRef.current = Date.now();
    }
    const { bufferCap } = getProcessingSegmentBounds(confirmed);
    const timeTarget = Math.min((elapsed / etaMs) * PROCESSING_PROGRESS_MAX, bufferCap);
    const initialVisual = roundProcessingProgress(Math.min(timeTarget, bufferCap));
    dummyProgressRef.current = initialVisual;
    timeSavedBeforeProcessingRef.current = timeSavedSecondsDisplay || user?.time_saved_seconds || 0;
    setDummyProgress(initialVisual);
    startProgressCreep();
  }, [stopProgressCreep, startProgressCreep, timeSavedSecondsDisplay, user?.time_saved_seconds]);

  const resetProcessingProgress = useCallback((value = 0) => {
    stopProgressCreep();
    const rounded = roundProcessingProgress(value);
    confirmedProgressRef.current = rounded;
    dummyProgressRef.current = rounded;
    progressStartTimeRef.current = Date.now();
    progressEtaMsRef.current = 6 * 60 * 1000;
    setDummyProgress(rounded);
  }, [stopProgressCreep]);

  useEffect(() => () => stopProgressCreep(), [stopProgressCreep]);

  useEffect(() => {
    if (!DEV_FORCE_PROCESSING_VIEW) return;
    setEta(6);
    setShowGetNotified(true);
    beginProcessingProgress(0, 6);
    return () => stopProgressCreep();
  }, [beginProcessingProgress, stopProgressCreep]);

  // Function to get video duration
  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
      
      video.src = URL.createObjectURL(file);
    });
  };

  const getResolutionLabel = (height) => {
    if (!height || Number.isNaN(height)) return null;
    if (height >= 2160) return '2160p';
    if (height >= 1440) return '1440p';
    if (height >= 1080) return '1080p';
    if (height >= 720) return '720p';
    if (height >= 480) return '480p';
    return `${Math.round(height)}p`;
  };

  const getVideoResolutionLabel = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        const normalizedHeight = Math.min(video.videoWidth || 0, video.videoHeight || 0);
        const qualityLabel = getResolutionLabel(normalizedHeight);
        window.URL.revokeObjectURL(video.src);
        resolve(qualityLabel);
      };

      video.onerror = () => {
        resolve(null);
      };

      video.src = URL.createObjectURL(file);
    });
  };

  // Function to generate video thumbnail (muted + playsInline for iOS Photo Gallery)
  const generateVideoThumbnail = (file) => {
    return new Promise((resolve) => {
      let resolved = false;
      const doResolve = (url) => {
        if (resolved) return;
        resolved = true;
        resolve(url);
      };
      const video = document.createElement('video');
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';

      const drawFrame = () => {
        if (video.videoWidth && video.videoHeight) {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((blob) => {
            if (blob) {
              doResolve(URL.createObjectURL(blob));
            } else {
              doResolve(null);
            }
          }, 'image/jpeg', 0.8);
        } else {
          doResolve(null);
        }
      };

      video.onseeked = () => {
        video.pause();
        drawFrame();
      };
      video.ontimeupdate = () => {
        // iOS often doesn't fire onseeked for gallery videos; use first timeupdate after seek
        if (video.currentTime > 0) {
          video.ontimeupdate = null;
          video.pause();
          drawFrame();
        }
      };
      video.onloadedmetadata = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        video.currentTime = Math.min(1, video.duration * 0.1);
        video.play().catch(() => {});
      };
      video.onerror = () => doResolve(null);
      video.src = URL.createObjectURL(file);
    });
  };

  // Shared logic: validate file and show preview (used by change handler and by visibility fallback for iOS Photo Gallery)
  const processSelectedFile = useCallback((file) => {
    if (!file) return;
    resetProcessingProgress(0);
    setUploadStatus(null);
    setProcessingStatus(null);
    setTaskRequirePhoneForDownload(null);
    setEta(null);
    setVideoDuration(null);
    setLocalVideoResolution(null);
    const validTypes = ['video/mp4', 'video/x-m4v', 'video/avi', 'video/mov', 'video/wmv', 'video/mkv', 'video/quicktime'];
    const validExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.mkv', '.m4v'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    const hasValidMimeOrExt = validTypes.includes(file.type) || file.type.startsWith('video/') || validExtensions.includes(fileExtension);
    const unknownTypeFromIOS = file.type === '' && file.size > 0;
    if (!hasValidMimeOrExt && !unknownTypeFromIOS) {
      setUploadStatus({ type: 'error', message: 'Please select a valid video file (MP4, AVI, MOV, WMV, MKV)' });
      return;
    }
    const maxSizeMb = uploadLimits.max_size_mb ?? 2048;
    const maxSize = maxSizeMb * 1024 * 1024;
    if (file.size > maxSize) {
      setUploadStatus({ type: 'error', message: 'Frequent users unlock longer videos' });
      return;
    }
    setVideoThumbnail(null);
    setVideoDuration(null);
    setSelectedFile(file);
    setUploadStatus(null);
    trackVideoSelected(file.name);
    const maxDurationMinutes = uploadLimits.max_duration_minutes ?? 60;
    const durationTimeoutMs = 8000;
    Promise.race([
      getVideoDuration(file),
      new Promise((_, reject) => setTimeout(() => reject(new Error('duration_timeout')), durationTimeoutMs))
    ])
      .then((duration) => {
        if (duration > maxDurationMinutes * 60) {
          setUploadStatus({ type: 'error', message: 'Frequent users unlock longer videos' });
          return;
        }
        setVideoDuration(duration);
      })
      .catch(() => {});
    getVideoResolutionLabel(file).then((resolution) => setLocalVideoResolution(resolution)).catch(() => {});
    generateVideoThumbnail(file).then((thumbnail) => setVideoThumbnail(thumbnail)).catch(() => {});
  }, [uploadLimits, resetProcessingProgress]);

  // iOS Photo Gallery: when user returns from the picker (after the "loading" bar), the file input may now have the file but change already ran earlier with no file. Check when page becomes visible and process file if present.
  useEffect(() => {
    const checkInputAfterVisible = () => {
      if (document.visibilityState !== 'visible') return;
      const input = fileInputRef.current;
      if (!input || !input.files || input.files.length === 0) return;
      if (selectedFileRef.current) return; // already showing a file preview
      const file = input.files[0];
      processSelectedFile(file);
      input.value = ''; // so we don't process again on next visibility
    };
    const onVisibilityChange = () => checkInputAfterVisible();
    const onPageShow = (ev) => {
      if (ev.persisted) checkInputAfterVisible(); // Safari back-forward cache
      checkInputAfterVisible();
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pageshow', onPageShow);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('pageshow', onPageShow);
    };
  }, [processSelectedFile]);

  // Start polling the file input when user opens the picker (iOS Photo Library often never fires change with the file, and document may stay "visible" so visibility handler doesn't run).
  const startFileInputPolling = useCallback(() => {
    if (fileInputPollRef.current) {
      clearInterval(fileInputPollRef.current);
      fileInputPollRef.current = null;
    }
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    if (!isIOS) return;
    const deadline = Date.now() + 20000; // 20 seconds
    fileInputPollRef.current = setInterval(() => {
      if (Date.now() > deadline) {
        clearInterval(fileInputPollRef.current);
        fileInputPollRef.current = null;
        return;
      }
      const input = fileInputRef.current;
      if (!input || !input.files || input.files.length === 0) return;
      if (selectedFileRef.current) {
        clearInterval(fileInputPollRef.current);
        fileInputPollRef.current = null;
        return;
      }
      const file = input.files[0];
      processSelectedFile(file);
      input.value = '';
      clearInterval(fileInputPollRef.current);
      fileInputPollRef.current = null;
    }, 500);
  }, [processSelectedFile]);

  // Format duration to MM:SS
  const formatDuration = (seconds) => {
    if (!seconds) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Validate supported video URL (YouTube, Drive, X, Vimeo, etc.)
  const validateYouTubeUrl = validateVideoUrl;

  // Extract YouTube video ID from URL
  const extractYouTubeVideoId = (url) => {
    if (!url) return null;
    
    // Handle different YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    return null;
  };

  // Get YouTube thumbnail URL from video ID
  const getYouTubeThumbnail = (videoId) => {
    if (!videoId) return null;
    // Try maxresdefault first (highest quality), fallback to hqdefault
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  };

  /** Backend returns 403 when subscription/trial is not entitled (legacy premium expiry). */
  const notifyPremiumExpiredRedirectToPricing = () => {
    setUploadStatus({
      type: 'error',
      message: 'Premium plan expired. Redirecting to pricing...'
    });
    window.setTimeout(() => {
      window.location.href = '/pricing';
    }, 500);
  };

  /** Parse upload/process gate errors (daily limit, ongoing task, legacy premium expiry). */
  const applyVideoProcessingGateError = (status, payload) => {
    const data = payload && typeof payload === 'object' ? payload : {};
    if (data.code === 'daily_limit_reached') {
      setUploadStatus({
        type: 'error',
        message:
          data.error
          || `Daily free limit reached (${FREE_DAILY_PROCESSING_LIMIT} videos per UTC day). Upgrade for unlimited processing.`,
      });
      return true;
    }
    if (data.code === 'ongoing_task') {
      setUploadStatus({
        type: 'error',
        message: data.error || 'You already have a video processing. Please wait for it to finish.',
      });
      return true;
    }
    if (status === 403 && String(data.error || '').toLowerCase().includes('premium plan')) {
      notifyPremiumExpiredRedirectToPricing();
      return true;
    }
    if (data.error) {
      setUploadStatus({ type: 'error', message: data.error });
      return true;
    }
    return false;
  };

  // Track the last URL we fetched metadata for to avoid duplicate calls
  const lastFetchedUrlRef = useRef('');
  const lastTrackedUrlRef = useRef('');

  // Fetch thumbnail and metadata when a supported video URL is pasted
  useEffect(() => {
    const currentUrl = youtubeUrl?.trim() || '';
    
    // If URL hasn't changed, don't fetch again
    if (currentUrl === lastFetchedUrlRef.current) {
      return;
    }

    const fetchThumbnailAndMetadata = async () => {
      if (!currentUrl) {
        setYoutubeThumbnail(null);
        setYoutubeMetadata(null);
        setIsFetchingMetadata(false);
        lastFetchedUrlRef.current = '';
        return;
      }

      const validation = validateVideoUrl(currentUrl);
      if (!validation.isValid) {
        setYoutubeThumbnail(null);
        setYoutubeMetadata(null);
        setIsFetchingMetadata(false);
        setYoutubeMetadataError(false);
        setYoutubeMetadataErrorMessage('');
        lastFetchedUrlRef.current = '';
        return;
      }

      lastFetchedUrlRef.current = currentUrl;

      if (currentUrl !== lastTrackedUrlRef.current) {
        trackVideoUrlAdded(currentUrl);
        lastTrackedUrlRef.current = currentUrl;
      }

      const videoId = extractYouTubeVideoId(currentUrl);
      if (videoId) {
        const thumbnailUrl = getYouTubeThumbnail(videoId);
        if (thumbnailUrl) {
          const img = new Image();
          img.onload = () => {
            setYoutubeThumbnail(thumbnailUrl);
          };
          img.onerror = () => {
            setYoutubeThumbnail(`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`);
          };
          img.src = thumbnailUrl;
        }
      } else {
        setYoutubeThumbnail(null);
      }

      setIsFetchingMetadata(true);
      setYoutubeMetadataError(false);
      setYoutubeMetadataErrorMessage('');
      try {
        const freshToken = await getFreshToken();
        if (freshToken) {
          const response = await fetch('/api/youtube-metadata', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${freshToken}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              youtube_url: currentUrl,
              video_url: currentUrl
            })
          });

          if (response.ok) {
            const result = await response.json();
            if (result.metadata) {
              setYoutubeMetadata(result.metadata);
              setYoutubeMetadataError(false);
              setYoutubeMetadataErrorMessage('');
              if (!videoId && result.metadata.thumbnail) {
                setYoutubeThumbnail(result.metadata.thumbnail);
              }
            } else {
              setYoutubeMetadata(null);
              setYoutubeMetadataError(true);
              setYoutubeMetadataErrorMessage('');
            }
          } else {
            const data = await response.json().catch(() => ({}));
            const msg = data.error || 'Failed to get video metadata';
            setYoutubeMetadata(null);
            setYoutubeMetadataError(true);
            setYoutubeMetadataErrorMessage(msg);
            if (data.error_code === 'VIDEO_TOO_LONG') trackVideoTooLong();
            else if (data.error_code === 'VIDEO_TOO_LARGE') trackVideoTooLarge();
          }
        } else {
          setYoutubeMetadata(null);
          setYoutubeMetadataError(false);
          setYoutubeMetadataErrorMessage('');
        }
      } catch (error) {
        console.error('Error fetching video metadata:', error);
        setYoutubeMetadata(null);
        setYoutubeMetadataError(true);
        setYoutubeMetadataErrorMessage('Failed to get video metadata.');
      } finally {
        setIsFetchingMetadata(false);
      }
    };

    const timeoutId = setTimeout(fetchThumbnailAndMetadata, 500);
    return () => clearTimeout(timeoutId);
  }, [youtubeUrl]); // Removed getFreshToken from dependencies

  // Check if YouTube URL feature is enabled
  useEffect(() => {
    const checkYoutubeUrlEnabled = async () => {
      try {
        const response = await fetch('/api/features/youtube-url-enabled');
        if (response.ok) {
          const data = await response.json();
          setYoutubeUrlEnabled(data.enabled !== false);
        }
      } catch (err) {
        console.error('Error checking YouTube URL toggle:', err);
        // Default to enabled if check fails
        setYoutubeUrlEnabled(true);
      }
    };
    checkYoutubeUrlEnabled();
  }, []);

  const fetchPhoneDownloadRequirement = useCallback(async () => {
    try {
      const response = await fetch('/api/features/phone-download-required', {
        cache: 'no-store',
      });
      if (response.ok) {
        const data = await response.json();
        return data.enabled !== false;
      }
    } catch (err) {
      console.error('Error checking phone download toggle:', err);
    }
    // Default to enabled if check fails
    return true;
  }, []);

  // Check if phone number is required before download
  useEffect(() => {
    const checkPhoneDownloadRequired = async () => {
      const enabled = await fetchPhoneDownloadRequirement();
      setRequirePhoneForDownload(enabled);
    };
    checkPhoneDownloadRequired();
  }, [fetchPhoneDownloadRequirement]);

  // Default Add B-roll checkbox state from admin config
  useEffect(() => {
    const loadIncludeBrollDefault = async () => {
      try {
        const response = await fetch('/api/features/include-broll-default', {
          cache: 'no-store',
        });
        if (response.ok) {
          const data = await response.json();
          setIncludeBroll(data.enabled !== false);
        }
      } catch (err) {
        console.error('Error checking B-roll default toggle:', err);
      }
    };
    loadIncludeBrollDefault();
  }, []);

  // Clear YouTube URL and related state when user logs out
  useEffect(() => {
    if (!isAuthenticated) {
      setYoutubeUrl('');
      setYoutubeThumbnail(null);
      setYoutubeMetadata(null);
      setIsFetchingMetadata(false);
      setYoutubeUrlError('');
      setYoutubeMetadataError(false);
      setYoutubeMetadataErrorMessage('');
      lastFetchedUrlRef.current = '';
      lastTrackedUrlRef.current = '';
      setUserPhoneNumber(null);
      setShowGetNotified(false);
    }
  }, [isAuthenticated]);

  // Phone number from Firestore user profile snapshot (useAuth).
  useEffect(() => {
    if (!isAuthenticated) {
      setUserPhoneNumber(null);
      return;
    }
    setUserPhoneNumber(user?.phone_number || null);
  }, [isAuthenticated, user?.phone_number]);

  // Show "get notified" message 5 seconds after processing starts (if no phone)
  useEffect(() => {
    if (processingStatus === 'PROCESSING' && !userPhoneNumber) {
      const timer = setTimeout(() => {
        setShowGetNotified(true);
      }, 5000); // 5 seconds
      return () => clearTimeout(timer);
    } else {
      setShowGetNotified(false);
    }
  }, [processingStatus, userPhoneNumber]);

  // Format time saved (seconds) into human readable string
  const formatTimeSaved = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return '0s';
    const seconds = Math.floor(totalSeconds);
    let mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const hours = Math.floor(mins / 60);
    mins = mins % 60;
    const parts = [];
    if (hours) parts.push(`${hours}h`);
    if (mins) parts.push(`${mins}m`);
    if (secs || parts.length === 0) parts.push(`${secs}s`);
    return parts.join(' ');
  };

  const animateTimeSavedIncrement = (startSeconds, newSeconds) => {
    const durationMs = 1200;
    const startTime = performance.now();

    const step = (now) => {
      const t = Math.min((now - startTime) / durationMs, 1);
      const current = Math.round(startSeconds + (newSeconds - startSeconds) * t);
      setTimeSavedSecondsDisplay(current);
      if (t < 1) {
        requestAnimationFrame(step);
      }
      // Note: User object is updated before animation starts, so value persists
    };

    requestAnimationFrame(step);
  };

  const handleJoinBeta = async (e) => {
    e.preventDefault();
    
    // Validate phone number
    const phoneValidation = validatePhoneNumber(phoneNumber);
    if (!phoneValidation.isValid) {
      setUploadStatus({
        type: 'error',
        message: phoneValidation.message
      });
      return;
    }
    
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      alert('Thank you for joining our beta! We\'ll be in touch soon.');
      setPhoneNumber('');
    }, 1000);
  };

  const beginProcessingUi = async (taskId, successMessage = 'Processing started! We\'ll notify you when your shorts are ready.') => {
    const taskPhoneRequirement = await fetchPhoneDownloadRequirement();
    setRequirePhoneForDownload(taskPhoneRequirement);
    setTaskRequirePhoneForDownload(taskPhoneRequirement);
    setUploadStatus({
      type: 'success',
      message: successMessage,
    });
    setCurrentTask(taskId);
    setProcessingStatus('PROCESSING');
    setShowPhoneInput(false);
    setPhoneNumber('');
    const durationSec = videoDuration ?? youtubeMetadata?.duration_seconds ?? null;
    const etaMins = durationSec != null ? calculateETA(durationSec) : 6;
    setEta(etaMins);
    startStatusPolling(taskId, 0, etaMins);
  };

  // Function to start processing (can be called after upload or with phone number)
  const startProcessing = async (phoneNum = null) => {
    try {
      // Get fresh token to ensure it's valid
      const freshToken = await getFreshToken();
      
      if (!freshToken) {
        setUploadStatus({
          type: 'error',
          message: 'Authentication required. Please sign in again.'
        });
        return;
      }

      const headers = {
        'Content-Type': 'application/json',
      };
      
      headers['Authorization'] = `Bearer ${freshToken}`;
      
      // Use provided phone number or empty string
      const phoneToSend = phoneNum || '';

      // Snapshot the phone-download requirement for this processing task.
      const taskPhoneRequirement = await fetchPhoneDownloadRequirement();
      
      // Validate phone number format if provided
      if (phoneToSend) {
        const phoneValidation = validatePhoneNumber(phoneToSend);
        if (!phoneValidation.isValid) {
          setUploadStatus({
            type: 'error',
            message: phoneValidation.message
          });
          return;
        }
      }
      
      const response = await fetch('/api/start-processing', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ phone_number: phoneToSend }),
      });
      
      if (response.ok) {
        const result = await response.json();
        await beginProcessingUi(result.task_id);
      } else if (response.status === 403 || response.status === 409) {
        const errorData = await response.json().catch(() => ({}));
        if (errorData.code === 'ongoing_task' && uploadedVideo?.task_id) {
          await beginProcessingUi(uploadedVideo.task_id);
          return;
        }
        if (!applyVideoProcessingGateError(response.status, errorData)) {
          notifyPremiumExpiredRedirectToPricing();
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.error || errorData.message || 'Failed to start processing. Please try again.';
        
        // Check if error is about phone number being required
        const errorLower = errorMessage.toLowerCase();
        if (response.status === 400 && (
          errorLower.includes('phone number is required') || 
          errorLower.includes('phone_number') ||
          errorLower.includes('phone number')
        )) {
          // Show phone input popup
          setShowPhoneInput(true);
          setUploadStatus(null); // Clear any status messages
        } else {
          setUploadStatus({
            type: 'error',
            message: errorMessage
          });
        }
      }
    } catch (error) {
      setUploadStatus({
        type: 'error',
        message: 'Network error. Please check your connection and try again.'
      });
    }
  };

  const handleGetShorts = async (e) => {
    e.preventDefault();
    
    // Validate phone number
    const phoneValidation = validatePhoneNumber(phoneNumber);
    if (!phoneValidation.isValid) {
      setUploadStatus({
        type: 'error',
        message: phoneValidation.message
      });
      return;
    }
    
    if (!uploadedVideo) {
      setUploadStatus({
        type: 'error',
        message: 'No video uploaded'
      });
      return;
    }
    
    try {
      // Start processing with phone number
      await startProcessing(phoneNumber);
    } catch (error) {
      setUploadStatus({
        type: 'error',
        message: 'Network error. Please check your connection and try again.'
      });
    }
  };

  const handleGenerateShortsClick = () => {
    trackButtonClick(BUTTON_ENUMS.GENERATE_SHORTS_BUTTON);
    if (processingStatus === 'PROCESSING') {
      setUploadStatus({
        type: 'error',
        message: 'You already have a video processing. Please wait for it to finish.',
      });
      return;
    }
    if (isFreeDailyLimitReached) {
      setUploadStatus({
        type: 'error',
        message: `Daily free limit reached (${FREE_DAILY_PROCESSING_LIMIT} videos per UTC day). Upgrade for unlimited processing.`,
      });
      return;
    }
    if (selectedFile) {
      handleVideoUpload();
      return;
    }
    handleYouTubeDownload();
  };

  // Handler to update phone number only (without starting processing)
  const handleUpdatePhoneNumber = async () => {
    const phoneValidation = validatePhoneNumber(phoneNumber);
    if (!phoneValidation.isValid) {
      setPhoneNumberError(phoneValidation.message);
      return;
    }
    
    // Clear error if validation passes
    setPhoneNumberError('');

    setIsLoading(true);
    try {
      const freshToken = await getFreshToken();
      if (!freshToken) {
        setUploadStatus({
          type: 'error',
          message: 'Authentication required. Please sign in again.'
        });
        setIsLoading(false);
        return;
      }

      const response = await fetch('/api/user/update-phone', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${freshToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ phone_number: phoneNumber })
      });

      if (response.ok) {
        const result = await response.json();
        setUserPhoneNumber(phoneNumber);
        setPhoneNumber('');
        setPhoneNumberError('');
        setShowPhonePopup(false);
        setShowGetNotified(false); // Hide get notified message since phone is now added
        
        // Track phone number submission based on mode
        if (phonePopupMode === 'notify') {
          trackProvidedPhoneDuringProcessing(phoneNumber);
        } else if (phonePopupMode === 'download') {
          trackProvidedPhoneDuringDownload(phoneNumber);
        }
        
        // If this was triggered from download, retry the download
        if (phonePopupMode === 'download') {
          setPhonePopupMode(null);
          // Small delay then retry download
          setTimeout(() => {
            handleYouTubeDownload();
          }, 500);
        }
        
        setUploadStatus({
          type: 'success',
          message: 'Phone number updated successfully!'
        });
      } else {
        const errorData = await response.json();
        setUploadStatus({
          type: 'error',
          message: errorData.error || 'Failed to update phone number'
        });
      }
    } catch (error) {
      setUploadStatus({
        type: 'error',
        message: 'Network error. Please check your connection and try again.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCustomBackgroundFile = async (e) => {
    const input = e.target;
    const file = input.files && input.files[0];
    if (input) {
      input.value = '';
    }
    if (!file) return;
    const nextPreviewUrl = URL.createObjectURL(file);
    if (stagedBackgroundPreviewUrl && stagedBackgroundPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(stagedBackgroundPreviewUrl);
    }
    setStagedBackgroundPreviewUrl(nextPreviewUrl);
    setStagedBackgroundPreviewType(file.type || '');

    if (!isAuthenticated) {
      await triggerGoogleOneTap();
      setUploadStatus({
        type: 'error',
        message: 'Please sign in to upload a background'
      });
      setLoginMode('signup');
      setIsSignupModalOpen(true);
      return;
    }

    setCustomBackgroundError('');
    setIsStagingBackground(true);
    try {
      const token = await getFreshToken();
      if (!token) {
        setCustomBackgroundError('Please sign in again.');
        return;
      }
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch('/api/stage-custom-background', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: fd
      });
      let data = {};
      try {
        data = await res.json();
      } catch (_) {
        data = {};
      }
      if (!res.ok) {
        setCustomBackgroundError(data.error || data.details || 'Could not upload background');
        return;
      }
      const bgVal = data.background;
      if (!bgVal) {
        setCustomBackgroundError('Invalid server response');
        return;
      }
      setSelectedBackground(bgVal);
      setBackgroundOptions((prev) => {
        const rest = (prev || []).filter((o) => o && !String(o.id).startsWith('staging:'));
        return [...rest, { id: bgVal, name: data.display_name || 'Your upload', type: data.type || 'custom' }];
      });
    } catch (err) {
      setCustomBackgroundError(err?.message || 'Upload failed');
    } finally {
      setIsStagingBackground(false);
    }
  };

  const handleFileSelect = (e) => {
    const input = e.target;
    const file = input.files && input.files[0];
    if (file) {
      if (fileInputPollRef.current) {
        clearInterval(fileInputPollRef.current);
        fileInputPollRef.current = null;
      }
      processSelectedFile(file);
      return;
    }
    // iOS Photo Gallery: change sometimes fires with no file; polling is started when user opens picker (startFileInputPolling).
    setUploadStatus(null);
  };

  const handleVideoUpload = async () => {
    resetProcessingProgress(0);
    
    // Check if user is authenticated
    if (!isAuthenticated) {
      await triggerGoogleOneTap();
      setUploadStatus({
        type: 'error',
        message: 'Please sign in to upload videos'
      });
      setLoginMode('signup');
      setIsSignupModalOpen(true);
      return;
    }
    
    if (!selectedFile) {
      setUploadStatus({
        type: 'error',
        message: 'Please select a video file first'
      });
      return;
    }
    
    setIsUploading(true);
    setUploadProgress(0);
    setUploadStatus(null);
    
    // Collect device metadata when user initiates upload
    const deviceMetadata = collectDeviceMetadata();
    
    const formData = new FormData();
    formData.append('video', selectedFile);
    formData.append('subtitle_template', selectedFontTemplate);
    // Always auto-detect on backend; dropdown is UI-only
    formData.append('language', 'auto');
    formData.append('trim_silence', trimSilence ? 'yes' : 'no');
    formData.append('include_broll', includeBroll ? 'yes' : 'no');
    formData.append('add_captions', addCaptions ? 'yes' : 'no');
    formData.append('ai_hooks', aiHooks ? 'yes' : 'no');
    formData.append('background', selectedBackground || 'auto');
    formData.append('hook_template', selectedHookTemplate || 'auto');
    formData.append('metadata', JSON.stringify(deviceMetadata));
    
    try {
      const xhr = new XMLHttpRequest();
      
      // Track upload progress
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const progress = Math.round((e.loaded / e.total) * 100);
          setUploadProgress(progress);
        }
      });
      
      // Handle response
      xhr.addEventListener('load', async () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          setUploadedVideo({
            task_id: response.task_id,
            filename: response.filename,
            file: selectedFile
          });
          setSelectedFile(null);
          setLocalVideoResolution(null);
          setUploadProgress(0);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          
          // Upload already queues processing on the backend — show processing UI immediately.
          await beginProcessingUi(
            response.task_id,
            'Video uploaded successfully! Processing will start shortly.',
          );
        } else if (xhr.status === 403 || xhr.status === 409) {
          try {
            const data = JSON.parse(xhr.responseText || '{}');
            if (!applyVideoProcessingGateError(xhr.status, data)) {
              setUploadStatus({
                type: 'error',
                message: 'Upload failed. Please try again.',
              });
            }
          } catch {
            notifyPremiumExpiredRedirectToPricing();
          }
        } else {
          setUploadStatus({
            type: 'error',
            message: 'Upload failed. Please try again.'
          });
        }
        setIsUploading(false);
      });
      
      // Handle errors
      xhr.addEventListener('error', () => {
        setUploadStatus({
          type: 'error',
          message: 'Upload failed. Please check your connection and try again.'
        });
        setIsUploading(false);
      });
      
      // Send request with authentication token
      xhr.open('POST', '/upload', true);
      
      // Add authorization header if user is authenticated
      if (idToken) {
        xhr.setRequestHeader('Authorization', `Bearer ${idToken}`);
      }
      
      xhr.send(formData);
      
    } catch (error) {
      setUploadStatus({
        type: 'error',
        message: 'Upload failed. Please try again.'
      });
      setIsUploading(false);
    }
  };

  const removeSelectedFile = () => {
    // Clean up thumbnail URL
    if (videoThumbnail) {
      URL.revokeObjectURL(videoThumbnail);
    }
    setSelectedFile(null);
    setVideoThumbnail(null);
    setVideoDuration(null);
    setLocalVideoResolution(null);
    setUploadStatus(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const clearYouTubeUrl = () => {
    setYoutubeUrl('');
    setYoutubeUrlError('');
    setYoutubeThumbnail(null);
    setYoutubeMetadata(null);
    setIsFetchingMetadata(false);
    setUploadStatus(null);
  };

  const clearPreview = () => {
    // Track back button click
    trackButtonClick(BUTTON_ENUMS.BACK);
    setCustomBackgroundError('');
    
    if (selectedFile) {
      removeSelectedFile();
    } else if (youtubeThumbnail) {
      clearYouTubeUrl();
    }
  };

  const handleYouTubeDownload = async () => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      await triggerGoogleOneTap();
      setUploadStatus({
        type: 'error',
        message: 'Please sign in to download videos'
      });
      setLoginMode('signup');
      setIsSignupModalOpen(true);
      return;
    }
    
    if (!youtubeUrl || !youtubeUrl.trim()) {
      setUploadStatus({
        type: 'error',
        message: 'Please enter a video URL'
      });
      return;
    }
    
    const validation = validateVideoUrl(youtubeUrl);
    if (!validation.isValid) {
      setYoutubeUrlError(validation.error);
      setUploadStatus({
        type: 'error',
        message: validation.error || 'Please enter a supported video URL'
      });
      return;
    }
    
    setIsDownloading(true);
    setDownloadProgress(0);
    setUploadStatus(null);
    
    // Start animated progress bar based on video duration
    const progressIntervalRef = { current: null };
    const startDownloadProgress = () => {
      setDownloadProgress(0);
      const startTime = Date.now();
      
      // Always use 60 seconds (1 minute) for the animation - moves from 0-99%
      const duration = 60000; // 1 minute in milliseconds
      
      const updateProgress = () => {
        const elapsed = Date.now() - startTime;
        // Move from 0-99% over 1 minute
        const progress = Math.min((elapsed / duration) * 99, 99);
        setDownloadProgress(progress);
        
        if (progress < 99) {
          progressIntervalRef.current = setTimeout(updateProgress, 100);
        }
      };
      
      updateProgress();
    };
    
    startDownloadProgress();
    
    try {
      const freshToken = await getFreshToken();
      if (!freshToken) {
        setUploadStatus({
          type: 'error',
          message: 'Authentication required. Please sign in again.'
        });
        if (progressIntervalRef.current) {
          clearTimeout(progressIntervalRef.current);
        }
        setIsDownloading(false);
        setDownloadProgress(0);
        return;
      }
      
      // Collect device metadata
      const deviceMetadata = collectDeviceMetadata();
      
      const response = await fetch('/api/download-youtube', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${freshToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          youtube_url: youtubeUrl.trim(),
          video_url: youtubeUrl.trim(),
          subtitle_template: selectedFontTemplate,
          language: 'auto', // always auto; language dropdown is UI-only
          trim_silence: trimSilence,
          include_broll: includeBroll,
          add_captions: addCaptions,
          ai_hooks: aiHooks,
          background: selectedBackground || 'auto',
          hook_template: selectedHookTemplate || 'auto',
          metadata: deviceMetadata
        })
      });
      
      // Check if we got a task_id in the response (even if download is still in progress)
      // This allows us to set currentTask immediately so reloads work
      if (response.ok) {
        try {
          const result = await response.json();
          const durationSec = youtubeMetadata?.duration_seconds ?? null;
          const etaMins = durationSec != null ? calculateETA(durationSec) : 6;
          
          // If we have a task_id, set it immediately (task is created before download)
          if (result.task_id) {
            setCurrentTask(result.task_id);
            // Start polling immediately so user can reload and still see progress
            startStatusPolling(result.task_id, result.completed_percent || 0, etaMins);
          }
          
          // Clear progress interval
          if (progressIntervalRef.current) {
            clearTimeout(progressIntervalRef.current);
          }
          
          // Complete the progress bar
          setDownloadProgress(100);
          
          // Set uploaded video info
          setUploadedVideo({
            task_id: result.task_id,
            filename: result.filename,
            file: null // No file object for YouTube downloads
          });
          
          // Check lifecycle state - could be UPLOADED (download in progress) or PROCESSING (processing started)
          if (result.lifecycle_state === 'PROCESSING') {
            // Processing started automatically by backend
            setProcessingStatus('PROCESSING');
            setEta(etaMins);
            setUploadStatus({
              type: 'success',
              message: 'Video downloaded and processing started!'
            });
          } else if (result.lifecycle_state === 'UPLOADED') {
            // Download is in progress, processing will start automatically
            setProcessingStatus('PROCESSING'); // Show processing screen while download happens
            setEta(etaMins);
            setUploadStatus({
              type: 'success',
              message: 'Downloading video... Processing will start automatically.'
            });
          } else {
            // Fallback for other states
            setUploadStatus({
              type: 'success',
              message: 'Video downloaded successfully! Processing will start shortly...'
            });
          }
          
          setYoutubeUrl('');
          setYoutubeThumbnail(null);
          setYoutubeMetadata(null);
          setIsFetchingMetadata(false);
          setInputMode('upload'); // Reset to upload mode
          
          // Small delay to show 100% completion
          setTimeout(() => {
            setIsDownloading(false);
            setDownloadProgress(0);
          }, 500);
        } catch (jsonError) {
          console.error('Error parsing response:', jsonError);
          setUploadStatus({
            type: 'error',
            message: 'Download completed but received invalid response. Processing may have started.'
          });
          setIsDownloading(false);
          setDownloadProgress(0);
        }
      } else {
        if (progressIntervalRef.current) {
          clearTimeout(progressIntervalRef.current);
        }
        setIsDownloading(false);
        setDownloadProgress(0);
        if (response.status === 403 || response.status === 409) {
          const errorData = await response.json().catch(() => ({}));
          if (!applyVideoProcessingGateError(response.status, errorData)) {
            notifyPremiumExpiredRedirectToPricing();
          }
          return;
        }
        const errorData = await response.json().catch(() => ({}));
        const downloadErrorMsg = errorData.error || errorData.details || 'Download failed. Please try again.';
        setUploadStatus({
          type: 'error',
          message: downloadErrorMsg
        });
        setIsDownloading(false);
        setDownloadProgress(0);
      }
    } catch (error) {
      if (progressIntervalRef.current) {
        clearTimeout(progressIntervalRef.current);
      }
      console.error('YouTube download error:', error);
      const errorMessage = error.message || 'Download failed. Please check your connection and try again.';
      setUploadStatus({
        type: 'error',
        message: errorMessage
      });
      setIsDownloading(false);
      setDownloadProgress(0);
    }
  };

  const startStatusPolling = (taskId, initialConfirmedPercent = 0, etaMinutes = 6, { restoreElapsed = false } = {}) => {
    beginProcessingProgress(initialConfirmedPercent, etaMinutes, { restoreElapsed });

    const pollInterval = setInterval(async () => {
      try {
        const headers = {};
        if (idToken) {
          headers['Authorization'] = `Bearer ${idToken}`;
        }
        
        const response = await fetch(`/task/${taskId}`, {
          headers: headers
        });
        const data = await response.json();
        
        if (response.ok) {
          // Use lifecycle_state (UPLOADED, PROCESSING, SUCCESS, FAILED)
          const lifecycleState = data.lifecycle_state || 'UNKNOWN';
          const completedPercent = data.completed_percent || 0;
          
          if (lifecycleState === 'PROCESSING') {
            setProcessingStatus('PROCESSING');
            setEta(prev => prev ?? 6); // Keep ETA if already set (from duration), else 6 mins
            applyConfirmedProgress(completedPercent);
          } else if (lifecycleState === 'SUCCESS') {
            // If backend sent updated time saved, show overlay and animate the dial value
            if (data.time_saved_seconds != null) {
              const newSeconds = data.time_saved_seconds;
              const startSeconds = timeSavedBeforeProcessingRef.current;
              const delta = newSeconds - startSeconds;

              if (delta > 0) {
                setTimeSavedDelta(delta);
                
                // Calculate target position (center of time-saved widget in header)
                setTimeout(() => {
                  if (timeSavedWidgetRef.current) {
                    const rect = timeSavedWidgetRef.current.getBoundingClientRect();
                    const centerX = rect.left + rect.width / 2;
                    const centerY = rect.top + rect.height / 2;
                    // Calculate relative to viewport center (where overlay starts)
                    const viewportCenterX = window.innerWidth / 2;
                    const viewportCenterY = window.innerHeight / 2;
                    setOverlayTargetCoords({
                      x: centerX - viewportCenterX,
                      y: centerY - viewportCenterY
                    });
                  }
                  setShowTimeSavedOverlay(true);
                }, 50);

                // Let the overlay animation + confetti play, then update the dial
                const overlayDuration = 5000;
                setTimeout(() => {
                  // Update user object first so it persists
                  updateUserTimeSaved(newSeconds);
                  // Then animate the display
                  animateTimeSavedIncrement(startSeconds, newSeconds);
                  setShowTimeSavedOverlay(false);
                  // Highlight the widget briefly
                  setHighlightTimeSaved(true);
                  setTimeout(() => setHighlightTimeSaved(false), 800);
                }, overlayDuration);
              } else {
                // Update user object first so it persists
                updateUserTimeSaved(newSeconds);
                // Then animate the display
                animateTimeSavedIncrement(startSeconds, newSeconds);
              }
            }

            // When status is SUCCESS, fetch the processed files from the output endpoint
            try {
              const freshToken = await getFreshToken();
              if (freshToken && user?.uid) {
                const outputResponse = await fetch(`/api/output/${user.uid}`, {
                  headers: {
                    'Authorization': `Bearer ${freshToken}`,
                    'Content-Type': 'application/json'
                  }
                });
                
                if (outputResponse.ok) {
                  const outputData = await outputResponse.json();
                  const processedFiles = outputData.processed_files || [];
                  
                  // Transform processed files to match expected format
                  const transformedClips = processedFiles.map(file => ({
                    filename: file.filename,
                    file_stem: file.file_stem || '',
                    size: file.size * 1024 * 1024, // Convert MB to bytes
                    download_url: file.url,
                    isProcessedVideo: file.file_stem ? false : true, // Heuristic: if no file_stem, might be processed video
                    viralityScore: Math.floor(Math.random() * 36) + 60 // Random virality score between 60-95
                  }));
                  
                  setResultFiles(transformedClips);
                }
              }
            } catch (fetchError) {
              // Error fetching processed files - silently fail
            }
            
            // Clear progress creep animation
            stopProgressCreep();
            
            setProcessingStatus('completed');
            confirmedProgressRef.current = 100;
            dummyProgressRef.current = 100;
            setDummyProgress(100);
            setUploadStatus(null); // Clear the "Processing started" message
            clearInterval(pollInterval);
          } else if (lifecycleState === 'FAILED') {
            stopProgressCreep();
            
            // Check for specific error types to show helpful messages
            const errorMessage = data.message || data.error || '';
            let userMessage = 'Processing failed. Please try again.';
            
            // No spoken audio / transcription error: show message from server (defined in backend automationtool/src/utils/error_messages.py)
            if (errorMessage.includes('No spoken audio detected') ||
                errorMessage.includes('Try uploading a video where someone is talking') ||
                errorMessage.includes('TRANSCRIPTION_EMPTY') ||
                errorMessage.includes('No transcription segments') ||
                errorMessage.includes('No valid text found')) {
              userMessage = errorMessage;
            }
            
            setUploadStatus({
              type: 'error',
              message: userMessage
            });
            setProcessingStatus('failed');
            clearInterval(pollInterval);
          }
        }
      } catch (error) {
        // Status polling error - silently fail
      }
    }, 5000); // Poll every 5 seconds
    
    // Clear interval after 1 hour to prevent infinite polling
    setTimeout(() => {
      clearInterval(pollInterval);
    }, 3600000);
  };

  // Function to fetch all processed files for the current user
  const fetchUserProcessedFiles = async () => {
    if (!user?.uid) {
      return [];
    }

    try {
      const freshToken = await getFreshToken();
      if (!freshToken) {
        return [];
      }

      const response = await fetch(`/api/output/${user.uid}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${freshToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch processed files: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data.processed_files || [];
    } catch (error) {
      return [];
    }
  };

  const scheduleClipFeedbackPrompt = (triggerAction, clipFilename = '') => {
    if (processingStatus !== 'completed' || resultFiles.length === 0) {
      return;
    }
    if (!currentTask || submittingClipFeedback) {
      return;
    }
    if (clipFeedbackTimerRef.current) {
      clearTimeout(clipFeedbackTimerRef.current);
      clipFeedbackTimerRef.current = null;
    }
    clipFeedbackTimerRef.current = setTimeout(() => {
      const nextFeedbackId =
        (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : `fb_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      setClipFeedbackId(nextFeedbackId);
      setClipFeedbackStep('rating');
      setClipFeedbackTriggerAction(triggerAction || '');
      setClipFeedbackClipFilename(clipFilename || '');
      setClipFeedbackStars(0);
      setClipFeedbackText('');
      setClipFeedbackError('');
      clipFeedbackInteractedRef.current = false;
      setShowClipFeedbackBubble(true);
      clipFeedbackTimerRef.current = null;
    }, 2000);
  };

  const persistClipFeedback = async ({ stars, improvementText, stage }) => {
    const freshToken = await getFreshToken();
    if (!freshToken) {
      throw new Error('Please sign in again to submit feedback.');
    }
    const response = await fetch('/api/clip-feedback', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${freshToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        feedback_id: clipFeedbackId || null,
        task_id: currentTask,
        email: user?.email || null,
        stars,
        improvement_text: improvementText,
        trigger_action: clipFeedbackTriggerAction || null,
        clip_filename: clipFeedbackClipFilename || null,
        feedback_stage: stage,
        timestamp: new Date().toISOString(),
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.error || 'Failed to submit feedback');
    }
  };

  const handleClipFeedbackStarClick = async (star) => {
    if (submittingClipFeedback) {
      return;
    }
    if (!currentTask) {
      setClipFeedbackError('Task not found. Please try again.');
      return;
    }
    try {
      setSubmittingClipFeedback(true);
      setClipFeedbackError('');
      clipFeedbackInteractedRef.current = true;
      setClipFeedbackStars(star);
      await persistClipFeedback({
        stars: star,
        improvementText: null,
        stage: 'rated',
      });
      setClipFeedbackStep('improvement');
    } catch (error) {
      setClipFeedbackError(error?.message || 'Failed to submit feedback');
    } finally {
      setSubmittingClipFeedback(false);
    }
  };

  const submitClipFeedbackImprovement = async () => {
    if (submittingClipFeedback) {
      return;
    }
    if (!clipFeedbackStars || clipFeedbackStars < 1 || clipFeedbackStars > 5) {
      setClipFeedbackError('Please select a rating first.');
      return;
    }
    if (!currentTask) {
      setClipFeedbackError('Task not found. Please try again.');
      return;
    }
    try {
      setSubmittingClipFeedback(true);
      setClipFeedbackError('');
      clipFeedbackInteractedRef.current = true;
      await persistClipFeedback({
        stars: clipFeedbackStars,
        improvementText: clipFeedbackText.trim() || null,
        stage: 'submitted',
      });
      setShowClipFeedbackBubble(false);
      setClipFeedbackStep('rating');
      setClipFeedbackId('');
      setClipFeedbackStars(0);
      setClipFeedbackText('');
      setClipFeedbackTriggerAction('');
      setClipFeedbackClipFilename('');
      clipFeedbackInteractedRef.current = false;
    } catch (error) {
      setClipFeedbackError(error?.message || 'Failed to submit feedback');
    } finally {
      setSubmittingClipFeedback(false);
    }
  };

  useEffect(() => {
    if (!showClipFeedbackBubble) {
      if (clipFeedbackAutoHideTimerRef.current) {
        clearTimeout(clipFeedbackAutoHideTimerRef.current);
        clipFeedbackAutoHideTimerRef.current = null;
      }
      return undefined;
    }
    if (clipFeedbackAutoHideTimerRef.current) {
      clearTimeout(clipFeedbackAutoHideTimerRef.current);
    }
    clipFeedbackAutoHideTimerRef.current = setTimeout(() => {
      if (!clipFeedbackInteractedRef.current) {
        setShowClipFeedbackBubble(false);
      }
      clipFeedbackAutoHideTimerRef.current = null;
    }, 300000);
    return () => {
      if (clipFeedbackAutoHideTimerRef.current) {
        clearTimeout(clipFeedbackAutoHideTimerRef.current);
        clipFeedbackAutoHideTimerRef.current = null;
      }
    };
  }, [showClipFeedbackBubble]);

  const downloadFile = async (downloadUrl, filename) => {
    // Track download button click
    trackButtonClick(BUTTON_ENUMS.DOWNLOAD);
    const shouldRequirePhoneForDownload = taskRequirePhoneForDownload ?? requirePhoneForDownload;

    // Check if user has phone number (required for downloading generated shorts)
    if (shouldRequirePhoneForDownload && !userPhoneNumber) {
      trackClickedAddPhoneDuringDownload();
      setPhonePopupMode('download');
      setShowPhonePopup(true);
      return;
    }
    
    try {
      setDownloadProgressByFile((prev) => ({ ...prev, [filename]: 0 }));
      setUploadStatus({ type: 'info', message: `Downloading ${filename}...` });

      const blob = await fetchBlobWithProgress(downloadUrl, (progress) => {
        setDownloadProgressByFile((prev) => ({ ...prev, [filename]: progress }));
      });
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up
      window.URL.revokeObjectURL(url);
      
      // Show success message
      setUploadStatus({ type: 'success', message: `✅ ${filename} downloaded successfully!` });
      
      // Clear status after 3 seconds
      setTimeout(() => {
        setUploadStatus(null);
      }, 3000);
      
    } catch (error) {
      setUploadStatus({ type: 'error', message: `❌ Download failed: ${error.message}` });
      
      // Clear error after 5 seconds
      setTimeout(() => {
        setUploadStatus(null);
      }, 5000);
    } finally {
      setDownloadProgressByFile((prev) => {
        const next = { ...prev };
        delete next[filename];
        return next;
      });
    }
  };

  const shareResultVideo = async (downloadUrl, filename) => {
    trackButtonClick(BUTTON_ENUMS.SHARE_VIDEO);
    const shouldRequirePhoneForDownload = taskRequirePhoneForDownload ?? requirePhoneForDownload;

    if (shouldRequirePhoneForDownload && !userPhoneNumber) {
      trackClickedAddPhoneDuringDownload();
      setPhonePopupMode('download');
      setShowPhonePopup(true);
      return;
    }

    const copyLinkFallback = async () => {
      try {
        await navigator.clipboard.writeText(downloadUrl);
        setUploadStatus({
          type: 'success',
          message: 'Download link copied — paste it to share your video.',
        });
      } catch {
        setUploadStatus({
          type: 'error',
          message: 'Could not share or copy the link. Try Download instead.',
        });
      }
      setTimeout(() => setUploadStatus(null), 4000);
    };

    if (!navigator.share) {
      await copyLinkFallback();
      return;
    }

    setSharingFiles(prev => new Set([...prev, filename]));
    setUploadStatus({ type: 'info', message: `Preparing ${filename} to share…` });

    try {
      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          Accept: 'video/mp4, video/*, */*',
        },
      });

      if (!response.ok) {
        throw new Error(`Could not load video: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();
      const mime =
        blob.type && blob.type.startsWith('video/')
          ? blob.type
          : 'video/mp4';
      const file = new File([blob], filename, { type: mime });

      const shareData = {
        files: [file],
        title: filename.replace(/\.[^/.]+$/, '') || 'Video',
        text: 'Short video from Makereels',
      };

      if (!navigator.canShare || !navigator.canShare(shareData)) {
        await copyLinkFallback();
        return;
      }

      await navigator.share(shareData);
      setUploadStatus({ type: 'success', message: `Ready to share: ${filename}` });
      setTimeout(() => setUploadStatus(null), 3000);
    } catch (error) {
      if (error && error.name === 'AbortError') {
        setUploadStatus(null);
      } else {
        setUploadStatus({
          type: 'error',
          message: `Share failed: ${error.message || 'Unknown error'}`,
        });
        setTimeout(() => setUploadStatus(null), 5000);
      }
    } finally {
      setSharingFiles(prev => {
        const next = new Set(prev);
        next.delete(filename);
        return next;
      });
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <SignInRedirectHandler onOpenSignIn={openSignInForFeature} />
      <CanonicalTagForRoute />
      <HreflangTagsForRoute />
      <div className="App">
        <svg width="0" height="0" className="result-action-btn-defs" aria-hidden="true">
          <defs>
            <linearGradient id="result-action-grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#5170ff" />
              <stop offset="100%" stopColor="#ff66c4" />
            </linearGradient>
          </defs>
        </svg>
        {showStreakOverlay && streakOverlayTo >= 1 && (
          <div className={`streak-overlay${streakOverlayFast ? ' streak-overlay--fast' : ''}`}>
            <div className="streak-overlay-backdrop" />
            <StreakPerfectHeadline />
            <div
              className="streak-overlay-fly-card streak-overlay-content--flying"
              style={{
                '--streak-fly-x': `${streakFlyCoords.x}px`,
                '--streak-fly-y': `${streakFlyCoords.y}px`,
                '--streak-fly-end-scale': streakFlyEndScale,
                width: `${streakOverlaySize.width}px`,
                height: `${streakOverlaySize.height}px`,
              }}
            >
              <StreakOverlayScreen
                from={streakOverlayFrom}
                to={streakOverlayTo}
                fast={streakOverlayFast}
              />
            </div>
          </div>
        )}
        {showBadgeOverlay && badgeOverlayTier && (
          <>
            <div
              className={`badge-overlay badge-overlay--${badgeOverlayTier.key}${badgeOverlayFast ? ' badge-overlay--fast' : ''}`}
              style={getTierOverlayThemeStyle(badgeOverlayTier.key)}
            >
              <div className="badge-overlay-backdrop" />
              <StreakPerfectHeadline
                line1="NEW ACHIEVEMENT"
                line2="UNLOCKED!"
                singleLine="NEW ACHIEVEMENT UNLOCKED!"
              />
              <div
                className="badge-overlay-fly-card badge-overlay-content--flying"
                style={{
                  '--streak-fly-x': `${badgeFlyCoords.x}px`,
                  '--streak-fly-y': `${badgeFlyCoords.y}px`,
                  '--streak-fly-end-scale': badgeFlyEndScale,
                  width: `${badgeOverlaySize.width}px`,
                  height: `${badgeOverlaySize.height}px`,
                }}
              >
                <BadgeOverlayScreen
                  tierKey={badgeOverlayTier.key}
                  tierName={badgeOverlayTier.name}
                  fast={badgeOverlayFast}
                />
              </div>
            </div>
            <div className={`badge-overlay-confetti${badgeOverlayFast ? ' badge-overlay-confetti--fast' : ''}`} aria-hidden="true">
              <Confetti recycle={false} numberOfPieces={180} gravity={0.9} />
            </div>
          </>
        )}
        {showTimeSavedOverlay && timeSavedDelta > 0 && (
          <>
            <div className="time-saved-overlay">
              <div className="time-saved-overlay-backdrop" />
              <div 
                className="time-saved-overlay-content"
                style={{
                  '--target-x': `${overlayTargetCoords.x}px`,
                  '--target-y': `${overlayTargetCoords.y}px`
                }}
              >
                <div className="time-saved-overlay-label">You just saved</div>
                <div className="time-saved-overlay-number">
                  {formatTimeSaved(timeSavedDelta)}
                </div>
                <div className="time-saved-overlay-sub">
                  Added to your total time saved
                </div>
              </div>
            </div>
            <div className="time-saved-confetti-container">
              <Confetti
                recycle={false}
                numberOfPieces={450}
                gravity={0.7}
              />
            </div>
          </>
        )}
        {showSuccessScreen && (
          <>
            <div className="pro-success-overlay">
              <div className="pro-success-morph" aria-hidden="true">
                <span className="pro-success-coin">₹</span>
                <span className="pro-success-infinity">∞</span>
                <span className="pro-success-glow" />
              </div>
              <h2 className="pro-success-title">You&apos;re on Creators Plan</h2>
              <p className="pro-success-subtitle">
                Unlimited clips · No editing · As promised
              </p>
              <p className="pro-success-cta-text">Upload your First Video!</p>
            </div>
            <div className="pro-success-confetti" aria-hidden="true">
              <Confetti recycle={false} numberOfPieces={180} gravity={0.9} />
            </div>
          </>
        )}
        {showClipFeedbackBubble && (
          <div
            style={{
              position: 'fixed',
              right: '22px',
              bottom: '84px',
              width: 'min(248px, calc(100vw - 12px))',
              background: 'linear-gradient(180deg, #ffffff 0%, #fcf7ff 100%)',
              border: '1px solid rgba(139, 92, 246, 0.26)',
              borderRadius: '12px',
              boxShadow: '0 12px 24px rgba(124, 58, 237, 0.2)',
              zIndex: 1600,
              padding: '9px 9px 8px',
            }}
          >
            <div
              aria-hidden="true"
              style={{
                position: 'absolute',
                right: '22px',
                bottom: '-8px',
                width: '14px',
                height: '14px',
                background: '#fbf5ff',
                borderRight: '1px solid rgba(139, 92, 246, 0.26)',
                borderBottom: '1px solid rgba(139, 92, 246, 0.26)',
                transform: 'rotate(45deg)',
              }}
            />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '6px' }}>
              <div style={{ color: '#4c1d95', fontSize: '12px', lineHeight: 1.3, fontWeight: 600 }}>
                {clipFeedbackStep === 'rating' ? 'Did you like the generated clips?' : 'What should we improve?'}
              </div>
              <button
                type="button"
                onClick={() => {
                  trackButtonClick(BUTTON_ENUMS.FEEDBACK_PROMPT_CLOSE);
                  setShowClipFeedbackBubble(false);
                }}
                style={{
                  border: 'none',
                  background: 'transparent',
                  color: '#8b5cf6',
                  fontSize: '18px',
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
                aria-label="Close feedback"
              >
                ×
              </button>
            </div>
            {clipFeedbackStep === 'rating' ? (
              <>
                <div style={{ display: 'flex', gap: '4px', marginBottom: '2px', justifyContent: 'center' }}>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => handleClipFeedbackStarClick(star)}
                      disabled={submittingClipFeedback}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: submittingClipFeedback ? 'not-allowed' : 'pointer',
                        fontSize: '50px',
                        padding: 0,
                        lineHeight: 1,
                        opacity: submittingClipFeedback ? 0.7 : 1,
                      }}
                      aria-label={`${star} star${star > 1 ? 's' : ''}`}
                    >
                      <span
                        style={
                          clipFeedbackStars >= star
                            ? {
                                backgroundImage: 'linear-gradient(90deg, #8b5cf6 0%, #ff66c4 100%)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                color: 'transparent',
                                display: 'inline-block',
                              }
                            : {
                                color: '#d1d5db',
                                display: 'inline-block',
                              }
                        }
                      >
                        ★
                      </span>
                    </button>
                  ))}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '9px',
                    padding: '0 3px',
                    marginTop: '-2px',
                  }}
                >
                  <span style={{ color: '#dc2626', fontWeight: 700, marginLeft: '8px' }}>Bad</span>
                  <span style={{ color: '#16a34a', fontWeight: 700 }}>Excellent</span>
                </div>
              </>
            ) : (
              <div style={{ marginBottom: '8px' }}>
                <textarea
                  value={clipFeedbackText}
                  onChange={(e) => setClipFeedbackText(e.target.value)}
                  placeholder="Share your suggestions..."
                  rows={2}
                  maxLength={2000}
                  style={{
                    width: '100%',
                    border: '1px solid rgba(139, 92, 246, 0.35)',
                    borderRadius: '7px',
                    padding: '6px',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    fontSize: '12px',
                    boxSizing: 'border-box',
                  }}
                />
              </div>
            )}
            {clipFeedbackError && (
              <div style={{ color: '#b91c1c', fontSize: '12px', marginBottom: '8px' }}>
                {clipFeedbackError}
              </div>
            )}
            {clipFeedbackStep === 'improvement' && (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={submitClipFeedbackImprovement}
                  disabled={submittingClipFeedback}
                  style={{
                    padding: '6px 10px',
                    borderRadius: '7px',
                    border: 'none',
                    background: 'linear-gradient(90deg, #8b5cf6 0%, #ff66c4 100%)',
                    color: 'white',
                    cursor: submittingClipFeedback ? 'not-allowed' : 'pointer',
                    fontWeight: 600,
                    opacity: submittingClipFeedback ? 0.65 : 1,
                  }}
                >
                  {submittingClipFeedback ? 'Submitting…' : 'Submit'}
                </button>
              </div>
            )}
          </div>
        )}
        {/* Header */}
        <header className="header">
          <div className="header-container">
            <div className="header-content">
              {isAuthenticated && isPremiumUser && (
                <div className="header-content-glow" aria-hidden="true" />
              )}
              <div className="header-left">
                <Link to="/" className="logo-link">
                  <img src="/assets/images/headerlogo.png" alt="MAKEREELS" className="logo-image" />
                </Link>
                {isAuthenticated && isPremiumUser && (
                  <span className="premium-badge" title="Unlimited Premium">
                    ✦ UNLIMITED
                  </span>
                )}
              </div>
              <nav className="header-nav">
                {/* Navigation links - hidden on mobile, visible on md+ */}
              </nav>
              <div className="header-right" style={{ position: 'relative' }}>
                {/* Time saved - visible when authenticated and we have time_saved_seconds */}
                {isAuthenticated && user?.time_saved_seconds != null && (
                  <div 
                    ref={timeSavedWidgetRef}
                    className={`time-saved-widget ${highlightTimeSaved ? 'highlight' : ''}`}
                  >
                    <div className="time-saved-text">
                      <div className="time-saved-label">Time saved</div>
                      <div className="time-saved-value">
                        {formatTimeSaved(timeSavedSecondsDisplay != null ? timeSavedSecondsDisplay : (user?.time_saved_seconds || 0))}
                      </div>
                    </div>
                  </div>
                )}

                {!isAuthenticated && (
                  <>
                    <Link to="/features" className="header-link">Features</Link>
                    <Link to="/blog" className="header-link">Blog</Link>
                    <button className="btn-gradient" onClick={() => {
                      trackButtonClick(BUTTON_ENUMS.SIGNUP_BUTTON);
                      setLoginMode('signup');
                      setIsSignupModalOpen(true);
                    }}>Sign Up</button>
                    {/* Mobile Hamburger Menu */}
                    <div className="mobile-menu-container" style={{ position: 'relative' }}>
                      <button 
                        className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Menu"
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="mobile-menu-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                              <stop offset="0%" stopColor="#5170ff" />
                              <stop offset="100%" stopColor="#ff66c4" />
                            </linearGradient>
                          </defs>
                          {/* Hamburger lines */}
                          <path 
                            className="hamburger-line hamburger-line-1" 
                            d="M3 6h18" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                          />
                          <path 
                            className="hamburger-line hamburger-line-2" 
                            d="M3 12h18" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                          />
                          <path 
                            className="hamburger-line hamburger-line-3" 
                            d="M3 18h18" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                          />
                          {/* Close (X) lines */}
                          <path 
                            className="close-line close-line-1" 
                            d="M6 6l12 12" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                          />
                          <path 
                            className="close-line close-line-2" 
                            d="M18 6l-12 12" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                      {isMobileMenuOpen && (
                        <div className="mobile-menu-dropdown">
                          <Link 
                            to="/" 
                            className="mobile-menu-item"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            Home
                          </Link>
                          <div className="mobile-menu-divider"></div>
                          <Link 
                            to="/features" 
                            className="mobile-menu-item"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            Features
                          </Link>
                          <div className="mobile-menu-divider"></div>
                          <Link 
                            to="/blog" 
                            className="mobile-menu-item"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            Blog
                          </Link>
                          <div className="mobile-menu-divider"></div>
                          <Link 
                            to="/terms" 
                            className="mobile-menu-item"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            Terms of Service
                          </Link>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {isAuthenticated && (
                  <div 
                    className="user-menu-container" 
                    ref={userMenuRef}
                    data-open={isUserMenuOpen}
                  >
                    <div 
                      className="user-avatar-wrapper" 
                      onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                    >
                      <div className="user-avatar-with-badge">
                        <div className="user-avatar">
                          <img 
                            src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user?.displayName || user?.name || user?.email || 'User')}&background=8b5cf6&color=ffffff&size=128&bold=true&font-size=0.5`}
                            alt={user?.displayName || 'User'} 
                            className="avatar-image"
                            onError={(e) => {
                              // Fallback to initials if avatar service fails
                              e.target.style.display = 'none';
                              const initialsDiv = e.target.parentElement.querySelector('.avatar-initials');
                              if (initialsDiv) {
                                initialsDiv.style.display = 'flex';
                              }
                            }}
                          />
                          <div 
                            className="avatar-initials"
                            style={{ display: 'none' }}
                          >
                            {(user?.displayName || user?.name || user?.email || 'U').charAt(0).toUpperCase()}
                          </div>
                        </div>
                        {isPremiumUser && (
                          <span className="avatar-premium-star-badge" title="Unlimited Premium" aria-label="Unlimited Premium">
                            <svg
                              className="avatar-premium-star-icon"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              focusable="false"
                              shapeRendering="geometricPrecision"
                            >
                              <path
                                d="M12 1.35 Q14.48 9.72 22.65 12 Q14.48 14.28 12 22.65 Q9.52 14.28 1.35 12 Q9.52 9.72 12 1.35 Z"
                                fillRule="nonzero"
                              />
                            </svg>
                          </span>
                        )}
                      </div>
                      <span className="user-name-display">
                        {user?.displayName || user?.name || user?.email?.split('@')[0] || 'User'}
                      </span>
                      <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    {isUserMenuOpen && (
                      <div className="user-dropdown">
                        <div className="user-dropdown-header">
                          <div className="user-dropdown-name">
                            Hi {user?.displayName || user?.name || user?.email?.split('@')[0] || 'User'}!
                          </div>
                          {user?.email && (
                            <div className="user-dropdown-email">{user.email}</div>
                          )}
                        </div>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Dashboard
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/calender" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Calendar
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/dailycontent" 
                          className="user-dropdown-item"
                          onClick={() => {
                            trackDailyContentIdeaClick();
                            setIsUserMenuOpen(false);
                          }}
                        >
                          Daily content idea
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/#past-projects" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Projects
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/features" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Features
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/pricing" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Pricing
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/blog" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Blog
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/policy" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Privacy Policy
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <Link 
                          to="/terms" 
                          className="user-dropdown-item"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          Terms of Service
                        </Link>
                        <div className="user-dropdown-divider"></div>
                        <button 
                          className="user-dropdown-item" 
                          onClick={() => {
                            setIsUserMenuOpen(false);
                            // Track logout before logging out
                            if (user?.email) {
                              trackUserLogout(user.email);
                            }
                            logout();
                          }}
                        >
                          Log Out
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        <Suspense
          fallback={
            <div
              className="route-chunk-fallback"
              style={{
                minHeight: '45vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(0,0,0,0.35)',
                fontSize: 14,
                fontFamily: 'Inter, sans-serif',
              }}
            >
              Loading…
            </div>
          }
        >
        <Routes>
          <Route path="/" element={
            <>
              {/* Hero Section */}
              <main className={`hero${isSignedInIdleHome ? ' hero--signed-in-idle' : ''}`}>
        <div className="hero-content">
          {!isAuthenticated && (
            <h1 className="hero-title">
              Post more <span className="lightning">⚡</span> Grow faster
            </h1>
          )}

          {!isAuthenticated && (
            <h2 className="main-headline">
              <span className="headline-line">Your Path to</span>
              <span className="headline-line"><span className="highlight-number">10 Million</span> <span className="rotating-word-container"><span className={`rotating-word ${isRolling ? 'rolling' : ''}`}>{ROTATING_WORDS[rotatingWord]}</span></span></span>
            </h2>
          )}
        </div>

        {/* Hero: before/after wipe demo — outside hero-content so it isn't capped at 600px */}
        {!isAuthenticated && <HeroWipe />}

        <div className={`hero-content${isSignedInIdleHome ? ' hero-content--full' : ''}`}>

          {/* Video Upload Section, Phone Input Section, or Results Section */}
          {processingStatus === 'completed' && resultFiles.length > 0 ? (
            <div className={`upload-section ${isAuthenticated ? 'authenticated' : ''}`}>
              {resultFiles.some(file => file.isProcessedVideo) && resultFiles.length === 1 ? (
                <>
                  <h3 className="upload-title">🎉 Your Processed Video Is Ready!</h3>
                </>
              ) : (
                <>
                  <h3 className="upload-title">🎉 Your Viral Shorts Are Ready!</h3>
                  <p className="upload-description">
                    We've created {resultFiles.length} viral short{resultFiles.length > 1 ? 's' : ''} from your video.
                  </p>
                </>
              )}
              
              <div className="upload-container">
                <div className="results-grid">
                  {resultFiles.map((file, index) => {
                    const isPlaying = playingVideo === file.filename;
                    return (
                      <div key={index} className="result-item">
                        {!file.isProcessedVideo && (
                          <span className="result-virality-badge">
                            <i className="fa-solid fa-fire-flame-curved result-virality-badge-icon" aria-hidden="true" />
                            <span className="result-virality-badge-value">
                              <span className="result-virality-badge-score">{file.viralityScore || 75}</span>
                              <span className="result-virality-badge-max">/100</span>
                            </span>
                          </span>
                        )}
                        <div className="result-item__body">
                        <div className="result-thumbnail-container">
                          {isPlaying ? (
                            <div className="result-video-wrapper">
                              <video
                                ref={(el) => {
                                  videoRefs.current[file.filename] = el;
                                  if (el && isPlaying) {
                                    el.play().catch(() => {});
                                  }
                                }}
                                src={file.download_url}
                                className="result-video-player"
                                preload="metadata"
                                onEnded={() => {
                                  setPlayingVideo(null);
                                  setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                }}
                                onClick={() => {
                                  // Toggle pause button visibility on video click
                                  setShowPauseButton(prev => ({ ...prev, [file.filename]: !prev[file.filename] }));
                                  // Hide again after 2 seconds
                                  setTimeout(() => {
                                    setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                  }, 2000);
                                }}
                                loop={false}
                                playsInline
                                controls={false}
                              />
                              {showPauseButton[file.filename] && (
                                <button
                                  className="result-pause-button"
                                  onClick={() => {
                                    if (videoRefs.current[file.filename]) {
                                      videoRefs.current[file.filename].pause();
                                    }
                                    setPlayingVideo(null);
                                    setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                  }}
                                  aria-label="Pause video"
                                >
                                  <svg width="32" height="32" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                                  </svg>
                                </button>
                              )}
                            </div>
                          ) : (
                            <>
                              <ClipThumbnail
                                fileStem={file.file_stem}
                                clipFilename={file.filename}
                                getFreshTokenRef={getFreshTokenRef}
                              />
                              <button
                                className="result-play-button"
                                onClick={() => {
                                  trackClipPreviewPlayed(file.filename);
                                  scheduleClipFeedbackPrompt('preview', file.filename);
                                  setPlayingVideo(file.filename);
                                  setShowPauseButton(prev => ({ ...prev, [file.filename]: true }));
                                }}
                                aria-label="Play video"
                              >
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8 5v14l11-7z"/>
                                </svg>
                              </button>
                            </>
                          )}
                        </div>
                        <div className="result-content">
                          <div className="result-rank">
                            #{index + 1}
                          </div>
                          <div className="result-filename-wrap">
                            <h4 className="result-filename" title={file.filename}>
                              {file.filename}
                            </h4>
                          </div>
                          <div className="result-actions">
                            <div className="result-actions-row">
                            <button
                              type="button"
                              className={`share-btn ${sharingFiles.has(file.filename) ? 'loading' : ''}`}
                              onClick={() => {
                                scheduleClipFeedbackPrompt('share', file.filename);
                                shareResultVideo(file.download_url, file.filename);
                              }}
                              disabled={
                                sharingFiles.has(file.filename) ||
                                file.filename in downloadProgressByFile
                              }
                              aria-label={
                                sharingFiles.has(file.filename)
                                  ? 'Preparing video to share'
                                  : 'Share video'
                              }
                              aria-busy={sharingFiles.has(file.filename)}
                            >
                              {sharingFiles.has(file.filename) ? (
                                <span className="download-spinner" aria-hidden="true">⏳</span>
                              ) : (
                                <svg className="share-btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="url(#result-action-grad)" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
                                </svg>
                              )}
                            </button>
                            <button
                              type="button"
                              className={`download-btn ${file.filename in downloadProgressByFile ? 'loading' : ''}`}
                              onClick={() => {
                                scheduleClipFeedbackPrompt('download', file.filename);
                                downloadFile(file.download_url, file.filename);
                              }}
                              disabled={
                                file.filename in downloadProgressByFile ||
                                sharingFiles.has(file.filename)
                              }
                              aria-busy={file.filename in downloadProgressByFile}
                              aria-label={
                                file.filename in downloadProgressByFile
                                  ? `Downloading ${downloadProgressByFile[file.filename]} percent`
                                  : 'Download video'
                              }
                            >
                              {file.filename in downloadProgressByFile ? (
                                `${downloadProgressByFile[file.filename]}%`
                              ) : (
                                'DOWNLOAD'
                              )}
                            </button>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div className="result-item__ribbon">
                          <ResultPublishButton
                            fileStem={file.file_stem}
                            clipFilename={file.filename}
                            taskId={currentTask}
                            userId={user?.uid || ''}
                            isPremiumUser={isPremiumUser}
                            getAuthToken={getFreshToken}
                            onStatusMessage={setUploadStatus}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>

                <button 
                  onClick={() => {
                    trackUploadAnotherVideoClick();
                    setProcessingStatus(null);
                    setResultFiles([]);
                    setCurrentTask(null);
                    if (clipFeedbackTimerRef.current) {
                      clearTimeout(clipFeedbackTimerRef.current);
                      clipFeedbackTimerRef.current = null;
                    }
                    setShowClipFeedbackBubble(false);
                    setTaskRequirePhoneForDownload(null);
                    setSelectedFile(null);
                    setLocalVideoResolution(null);
                    setShowPhoneInput(false);
                    setPhoneNumber('');
                    setUploadStatus(null);
                    hasRestoredFilesRef.current = false; // Reset so we can restore new files after processing
                    if (fileInputRef.current) {
                      fileInputRef.current.value = '';
                    }
                  }}
                  className="upload-btn"
                  style={{ marginTop: '20px' }}
                >
                  Upload Another Video
                </button>
              </div>
            </div>
          ) : (DEV_FORCE_PROCESSING_VIEW || processingStatus === 'PROCESSING') ? (
            <div className={`upload-section ${isAuthenticated ? 'authenticated' : ''}`}>
              <h3 className="upload-title">Processing Your Video</h3>
              <p className="upload-description">AI is analyzing your video and creating viral shorts...</p>
              
              <div className="upload-container processing-container">
                <div className="processing-card">
                {/* YouTube Video for entertainment during processing */}
                <div className="processing-youtube-wrapper">
                  <div className="youtube-container">
                    <iframe 
                      width="100%" 
                      height="100%" 
                      src="https://www.youtube.com/embed/9CQX9kq4BPM?autoplay=1&mute=0&controls=1&rel=0&modestbranding=1" 
                      title="YouTube video player" 
                      frameBorder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      allowFullScreen
                      className="youtube-iframe">
                    </iframe>
                  </div>
                </div>
                
                <div className="processing-info">
                  <div className="processing-percent-display">
                    {dummyProgress < PROCESSING_PROGRESS_MAX ? (
                      <span className="processing-percent-value">
                        {dummyProgress.toFixed(2)}%
                      </span>
                    ) : (
                      <span className="processing-percent-value processing-percent-value--almost">Almost done</span>
                    )}
                  </div>
                  
                  {/* Get Notified Message - shown 5 seconds after processing starts if no phone */}
                  {showGetNotified && !userPhoneNumber && (
                    <div className="processing-notify-banner">
                      <span className="processing-notify-text">🔔 Get notified when your shorts are ready</span>
                      <button
                        type="button"
                        className="processing-notify-btn"
                        onClick={() => {
                          trackClickedAddPhoneDuringProcessing();
                          setPhonePopupMode('notify');
                          setShowPhonePopup(true);
                        }}
                      >
                        Add Number
                      </button>
                    </div>
                  )}
                  
                  {/* Simple Progress Bar: percentage complete + ETA */}
                  <div className="progress-container processing-progress">
                    <div className="progress-bar">
                      <div 
                        className="progress-fill" 
                        style={{ width: `${dummyProgress}%` }}
                      ></div>
                    </div>
                    <div className="eta-text">
                      ETA: {eta ?? 6} min{(eta ?? 6) !== 1 ? 's' : ''}
                    </div>
                  </div>
                </div>
                </div>
              </div>
              {userPhoneNumber && (
                <p className="processing-whatsapp-note">
                  You will receive a WhatsApp notification once processing is complete.
                </p>
              )}
            </div>
          ) : (
            (() => {
              const idleUploadBlock = (
            <>
            <div className={`upload-section ${isAuthenticated ? 'authenticated' : ''}`}>
              <h3 className="upload-title">Upload Your Raw Video</h3>
              <p className="upload-description">Transform your video into viral shorts with AI</p>
              
              <div className="upload-container">
                {/* Show preview if file is selected or YouTube URL has thumbnail, otherwise show upload/URL input */}
                {(selectedFile || youtubeThumbnail || (youtubeUrl.trim() && !youtubeUrlError && (youtubeMetadata || isFetchingMetadata))) ? (
                  <>
                  <div className="file-preview" style={{ position: 'relative' }}>
                    {/* Video Thumbnail Section */}
                    <div className="video-thumbnail-preview" style={{ marginTop: '0px' }}>
                      <div className="video-thumbnail-wrapper">
                        {processingStatus !== 'PROCESSING' && !isUploading && !isDownloading && !currentTask && (
                          <button
                            type="button"
                            aria-label="Close preview"
                            onClick={clearPreview}
                            style={{
                              position: 'absolute',
                              top: '8px',
                              left: '8px',
                              background: 'transparent',
                              border: 'none',
                              width: '24px',
                              height: '24px',
                              padding: '0',
                              cursor: 'pointer',
                              fontSize: '24px',
                              fontWeight: '600',
                              lineHeight: '1',
                              transition: 'all 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              zIndex: 20,
                              boxShadow: 'none',
                            }}
                          >
                            <span
                              aria-hidden="true"
                              style={{
                                display: 'inline-block',
                                background: 'linear-gradient(90deg, #8b5cf6, #ec4899)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                              }}
                            >
                              ×
                            </span>
                          </button>
                        )}
                        {selectedFile ? (
                          videoThumbnail ? (
                            <img 
                              src={videoThumbnail} 
                              alt="Video thumbnail" 
                              className="video-thumbnail-img"
                            />
                          ) : (
                            <div className="video-thumbnail-placeholder">
                              <span>📹</span>
                            </div>
                          )
                        ) : youtubeThumbnail ? (
                          <img 
                            src={youtubeThumbnail} 
                            alt="Video thumbnail" 
                            className="video-thumbnail-img"
                            onError={(e) => {
                              const videoId = extractYouTubeVideoId(youtubeUrl);
                              if (videoId) {
                                e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                              } else {
                                e.target.style.display = 'none';
                              }
                            }}
                          />
                        ) : (
                          <div className="video-thumbnail-placeholder">
                            <span>🔗</span>
                          </div>
                        )}
                        {(selectedFile ? localVideoResolution : youtubeMetadata?.resolution) && (
                          <div className="thumbnail-quality-badge">
                            {selectedFile ? localVideoResolution : youtubeMetadata?.resolution}
                          </div>
                        )}
                      </div>
                      <div className="video-info-preview">
                        {selectedFile ? (
                          <>
                            <div className="video-info-item">
                              <span className="video-info-label">Size:</span>
                              <span className="video-info-value">{(selectedFile.size / (1024 * 1024)).toFixed(1)} MB</span>
                            </div>
                            {videoDuration && (
                              <div className="video-info-item">
                                <span className="video-info-label">Duration:</span>
                                <span className="video-info-value">{formatDuration(videoDuration)}</span>
                              </div>
                            )}
                          </>
                        ) : youtubeMetadata ? (
                          <>
                            <div className="video-info-item">
                              <span className="video-info-label">Size:</span>
                              <span className="video-info-value">
                                {youtubeMetadata.size_mb !== null && 
                                 youtubeMetadata.size_mb !== undefined && 
                                 youtubeMetadata.size_mb > 0
                                  ? `${youtubeMetadata.size_mb.toFixed(1)} MB`
                                  : 'Unknown'}
                              </span>
                            </div>
                            <div className="video-info-item">
                              <span className="video-info-label">Duration:</span>
                              <span className="video-info-value">
                                {youtubeMetadata.duration_seconds
                                  ? formatDuration(youtubeMetadata.duration_seconds)
                                  : 'Unknown'}
                              </span>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                    
                    {/* Font Selection Section */}
                    <div className="font-selection">
                      <div className="trim-silence-header">
                        <div className="font-selection-title">Captions</div>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            checked={addCaptions}
                            onChange={(e) => setAddCaptions(e.target.checked)}
                            className="toggle-input"
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      <div
                        className="font-options-scroll caption-picker-scroll"
                        style={{
                          opacity: addCaptions ? 1 : 0.5,
                          pointerEvents: addCaptions ? 'auto' : 'none'
                        }}
                      >
                        {fontTemplates.map((template) => (
                          <div
                            key={template.id}
                            className={`font-option-simple ${selectedFontTemplate === template.id ? 'selected' : ''}`}
                            onClick={() => {
                              if (!addCaptions) return;
                              setSelectedFontTemplate(template.id);
                            }}
                          >
                            <div className="font-preview-simple">
                              {template.preview.includes('.mp4') ? (
                                <video 
                                  src={template.preview}
                                  autoPlay 
                                  loop 
                                  muted 
                                  playsInline
                                  className="font-preview-image"
                                  key={template.id}
                                />
                              ) : (
                                <img 
                                  src={template.preview}
                                  alt={`${template.name} ${template.style} preview`}
                                  className="font-preview-image"
                                  key={template.id}
                                />
                              )}
                              {template.isNew && (
                                <div className="new-label">New</div>
                              )}
                            </div>
                            <div className="font-name-simple">
                              {template.name}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    {/* Language Selection Section */}
                    <div className="language-selection">
                      <div className="language-selection-header">
                        <div className="language-selection-title">Language</div>
                        <div className="language-dropdown-container">
                          <div 
                            className="language-dropdown"
                            onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
                          >
                            <span className="language-dropdown-selected">
                              {languageOptions.find(lang => lang.id === selectedLanguage)?.flag} {languageOptions.find(lang => lang.id === selectedLanguage)?.name}
                            </span>
                            <span className="language-dropdown-arrow">▼</span>
                          </div>
                          {isLanguageDropdownOpen && (
                            <div className="language-dropdown-options">
                              {languageOptions.map((language) => (
                                <div
                                  key={language.id}
                                  className={`language-option ${selectedLanguage === language.id ? 'selected' : ''}`}
                                  onClick={() => {
                                    setSelectedLanguage(language.id);
                                    setIsLanguageDropdownOpen(false);
                                  }}
                                >
                                  <span className="language-flag">{language.flag}</span>
                                  <span className="language-name">{language.name}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Background Selection Section */}
                    <div className="language-selection">
                      <div className="language-selection-header">
                        <div className="language-selection-title">Background</div>
                      </div>
                      <div className="background-options-scroll background-picker-scroll">
                        <button
                          type="button"
                          className={`background-card ${selectedBackground === 'auto' ? 'selected' : ''}`}
                          onClick={() => setSelectedBackground('auto')}
                        >
                          <div className="background-card-preview background-card-auto">
                            <img src="/auto_preview.png" alt="" className="background-preview-image" />
                            <span className="background-card-overlay-label">Auto</span>
                          </div>
                        </button>
                        <button
                          type="button"
                          className={`background-card ${String(selectedBackground).startsWith('staging:') ? 'selected' : ''}`}
                          onClick={() => customBgFileInputRef.current && customBgFileInputRef.current.click()}
                          disabled={isStagingBackground}
                        >
                          <div className="background-card-preview background-card-upload">
                            <img src="/upload_preview.png" alt="" className="background-preview-image" />
                            {stagedBackgroundPreviewUrl ? (
                              stagedBackgroundPreviewType.startsWith('video/') ? (
                                <video
                                  src={stagedBackgroundPreviewUrl}
                                  autoPlay
                                  loop
                                  muted
                                  playsInline
                                  className="background-preview-image background-upload-staged-preview"
                                />
                              ) : (
                                <img src={stagedBackgroundPreviewUrl} alt="" className="background-preview-image background-upload-staged-preview" />
                              )
                            ) : null}
                            <span className="background-card-overlay-label">{isStagingBackground ? 'Uploading...' : 'Upload'}</span>
                          </div>
                        </button>
                        <button
                          type="button"
                          className={`background-card ${selectedBackground === 'blur_video' ? 'selected' : ''}`}
                          onClick={() => setSelectedBackground('blur_video')}
                        >
                          <div className="background-card-preview background-card-blur">
                            <img
                              src={videoThumbnail || youtubeThumbnail || '/blur_preview.png'}
                              alt=""
                              className="background-preview-image background-preview-image-blurred"
                            />
                            <span className="background-card-overlay-label">Blur</span>
                          </div>
                        </button>
                        {backgroundOptions
                          .filter((bg) => bg && bg.id !== 'auto' && bg.id !== 'blur_video' && !String(bg.id).startsWith('staging:'))
                          .map((bg) => {
                            const previewSrc = resolveBackgroundPreviewSrc(bg);
                            return (
                              <button
                                type="button"
                                key={bg.id}
                                className={`background-card ${selectedBackground === bg.id ? 'selected' : ''}`}
                                onClick={() => setSelectedBackground(bg.id)}
                                title={bg.name || bg.id}
                              >
                                <div className="background-card-preview">
                                  {previewSrc ? (
                                    <img src={previewSrc} alt="" className="background-preview-image" />
                                  ) : (
                                    <span className="background-card-fallback">Background</span>
                                  )}
                                </div>
                              </button>
                            );
                          })}
                      </div>
                    </div>
                    <input
                      ref={customBgFileInputRef}
                      type="file"
                      accept="image/png,image/jpeg,image/webp,image/gif,video/mp4,video/webm,video/quicktime"
                      style={{ display: 'none' }}
                      onChange={handleCustomBackgroundFile}
                    />
                    {customBackgroundError ? (
                      <div
                        style={{
                          marginBottom: '10px',
                          padding: '8px 12px',
                          background: '#fef2f2',
                          border: '1px solid #fecaca',
                          borderRadius: '8px',
                          color: '#991b1b',
                          fontSize: '13px'
                        }}
                      >
                        {customBackgroundError}
                      </div>
                    ) : null}
                    
                    <div className="trim-silence-section">
                      <div className="trim-silence-header">
                        <div className="trim-silence-title">Trim Silence</div>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            checked={trimSilence}
                            onChange={(e) => setTrimSilence(e.target.checked)}
                            className="toggle-input"
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      <p className="trim-silence-description">
                        Auto remove silence and filler words like uhm &amp; ah
                      </p>
                    </div>

                    <div className={`trim-silence-section trim-silence-section-ai-hooks${!isPremiumUser ? ' trim-silence-section--premium-locked' : ''}`}>
                      <div className="trim-silence-header">
                        <div className="trim-silence-title">
                          AI Intro Hooks
                          {!isPremiumUser ? (
                            <span
                              className={`preview-premium-badge${premiumBadgeJitter === 'aiHooks' ? ' preview-premium-badge--jitter' : ''}`}
                            >
                              Premium
                            </span>
                          ) : null}
                        </div>
                        <label
                          className={`toggle-switch${!isPremiumUser ? ' toggle-switch--premium-locked' : ''}`}
                          onClick={(e) => {
                            if (!isPremiumUser) {
                              e.preventDefault();
                              triggerPremiumBadgeJitter('aiHooks');
                            }
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={aiHooks}
                            readOnly={!isPremiumUser}
                            onChange={(e) => {
                              if (!isPremiumUser) {
                                triggerPremiumBadgeJitter('aiHooks');
                                return;
                              }
                              setAiHooks(e.target.checked);
                            }}
                            className="toggle-input"
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      <p className="trim-silence-description">
                        Add scroll stopping moments to your video
                      </p>
                      <div
                        className="background-options-scroll hook-style-options-scroll hook-picker-scroll"
                        style={{
                          opacity: aiHooks ? 1 : 0.5,
                          pointerEvents: aiHooks ? 'auto' : 'none'
                        }}
                      >
                        {hookTemplateOptions.map((h) => (
                          <button
                            key={h.id}
                            type="button"
                            className={`background-card ${selectedHookTemplate === h.id ? 'selected' : ''}`}
                            disabled={!aiHooks}
                            onClick={() => {
                              if (!aiHooks) return;
                              setSelectedHookTemplate(h.id);
                            }}
                            title={h.name}
                          >
                            <div
                              className={`background-card-preview background-card-hook${h.id === 'auto' ? ' background-card-hook-auto' : ''}`}
                            >
                              <img src={h.preview} alt="" className="background-preview-image" />
                              <span className="background-card-overlay-label">{h.name}</span>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className={`trim-silence-section${!isPremiumUser ? ' trim-silence-section--premium-locked' : ''}`}>
                      <div className="trim-silence-header">
                        <div className="trim-silence-title">
                          Add B-roll
                          {!isPremiumUser ? (
                            <span
                              className={`preview-premium-badge${premiumBadgeJitter === 'broll' ? ' preview-premium-badge--jitter' : ''}`}
                            >
                              Premium
                            </span>
                          ) : null}
                        </div>
                        <label
                          className={`toggle-switch${!isPremiumUser ? ' toggle-switch--premium-locked' : ''}`}
                          onClick={(e) => {
                            if (!isPremiumUser) {
                              e.preventDefault();
                              triggerPremiumBadgeJitter('broll');
                            }
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={includeBroll}
                            readOnly={!isPremiumUser}
                            onChange={(e) => {
                              if (!isPremiumUser) {
                                triggerPremiumBadgeJitter('broll');
                                return;
                              }
                              setIncludeBroll(e.target.checked);
                            }}
                            className="toggle-input"
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </div>
                      <p className="trim-silence-description">
                        Enhance videos with seamless B-roll for better storytelling
                      </p>
                    </div>
                    
                    {/* Upload/Download Progress */}
                    {(isUploading || isDownloading) && (
                      <div style={{ width: '100%' }}>
                        {isDownloading && (
                          <div style={{ 
                            textAlign: 'center', 
                            marginBottom: '16px',
                            color: '#6b7280',
                            fontSize: '14px'
                          }}>
                            <div style={{ 
                              fontSize: '32px', 
                              marginBottom: '8px',
                              animation: 'pulse 2s ease-in-out infinite'
                            }}>⬇️</div>
                            <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                              Downloading from YouTube...
                            </div>
                            <div style={{ fontSize: '12px' }}>
                              This may take a minute depending on video size
                            </div>
                          </div>
                        )}
                        <div className={isUploading ? "upload-progress" : "progress-container"}>
                          <div className="progress-bar">
                            <div 
                              className="progress-fill" 
                              style={{ width: `${isUploading ? uploadProgress : downloadProgress}%` }}
                            ></div>
                          </div>
                          <span className={isUploading ? "progress-text" : "progress-text"}>
                            {isUploading 
                              ? `${uploadProgress}%` 
                              : downloadProgress < 100 
                                ? `${Math.round(downloadProgress)}%` 
                                : 'Almost downloaded'}
                          </span>
                        </div>
                      </div>
                    )}
                    
                    {/* Error message for YouTube metadata fetch failure (e.g. video too long / too large) */}
                    {youtubeMetadataError && !selectedFile && youtubeUrl.trim() && (
                      <div style={{
                        marginTop: '12px',
                        marginBottom: '14px',
                        padding: '8px 12px',
                        background: '#fef3c7',
                        border: '1px solid #fbbf24',
                        borderRadius: '8px',
                        color: '#92400e',
                        fontSize: '14px',
                        textAlign: 'center',
                        lineHeight: 1.35
                      }}>
                        ⚠️ {youtubeMetadataErrorMessage || 'Could not load video info. Try again or use file upload.'}
                      </div>
                    )}
                    
                    {/* Upload/Download Button */}
                    {!isUploading && !isDownloading && (
                      <button 
                        type="button"
                        onClick={handleGenerateShortsClick}
                        className="upload-btn"
                        disabled={
                          isFreeDailyLimitReached
                          || (selectedFile
                            ? false
                            : (!youtubeUrl.trim() || !!youtubeUrlError || isFetchingMetadata || youtubeMetadataError))
                        }
                        style={{
                          opacity: (
                            !isFreeDailyLimitReached
                            && (selectedFile || (youtubeUrl.trim() && !youtubeUrlError && !isFetchingMetadata && !youtubeMetadataError))
                          ) ? 1 : 0.5,
                          cursor: (
                            !isFreeDailyLimitReached
                            && (selectedFile || (youtubeUrl.trim() && !youtubeUrlError && !isFetchingMetadata && !youtubeMetadataError))
                          ) ? 'pointer' : 'not-allowed'
                        }}
                      >
                        <strong style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                          {isFetchingMetadata && !selectedFile ? (
                            <>
                              <svg className="spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
                                <circle cx="12" cy="12" r="10" stroke="rgba(255, 255, 255, 0.3)" strokeWidth="2"/>
                                <path d="M12 2 A10 10 0 0 1 22 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                              <span>Loading...</span>
                            </>
                          ) : (
                            <>
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              <span>Generate Shorts</span>
                            </>
                          )}
                        </strong>
                      </button>
                    )}

                    {isAuthenticated && !isPremiumUser && (
                      <div
                        ref={freeQuotaInfoRef}
                        className={`freemium-quota-note${isFreeDailyLimitReached ? ' freemium-quota-note--limit' : ''}`}
                      >
                        <button
                          type="button"
                          className="freemium-quota-info-btn"
                          aria-label="Free quota info"
                          aria-expanded={showFreeQuotaInfo}
                          onClick={() => setShowFreeQuotaInfo((prev) => !prev)}
                        >
                          <span className="freemium-quota-info-icon" aria-hidden="true">i</span>
                        </button>
                        <span className="freemium-quota-text">
                          Left: {freeRunsRemaining}/{FREE_DAILY_PROCESSING_LIMIT} Today
                        </span>
                        {showFreeQuotaInfo ? (
                          <p className="freemium-quota-tooltip" role="tooltip">
                            Your free quota to process videos resets midnight daily.
                          </p>
                        ) : null}
                      </div>
                    )}
                  </div>
                  {/* Spoken-dialogue tip below file-preview, still in upload-container */}
                  <div className="preview-tip preview-tip-yellow" role="note">
                    <span className="preview-tip-icon" aria-hidden="true">ⓘ</span>
                    <span className="preview-tip-text">
                      <span className="preview-tip-line">Works best with videos that include spoken dialogue (podcasts, interviews, talking-head videos).</span>
                      <span className="preview-tip-line">Music-only or background-audio videos may not generate highlights.</span>
                    </span>
                  </div>
                  </>
                ) : (
                  /* Unified Upload/URL Input Screen */
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%'
                  }}>
                    {/* Big Plus Icon Upload Area */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileSelect}
                      accept="video/mp4,video/x-m4v,video/*"
                      className="file-input"
                      id="video-upload"
                      style={{ display: 'none' }}
                    />
                    <div
                      role="button"
                      tabIndex={0}
                      aria-label="Choose video file"
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trackButtonClick(BUTTON_ENUMS.UPLOAD_BUTTON); fileInputRef.current?.click(); startFileInputPolling(); } }}
                      onClick={(e) => {
                        if (!isAuthenticated) {
                          setUploadStatus({
                            type: 'error',
                            message: 'Please sign in to upload videos'
                          });
                          setLoginMode('signup');
                          setIsSignupModalOpen(true);
                          return;
                        }
                        trackButtonClick(BUTTON_ENUMS.UPLOAD_BUTTON);
                        fileInputRef.current?.click();
                        startFileInputPolling();
                      }}
                      style={{
                        width: '100%',
                        maxWidth: '400px',
                        aspectRatio: '7/3',
                        border: '3px dashed #d1d5db',
                        borderRadius: '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
                        position: 'relative',
                        overflow: 'visible',
                        zIndex: 1,
                        isolation: 'isolate'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = '#8b5cf6';
                        e.currentTarget.style.background = 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)';
                        e.currentTarget.style.transform = 'scale(1.02)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = '#d1d5db';
                        e.currentTarget.style.background = 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      {/* Radial gradient shadow all around upload button */}
                      <div className="url-input-shadow" style={{
                        position: 'absolute',
                        top: '-15px',
                        left: '-15px',
                        right: '-15px',
                        bottom: '-15px',
                        width: 'calc(100% + 30px)',
                        height: 'calc(100% + 30px)',
                        background: 'radial-gradient(ellipse at center, rgba(81, 112, 255, 0.3) 0%, rgba(255, 102, 196, 0.3) 50%, transparent 70%)',
                        borderRadius: '20px',
                        filter: 'blur(12px)',
                        zIndex: 0,
                        pointerEvents: 'none'
                      }} />
                      {/* Background layer to ensure shadow stays behind */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
                        borderRadius: '13px',
                        zIndex: 1,
                        pointerEvents: 'none'
                      }} />
                      <div style={{
                        fontSize: '48px',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="plus-icon-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                              <stop offset="0%" stopColor="#5170ff" />
                              <stop offset="100%" stopColor="#ff66c4" />
                            </linearGradient>
                          </defs>
                          <path 
                            d="M12 5V19M5 12H19" 
                            stroke="url(#plus-icon-gradient)" 
                            strokeWidth="2.5" 
                            strokeLinecap="square"
                          />
                        </svg>
                      </div>
                      <div style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#374151',
                        marginBottom: '6px',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        Upload Video
                      </div>
                      <div style={{
                        fontSize: '13px',
                        color: '#6b7280',
                        textAlign: 'center',
                        padding: '0 20px',
                        position: 'relative',
                        zIndex: 2
                      }}>
                        Click to browse or drag and drop
                      </div>
                    </div>

                    {/* OR Separator - Only show if YouTube URL is enabled */}
                    {youtubeUrlEnabled && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        maxWidth: '400px',
                        gap: '16px',
                        color: '#9ca3af',
                        margin: '-8px 0'
                      }}>
                        <div style={{
                          flex: 1,
                          height: '1px',
                          background: 'linear-gradient(to right, transparent, #d1d5db, transparent)'
                        }}></div>
                        <div style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          padding: '0 8px'
                        }}>
                          OR
                        </div>
                        <div style={{
                          flex: 1,
                          height: '1px',
                          background: 'linear-gradient(to right, transparent, #d1d5db, transparent)'
                        }}></div>
                      </div>
                    )}

                    {/* URL Input Field - Only show if YouTube URL is enabled */}
                    {youtubeUrlEnabled && (
                    <div style={{ 
                      width: '100%',
                      maxWidth: '400px',
                      position: 'relative'
                    }}>
                      <div style={{
                        position: 'absolute',
                        left: '16px',
                        top: '16px',
                        zIndex: 2,
                        pointerEvents: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '20px',
                        width: '20px',
                        overflow: 'visible'
                      }}>
                        {/* URL Link Icon */}
                        <svg 
                          className="url-icon-animated" 
                          width="20" 
                          height="20" 
                          viewBox="0 0 24 24" 
                          fill="none" 
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px'
                          }}
                        >
                          <defs>
                            <linearGradient id="url-input-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                              <stop offset="0%" stopColor="#5170ff" />
                              <stop offset="100%" stopColor="#ff66c4" />
                            </linearGradient>
                          </defs>
                          <path d="M10 13C10.4295 13.5741 10.9774 14.0492 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59699 21.9548 8.33397 21.9434 7.02296C21.932 5.71196 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.47L11.75 5.18" stroke="url(#url-input-gradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M14 11C13.5705 10.4259 13.0226 9.95081 12.3934 9.60706C11.7642 9.26331 11.0685 9.05886 10.3533 9.00766C9.63816 8.95645 8.92037 9.05972 8.24864 9.31026C7.57691 9.5608 6.96695 9.95302 6.45996 10.46L3.45996 13.46C2.54918 14.403 2.04519 15.666 2.05659 16.977C2.06798 18.288 2.59382 19.5421 3.52086 20.4691C4.4479 21.3962 5.70196 21.922 7.01296 21.9334C8.32397 21.9448 9.58699 21.4408 10.53 20.53L12.24 18.82" stroke="url(#url-input-gradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {/* YouTube Icon */}
                        <svg 
                          className="youtube-icon-animated" 
                          width="20" 
                          height="20" 
                          viewBox="0 0 24 24" 
                          fill="none" 
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px'
                          }}
                        >
                          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="#FF0000"/>
                        </svg>
                        {/* Google Drive Icon */}
                        <svg
                          className="drive-icon-animated"
                          width="20"
                          height="20"
                          viewBox="0 0 256 229"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px'
                          }}
                        >
                          <path fill="#0066DA" d="m19.354 196.034l11.29 19.5c2.346 4.106 5.718 7.332 9.677 9.678q17.009-21.591 23.68-33.137q6.77-11.717 16.641-36.655q-26.604-3.502-40.32-3.502q-13.165 0-40.322 3.502c0 4.545 1.173 9.09 3.519 13.196z"/>
                          <path fill="#EA4335" d="M215.681 225.212c3.96-2.346 7.332-5.572 9.677-9.677l4.692-8.064l22.434-38.855a26.57 26.57 0 0 0 3.518-13.196q-27.315-3.502-40.247-3.502q-13.899 0-40.248 3.502q9.754 25.075 16.422 36.655q6.724 11.683 23.752 33.137"/>
                          <path fill="#00832D" d="M128.001 73.311q19.68-23.768 27.125-36.655q5.996-10.377 13.196-33.137C164.363 1.173 159.818 0 155.126 0h-54.25C96.184 0 91.64 1.32 87.68 3.519q9.16 26.103 15.544 37.154q7.056 12.213 24.777 32.638"/>
                          <path fill="#2684FC" d="M175.36 155.42H80.642l-40.32 69.792c3.958 2.346 8.503 3.519 13.195 3.519h148.968c4.692 0 9.238-1.32 13.196-3.52z"/>
                          <path fill="#00AC47" d="M128.001 73.311L87.681 3.52c-3.96 2.346-7.332 5.571-9.678 9.677L3.519 142.224A26.57 26.57 0 0 0 0 155.42h80.642z"/>
                          <path fill="#FFBA00" d="m215.242 77.71l-37.243-64.514c-2.345-4.106-5.718-7.331-9.677-9.677l-40.32 69.792l47.358 82.109h80.496c0-4.546-1.173-9.09-3.519-13.196z"/>
                        </svg>
                        {/* X Icon */}
                        <svg
                          className="x-icon-animated"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px'
                          }}
                        >
                          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="#000000"/>
                        </svg>
                        {/* Zoom Icon - official blue wordmark */}
                        <svg
                          className="zoom-icon-animated"
                          width="34"
                          height="10"
                          viewBox="0 0 512 117"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          preserveAspectRatio="xMidYMid meet"
                          style={{
                            position: 'absolute',
                            width: '34px',
                            height: '10px',
                            top: '5px',
                            left: '-7px'
                          }}
                        >
                          <path fill="#0B5CFF" d="M107.472 114.706H16.348c-5.968 0-11.791-3.203-14.557-8.589C-1.41 99.858-.247 92.434 4.702 87.63L68.17 24.164H22.607C10.088 24.164.044 13.974.044 1.6h83.992c5.968 0 11.79 3.203 14.556 8.589c3.203 6.259 2.038 13.683-2.911 18.486L32.214 92.143h52.55c12.518 0 22.708 10.19 22.708 22.563M468.183 0c-13.1 0-24.746 5.677-32.898 14.702C427.134 5.677 415.488 0 402.388 0c-24.164 0-43.961 20.67-43.961 44.834v69.872c12.518 0 22.562-10.19 22.562-22.563V44.689c0-11.646 9.025-21.544 20.67-21.98c12.228-.437 22.272 9.315 22.272 21.397v48.037c0 12.519 10.19 22.563 22.563 22.563V44.543c0-11.645 9.025-21.544 20.67-21.98c12.228-.437 22.272 9.316 22.272 21.398v48.036c0 12.52 10.19 22.563 22.563 22.563V44.69C512.144 20.67 492.347 0 468.183 0M221.595 58.226c0 32.17-26.056 58.226-58.226 58.226s-58.226-26.056-58.226-58.226S131.199 0 163.369 0s58.226 26.056 58.226 58.226m-22.563 0c0-19.651-16.012-35.663-35.663-35.663s-35.664 16.012-35.664 35.663c0 19.652 16.013 35.664 35.664 35.664s35.663-16.012 35.663-35.664m148.04 0c0 32.17-26.056 58.226-58.226 58.226S230.62 90.396 230.62 58.226S256.676 0 288.846 0s58.227 26.056 58.227 58.226m-22.562 0c0-19.651-16.012-35.663-35.664-35.663c-19.65 0-35.663 16.012-35.663 35.663c0 19.652 16.012 35.664 35.663 35.664c19.652 0 35.664-16.012 35.664-35.664"/>
                        </svg>
                        {/* Reddit Icon */}
                        <svg
                          className="reddit-icon-animated"
                          width="20"
                          height="20"
                          viewBox="0 0 256 256"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px'
                          }}
                        >
                          <circle cx="128" cy="128" r="128" fill="#FF4500"/>
                          <path fill="#FFFFFF" d="M213.15 129.22c0-10.376-8.391-18.617-18.617-18.617a18.74 18.74 0 0 0-12.97 5.189c-12.818-9.157-30.368-15.107-49.9-15.87l8.544-39.981l27.773 5.95c.307 7.02 6.104 12.667 13.278 12.667c7.324 0 13.275-5.95 13.275-13.278c0-7.324-5.95-13.275-13.275-13.275c-5.188 0-9.768 3.052-11.904 7.478l-30.976-6.562c-.916-.154-1.832 0-2.443.458c-.763.458-1.22 1.22-1.371 2.136l-9.464 44.558c-19.837.612-37.692 6.562-50.662 15.872a18.74 18.74 0 0 0-12.971-5.188c-10.377 0-18.617 8.391-18.617 18.617c0 7.629 4.577 14.037 10.988 16.939a33.6 33.6 0 0 0-.458 5.646c0 28.686 33.42 52.036 74.621 52.036c41.202 0 74.622-23.196 74.622-52.036a35 35 0 0 0-.458-5.646c6.408-2.902 10.985-9.464 10.985-17.093M85.272 142.495c0-7.324 5.95-13.275 13.278-13.275c7.324 0 13.275 5.95 13.275 13.275s-5.95 13.278-13.275 13.278c-7.327.15-13.278-5.953-13.278-13.278m74.317 35.251c-9.156 9.157-26.553 9.768-31.588 9.768c-5.188 0-22.584-.765-31.59-9.768c-1.371-1.373-1.371-3.51 0-4.883c1.374-1.371 3.51-1.371 4.884 0c5.8 5.8 18.008 7.782 26.706 7.782s21.058-1.983 26.704-7.782c1.374-1.371 3.51-1.371 4.884 0c1.22 1.373 1.22 3.51 0 4.883m-2.443-21.822c-7.325 0-13.275-5.95-13.275-13.275s5.95-13.275 13.275-13.275c7.327 0 13.277 5.95 13.277 13.275c0 7.17-5.95 13.275-13.277 13.275"/>
                        </svg>
                      </div>
                      <input
                        type="text"
                        id="youtube-url"
                        value={youtubeUrl}
                        onChange={(e) => {
                          if (!isAuthenticated) {
                            e.target.blur();
                            setUploadStatus({
                              type: 'error',
                              message: 'Please sign in to use YouTube URL'
                            });
                            setLoginMode('signup');
                            setIsSignupModalOpen(true);
                            return;
                          }
                          // Clear any previous error messages when authenticated
                          if (uploadStatus?.type === 'error' && uploadStatus?.message === 'Please sign in to use YouTube URL') {
                            setUploadStatus(null);
                          }
                          const newUrl = e.target.value;
                          setYoutubeUrl(newUrl);
                          // Validate URL on change
                          const validation = validateYouTubeUrl(newUrl);
                          setYoutubeUrlError(validation.error);
                        }}
                        placeholder="Paste any video URL"
                        style={{
                          width: '100%',
                          padding: '16px 20px 16px 48px',
                          borderRadius: '12px',
                          border: `2px solid ${youtubeUrlError ? '#ef4444' : '#e5e7eb'}`,
                          fontSize: '16px',
                          outline: 'none',
                          transition: 'all 0.2s',
                          background: '#fff',
                          position: 'relative',
                          zIndex: 1
                        }}
                        onFocus={(e) => {
                          if (!isAuthenticated) {
                            e.target.blur();
                            setUploadStatus({
                              type: 'error',
                              message: 'Please sign in to use YouTube URL'
                            });
                            setLoginMode('signup');
                            setIsSignupModalOpen(true);
                            return;
                          }
                          e.target.style.borderColor = youtubeUrlError ? '#ef4444' : '#8b5cf6';
                          e.target.style.boxShadow = youtubeUrlError 
                            ? '0 0 0 3px rgba(239, 68, 68, 0.1)' 
                            : '0 0 0 3px rgba(139, 92, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          // Validate on blur
                          const validation = validateYouTubeUrl(youtubeUrl);
                          setYoutubeUrlError(validation.error);
                          e.target.style.borderColor = validation.error ? '#ef4444' : '#e5e7eb';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      {youtubeUrlError && (
                        <div style={{
                          marginTop: '8px',
                          fontSize: '0.875rem',
                          color: '#ef4444',
                          padding: '8px 12px',
                          background: '#fef2f2',
                          borderRadius: '6px',
                          border: '1px solid #fecaca'
                        }}>
                          {youtubeUrlError}
                        </div>
                      )}
                    </div>
                    )}

                    {!selectedFile && !youtubeThumbnail && (
                      <>
                        <DailyContentIdeaBar
                          onRequireAuth={() => openSignInForFeature('Please sign in to use Daily content idea')}
                        />
                        <PublishToSocialBar
                          onRequireAuth={() => openSignInForFeature('Please sign in to publish to social')}
                        />
                        {isAuthenticated && (
                          <div id="past-projects">
                            <PastProjects />
                          </div>
                        )}
                      </>
                    )}

                  </div>
                )}
              </div>
              
              {/* Client Logos Carousel */}
              {!isAuthenticated && (
              <div className="clients-carousel">
                  <div className="clients-track">
                    <div className="client-logo">
                      <img src="/c1.png" alt="Client 1" />
                    </div>
                    <div className="client-logo">
                      <img src="/c2.png" alt="Client 2" />
                    </div>
                    <div className="client-logo">
                      <img src="/c3.png" alt="Client 3" />
                    </div>
                    <div className="client-logo">
                      <img src="/c4.png" alt="Client 4" />
                    </div>
                    <div className="client-logo">
                      <img src="/c5.png" alt="Client 5" />
                    </div>
                    <div className="client-logo">
                      <img src="/c6.png" alt="Client 6" />
                    </div>
                    <div className="client-logo">
                      <img src="/c7.png" alt="Client 7" />
                    </div>
                    <div className="client-logo">
                      <img src="/c8.png" alt="Client 8" />
                    </div>
                    <div className="client-logo">
                      <img src="/c9.png" alt="Client 9" />
                    </div>
                    {/* Duplicate for seamless loop */}
                    <div className="client-logo">
                      <img src="/c1.png" alt="Client 1" />
                    </div>
                    <div className="client-logo">
                      <img src="/c2.png" alt="Client 2" />
                    </div>
                    <div className="client-logo">
                      <img src="/c3.png" alt="Client 3" />
                    </div>
                    <div className="client-logo">
                      <img src="/c4.png" alt="Client 4" />
                    </div>
                    <div className="client-logo">
                      <img src="/c5.png" alt="Client 5" />
                    </div>
                    <div className="client-logo">
                      <img src="/c6.png" alt="Client 6" />
                    </div>
                    <div className="client-logo">
                      <img src="/c7.png" alt="Client 7" />
                    </div>
                    <div className="client-logo">
                      <img src="/c8.png" alt="Client 8" />
                    </div>
                    <div className="client-logo">
                      <img src="/c9.png" alt="Client 9" />
                    </div>
                  </div>
                </div>
              )}
                
                {uploadStatus && (
                  <div className={`upload-status ${uploadStatus.type}`}>
                    {uploadStatus.type === 'success' ? '✅' : '❌'} {uploadStatus.message}
                  </div>
                )}
            </div>
            {isAuthenticated && !selectedFile && !youtubeThumbnail && (
              <>
                <HomeDashboardCards
                  streakCount={showStreakOverlay ? streakOverlayFrom : streakCountDisplay}
                  streakCardRef={streakCardRef}
                  streakCardHighlight={streakCardHighlight}
                  hideStreakCard={showStreakOverlay}
                  onTurnOnReminders={handleTurnOnStreakReminders}
                  onAnalyseSocial={handleAnalyseSocial}
                  isPremiumUser={isPremiumUser}
                />
              </>
            )}
            </>
              );

              if (isSignedInIdleHome) {
                const badgeCount = showBadgeOverlay
                  ? badgeOverlayPrevCount
                  : (badgePreviewCount != null
                    ? badgePreviewCount
                    : badgeCountDisplay);
                const badgeTierKey = getBadgeProgress(badgeCount).tier.key;
                return (
                  <HomeSignedInIdleShell
                    tierKey={badgeTierKey}
                    badge={(
                      <VideoBadgeProgress
                        count={badgeCount}
                        medalRef={badgeMedalRef}
                        hideCurrentMedal={showBadgeOverlay}
                        medalHighlight={badgeMedalHighlight}
                      />
                    )}
                  >
                    {idleUploadBlock}
                  </HomeSignedInIdleShell>
                );
              }

              return idleUploadBlock;
            })()
          )}

          {/* Processing Status - Removed since results now show in main upload area */}
          {false && processingStatus && processingStatus !== 'processing' && (
            <div className="processing-section">
              <h3 className="processing-title">Processing Your Video</h3>
              <div className="processing-status">
                
                {processingStatus === 'completed' && resultFiles.length > 0 && (
                  <div className="results-section">
                    <h3 className="results-title">🎉 Your Viral Shorts Are Ready!</h3>
                    <p className="results-description">
                      We've created {resultFiles.length} viral short{resultFiles.length > 1 ? 's' : ''} from your video.
                    </p>
                    
                    <div className="results-grid">
                      {resultFiles.map((file, index) => {
                        const isPlaying = playingVideo === file.filename;
                        return (
                          <div key={index} className="result-item">
                            {!file.isProcessedVideo && (
                              <span className="result-virality-badge">
                                <i className="fa-solid fa-fire-flame-curved result-virality-badge-icon" aria-hidden="true" />
                                <span className="result-virality-badge-value">
                                  <span className="result-virality-badge-score">{file.viralityScore || 75}</span>
                                  <span className="result-virality-badge-max">/100</span>
                                </span>
                              </span>
                            )}
                            <div className="result-item__body">
                            <div className="result-thumbnail-container">
                              {isPlaying ? (
                                <div className="result-video-wrapper">
                                  <video
                                    ref={(el) => {
                                      videoRefs.current[file.filename] = el;
                                      if (el && isPlaying) {
                                        el.play().catch(() => {});
                                      }
                                    }}
                                    src={file.download_url}
                                    className="result-video-player"
                                    preload="metadata"
                                    onEnded={() => {
                                      setPlayingVideo(null);
                                      setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                    }}
                                    onClick={() => {
                                      // Toggle pause button visibility on video click
                                      setShowPauseButton(prev => ({ ...prev, [file.filename]: !prev[file.filename] }));
                                      // Hide again after 2 seconds
                                      setTimeout(() => {
                                        setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                      }, 2000);
                                    }}
                                    loop={false}
                                    playsInline
                                    controls={false}
                                  />
                                  {showPauseButton[file.filename] && (
                                    <button
                                      className="result-pause-button"
                                      onClick={() => {
                                        if (videoRefs.current[file.filename]) {
                                          videoRefs.current[file.filename].pause();
                                        }
                                        setPlayingVideo(null);
                                        setShowPauseButton(prev => ({ ...prev, [file.filename]: false }));
                                      }}
                                      aria-label="Pause video"
                                    >
                                      <svg width="32" height="32" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <>
                                  <ClipThumbnail
                                    fileStem={file.file_stem}
                                    clipFilename={file.filename}
                                    getFreshTokenRef={getFreshTokenRef}
                                  />
                                  <button
                                    className="result-play-button"
                                    onClick={() => {
                                      trackClipPreviewPlayed(file.filename);
                                      scheduleClipFeedbackPrompt('preview', file.filename);
                                      setPlayingVideo(file.filename);
                                      setShowPauseButton(prev => ({ ...prev, [file.filename]: true }));
                                    }}
                                    aria-label="Play video"
                                  >
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8 5v14l11-7z"/>
                                    </svg>
                                  </button>
                                </>
                              )}
                            </div>
                            <div className="result-content">
                              <div className="result-rank">
                                #{index + 1}
                              </div>
                              <div className="result-filename-wrap">
                                <h4 className="result-filename" title={file.filename}>
                                  {file.filename}
                                </h4>
                              </div>
                              <div className="result-actions">
                                <div className="result-actions-row">
                                <button
                                  type="button"
                                  className={`share-btn ${sharingFiles.has(file.filename) ? 'loading' : ''}`}
                                  onClick={() => {
                                    scheduleClipFeedbackPrompt('share', file.filename);
                                    shareResultVideo(file.download_url, file.filename);
                                  }}
                                  disabled={
                                    sharingFiles.has(file.filename) ||
                                    file.filename in downloadProgressByFile
                                  }
                                  aria-label={
                                    sharingFiles.has(file.filename)
                                      ? 'Preparing video to share'
                                      : 'Share video'
                                  }
                                  aria-busy={sharingFiles.has(file.filename)}
                                >
                                  {sharingFiles.has(file.filename) ? (
                                    <span className="download-spinner" aria-hidden="true">⏳</span>
                                  ) : (
                                    <svg className="share-btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="url(#result-action-grad)" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
                                    </svg>
                                  )}
                                </button>
                                <button
                                  type="button"
                                  className={`download-btn ${file.filename in downloadProgressByFile ? 'loading' : ''}`}
                                  onClick={() => {
                                    scheduleClipFeedbackPrompt('download', file.filename);
                                    downloadFile(file.download_url, file.filename);
                                  }}
                                  disabled={
                                    file.filename in downloadProgressByFile ||
                                    sharingFiles.has(file.filename)
                                  }
                                  aria-busy={file.filename in downloadProgressByFile}
                                  aria-label={
                                    file.filename in downloadProgressByFile
                                      ? `Downloading ${downloadProgressByFile[file.filename]} percent`
                                      : 'Download video'
                                  }
                                >
                                  {file.filename in downloadProgressByFile ? (
                                    `${downloadProgressByFile[file.filename]}%`
                                  ) : (
                                    'DOWNLOAD'
                                  )}
                                </button>
                                </div>
                              </div>
                            </div>
                            </div>
                            <div className="result-item__ribbon">
                              <ResultPublishButton
                                fileStem={file.file_stem}
                                clipFilename={file.filename}
                                taskId={currentTask}
                                userId={user?.uid || ''}
                                isPremiumUser={isPremiumUser}
                                getAuthToken={getFreshToken}
                                onStatusMessage={setUploadStatus}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <button
                      className="upload-new-btn"
                      onClick={() => {
                        trackUploadAnotherVideoClick();
                        setCurrentTask(null);
                        setProcessingStatus(null);
                        setResultFiles([]);
                        if (clipFeedbackTimerRef.current) {
                          clearTimeout(clipFeedbackTimerRef.current);
                          clipFeedbackTimerRef.current = null;
                        }
                        setShowClipFeedbackBubble(false);
                        setTaskRequirePhoneForDownload(null);
                        setUploadStatus(null);
                        hasRestoredFilesRef.current = false; // Reset so we can restore new files after processing
                      }}
                    >
                      Upload Another Video
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

        </div>
      </main>

      <HomeBgShortsVideo />
      
              <footer className="footer">
                <div className="footer-content">
                  <p className="footer-text">© 2026 Makereels.live. All rights reserved.</p>
                  <nav className="footer-nav" aria-label="Legal">
                    <Link to="/policy" className="footer-link">Privacy Policy</Link>
                    <span className="footer-sep" aria-hidden="true">·</span>
                    <Link to="/terms" className="footer-link">Terms of Service</Link>
                    <span className="footer-sep" aria-hidden="true">·</span>
                    <Link to="/refund" className="footer-link">Refund Policy</Link>
                  </nav>
                </div>
              </footer>
            </>
          } />
          <Route path="/features" element={<div className="secondary-page-fonts"><FeaturesPage /></div>} />
          <Route
            path="/alternatives/opusclip"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostOpusclip />
              </div>
            }
          />
          <Route
            path="/alternatives/klap"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostKlap />
              </div>
            }
          />
          <Route
            path="/alternatives/vidyoai"
            element={<Navigate to="/alternatives/quso" replace />}
          />
          <Route
            path="/alternatives/quso"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostQuso />
              </div>
            }
          />
          <Route path="/submagic" element={<Navigate to="/alternatives/submagic" replace />} />
          <Route
            path="/alternatives/submagic"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostSubmagic />
              </div>
            }
          />
          <Route path="/capcut" element={<Navigate to="/alternatives/capcut" replace />} />
          <Route
            path="/alternatives/capcut"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostCapcut />
              </div>
            }
          />
          <Route path="/vizard" element={<Navigate to="/alternatives/vizard" replace />} />
          <Route
            path="/alternatives/vizard"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostVizard />
              </div>
            }
          />
          <Route path="/veed" element={<Navigate to="/alternatives/veed" replace />} />
          <Route
            path="/alternatives/veed"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostVeed />
              </div>
            }
          />
          <Route path="/descript" element={<Navigate to="/alternatives/descript" replace />} />
          <Route
            path="/alternatives/descript"
            element={
              <div className="secondary-page-fonts">
                <AlternativePostDescript />
              </div>
            }
          />
          <Route
            path="/alternatives/:slug"
            element={
              <div className="secondary-page-fonts">
                <AlternativesComingSoonPost />
              </div>
            }
          />
          <Route
            path="/alternatives"
            element={
              <div className="secondary-page-fonts">
                <AlternativesPage />
              </div>
            }
          />
          <Route
            path="/blog/ai-shorts-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiShortsGenerator />
              </div>
            }
          />
          <Route
            path="/es/blog/generador-de-shorts-con-ia"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeneradorDeShortsConIa />
              </div>
            }
          />
          <Route
            path="/es/blog/video-largo-a-clips-cortos"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoLargoAClipsCortos />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/video-longo-para-clipes-curtos"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoLongoParaClipesCurtos />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/clips-courts-depuis-longue-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostClipsCourtsDepuisLongueVideo />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/langes-video-in-kurze-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLangesVideoInKurzeClips />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/lamba-video-se-chote-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLambaVideoSeChoteClips />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/lamba-video-se-chote-clips-hinglish"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLambaVideoSeChoteClipsHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/podavaina-video-nunchi-chinna-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostPodavainaVideoNunchiChinnaClips />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/neenda-video-siriya-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostNeendaVideoSiriyaClips />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/lamb-video-pasun-chote-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLambVideoPasunChoteClips />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/gerador-de-shorts-com-ia"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeradorDeShortsComIa />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/ki-shorts-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKiShortsGenerator />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/generateur-de-shorts-ia"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGenerateurDeShortsIa />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/ai-shorts-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiShortsGeneratorHiIn />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/ai-shorts-generator-hinglish"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiShortsGeneratorHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/kratrim-medhasshu-shorts-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKratrimMedhasshuShortsGenerator />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/seyrkai-nunnarivu-kurumpadam-uruvakki"
            element={
              <div className="secondary-page-fonts">
                <BlogPostSeyrkaiNunnarivuKurumpadamUruvakki />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/kratrim-buddhimatta-shorts-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKratrimBuddhimattaShortsGenerator />
              </div>
            }
          />
          <Route
            path="/blog/add-hinglish-subtitles-to-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAddHinglishSubtitles />
              </div>
            }
          />
          <Route
            path="/blog/ai-reel-maker-india-cheap"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiReelMakerIndiaCheap />
              </div>
            }
          />
          <Route
            path="/blog/convert-youtube-video-to-reels-automatically"
            element={
              <div className="secondary-page-fonts">
                <BlogPostConvertYoutubeToReels />
              </div>
            }
          />
          <Route
            path="/blog/ai-se-video-editing-kaise-kare"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiSeVideoEditingKaiseKare />
              </div>
            }
          />
          <Route
            path="/blog/reels-ko-viral-kaise-kare"
            element={
              <div className="secondary-page-fonts">
                <BlogPostReelsKoViralKaiseKare />
              </div>
            }
          />
          <Route
            path="/blog/turn-podcast-into-shorts-ai"
            element={
              <div className="secondary-page-fonts">
                <BlogPostTurnPodcastIntoShortsAi />
              </div>
            }
          />
          <Route
            path="/blog/viral-reels-banane-wala-app"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralReelsBananeWalaApp />
              </div>
            }
          />
          <Route
            path="/blog/content-creation-tips-hindi"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentCreationTipsHindi />
              </div>
            }
          />
          <Route
            path="/blog/instagram-uploading-guide-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInstagramUploadingGuide2026 />
              </div>
            }
          />
          <Route
            path="/blog/how-to-add-captions-to-youtube-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostHowToAddCaptionsToYoutubeShorts />
              </div>
            }
          />
          <Route
            path="/blog/how-to-make-reels-with-existing-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostHowToMakeReelsWithExistingVideo />
              </div>
            }
          />
          <Route
            path="/blog/long-video-to-short-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLongVideoToShortClips />
              </div>
            }
          />
          <Route
            path="/blog/video-to-viral-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoToViralShorts />
              </div>
            }
          />
          <Route
            path="/blog/zoom-recording-to-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingToShorts />
              </div>
            }
          />
          <Route
            path="/es/blog/grabaciones-de-zoom-a-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGrabacionesDeZoomAShorts />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/gravacao-zoom-em-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGravacaoZoomEmShorts />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/zoom-aufzeichnung-zu-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomAufzeichnungZuShorts />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/zoom-recording-to-shorts-french"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingToShortsFrench />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/zoom-recording-se-shorts-hindi"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingSeShortsHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/zoom-recording-ko-shorts-mein-badlo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingKoShortsMeinBadlo />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/zoom-recording-nunchi-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingNunchiShorts />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/zoom-recording-to-shorts-tamil"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingToShortsTamil />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/zoom-recording-te-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostZoomRecordingTeShorts />
              </div>
            }
          />
          <Route
            path="/blog/interview-to-short-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewToShortClips />
              </div>
            }
          />
          <Route
            path="/es/blog/de-entrevistas-a-clips-cortos-c-mo-extraer-tus-mejores-momentos-y-crecer-en-todas-las-plataformas"
            element={
              <div className="secondary-page-fonts">
                <BlogPostEntrevistasAClipsCortos />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/entrevista-em-clipes-curtos"
            element={
              <div className="secondary-page-fonts">
                <BlogPostEntrevistaEmClipesCurtos />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/interview-zu-kurzclips-wie-du-deine-besten-momente-extrahierst-und-auf-jeder-plattform-w-chst"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewZuKurzclips />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/interview-en-clips-courts-comment-extraire-vos-meilleurs-moments-et-grandir-sur-toutes-les-plateformes"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewEnClipsCourts />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/interview-se-short-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewSeShortClipsHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/interview-ko-short-clips-mein-badlo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewKoShortClipsMeinBadlo />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/interview-nunchi-short-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewNunchiShortClips />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/interview-to-short-clips-moments-platform-grow"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewToShortClipsTamil />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/interview-se-short-clips"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInterviewSeShortClipsMarathi />
              </div>
            }
          />
          <Route
            path="/blog/meeting-recording-to-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingToShorts />
              </div>
            }
          />
          <Route
            path="/es/blog/de-grabaciones-de-reuniones-a-shorts-c-mo-convertir-llamadas-grabadas-en-contenido-que-realmente-se-ve"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGrabacionesDeReunionesAShorts />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/gravacao-de-reuniao-em-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGravacaoDeReuniaoEmShorts />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/meeting-aufzeichnung-zu-shorts-wie-du-aufgezeichnete-calls-in-content-verwandelst-der-wirklich-angeschaut-wird"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingAufzeichnungZuShorts />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/enregistrement-de-r-union-en-shorts-comment-transformer-vos-appels-enregistr-s-en-contenu-qui-se-regarde-vraiment"
            element={
              <div className="secondary-page-fonts">
                <BlogPostEnregistrementDeReunionEnShorts />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/meeting-recording-se-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingSeShortsHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/meeting-recording-ko-shorts-mein-badlo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingKoShortsMeinBadlo />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/meeting-recording-nunchi-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingToShortsTamil />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/meeting-recording-to-shorts-record-calls-content"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingSeShortsMarathi />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/meeting-recording-se-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMeetingRecordingNunchiShorts />
              </div>
            }
          />
          <Route
            path="/blog/online-course-to-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseToReels />
              </div>
            }
          />
          <Route
            path="/es/blog/de-curso-online-a-reels-c-mo-convertir-el-contenido-de-tu-curso-en-video-de-formato-corto-que-llena-tu-embudo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostCursoOnlineAReels />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/curso-online-em-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostCursoOnlineEmReels />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/online-kurs-zu-reels-wie-du-deinen-kurs-content-in-short-form-video-verwandelst-das-deinen-funnel-f-llt"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineKursZuReels />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/cours-en-ligne-en-reels-comment-transformer-votre-contenu-de-cours-en-vid-o-format-court-qui-remplit-votre-funnel"
            element={
              <div className="secondary-page-fonts">
                <BlogPostCoursEnLigneEnReels />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/online-course-se-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseSeReelsHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/online-course-ko-reels-mein-badlo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseKoReelsMeinBadlo />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/online-course-nunchi-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseToReelsTamil />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/online-course-to-reels-course-content-funnel-short-form-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseTeReelsMarathi />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/online-course-te-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostOnlineCourseNunchiReels />
              </div>
            }
          />
          <Route
            path="/es/blog/video-a-shorts-virales"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoAShortsVirales />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/video-en-shorts-viraux"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoEnShortsViraux />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/video-para-shorts-virais"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoParaShortsVirais />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/video-zu-viralen-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoZuViralenShorts />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/video-se-viral-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoSeViralShortsHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/video-se-viral-shorts-hinglish"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoSeViralShortsHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/video-nunchi-viral-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoNunchiViralShorts />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/video-irundu-viral-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoIrunduViralShorts />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/video-pasun-viral-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoPasunViralShorts />
              </div>
            }
          />
          <Route
            path="/blog/ai-instagram-reels-growth-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAiInstagramReelsGrowth2026 />
              </div>
            }
          />
          <Route
            path="/blog/video-to-shorts-converter-makereels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoToShortsConverterMakereels />
              </div>
            }
          />
          <Route
            path="/blog/how-to-make-money-with-a-podcast-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostHowToMakeMoneyWithAPodcast2026 />
              </div>
            }
          />
          <Route
            path="/blog/makereels-marketing-agencies-growth"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMakereelsMarketingAgenciesGrowth />
              </div>
            }
          />
          <Route
            path="/blog/repurpose-content-into-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostRepurposeContentIntoShorts />
              </div>
            }
          />
          <Route
            path="/es/blog/convertir-contenido-en-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostConvertirContenidoEnShorts />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/transformar-conteudo-em-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostTransformarConteudoEmShorts />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/content-in-shorts-umwandeln"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentInShortsUmwandeln />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/transformer-contenu-en-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostTransformerContenuEnShorts />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/content-ko-shorts-mein-repurpose-karein"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentKoShortsMeinRepurposeKareinHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/content-ko-shorts-mein-repurpose-karein"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentKoShortsMeinRepurposeKareinHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/content-ni-shorts-ga-maarchu"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentNiShortsGaMaarchu />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/content-shorts-aga-maatrunga"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentShortsAgaMaatrunga />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/content-shorts-madhe-repurpose-kara"
            element={
              <div className="secondary-page-fonts">
                <BlogPostContentShortsMadheRepurposeKara />
              </div>
            }
          />
          <Route
            path="/blog/increase-watch-time-short-form-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostIncreaseWatchTimeShortFormVideo />
              </div>
            }
          />
          <Route
            path="/es/blog/c-mo-aumentar-el-tiempo-de-visualizaci-n-en-video-de-formato-corto-cada-t-ctica-que-realmente-funciona-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAumentarTiempoVisualizacionVideoCorto />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/como-aumentar-tempo-de-visualizacao-video-formato-curto"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAumentarTempoVisualizacaoVideoCurto />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/wie-du-die-wiedergabezeit-bei-short-form-video-erh-hst-jede-taktik-die-in-2026-wirklich-funktioniert"
            element={
              <div className="secondary-page-fonts">
                <BlogPostWiedergabezeitShortFormVideoErhoehen />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/comment-augmenter-le-temps-de-visionnage-sur-les-vid-os-format-court-toutes-les-tactiques-qui-fonctionnent-vraiment-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostAugmenterTempsVisionnageVideoCourt />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/short-video-watch-time-badhaye"
            element={
              <div className="secondary-page-fonts">
                <BlogPostShortVideoWatchTimeBadhayeHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/short-form-video-mein-watch-time-kaise-badhao"
            element={
              <div className="secondary-page-fonts">
                <BlogPostShortFormVideoWatchTimeBadhao />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/increase-watch-time-short-form-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostChinnaVideolaloVeekshanaSamayam />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/increase-watch-time-short-form-video"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKurumKaanoligalilPaarvaiNeram />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/laghu-svarup-video-pahanyacha-vel-vadhava"
            element={
              <div className="secondary-page-fonts">
                <BlogPostLaghuSvarupVideoPahanyachaVelVadhava />
              </div>
            }
          />
          <Route
            path="/blog/make-videos-go-viral-automatically"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMakeVideosGoViralAutomatically />
              </div>
            }
          />
          <Route
            path="/es/blog/hacer-que-los-videos-se-vuelvan-virales-autom-ticamente-el-sistema-que-usan-los-mejores-creadores-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideosViralesAutomaticamente />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/fazer-videos-viralizarem-automaticamente"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideosViralizaremAutomaticamente />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/videos-automatisch-viral-machen-das-system-das-top-creator-in-2026-nutzen"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideosAutomatischViralMachen />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/rendre-les-vid-os-virales-automatiquement-le-syst-me-que-les-meilleurs-cr-ateurs-utilisent-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostRendreVideosViralesAutomatiquement />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/videos-ko-automatically-viral-banaye"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideosKoAutomaticallyViralBanaye />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/videos-ko-automatically-viral-karo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideosKoAutomaticallyViralKaro />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/make-videos-go-viral-automatically"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoIuSwayanchalakangaViral />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/make-videos-go-viral-automatically"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKaanoligalaiThaanagaveViral />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/video-aapaapa-vishanujan-banava"
            element={
              <div className="secondary-page-fonts">
                <BlogPostVideoAapaapVishanujanBanava />
              </div>
            }
          />
          <Route
            path="/blog/get-more-views-on-youtube-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGetMoreViewsOnYouTubeShorts />
              </div>
            }
          />
          <Route
            path="/es/blog/c-mo-obtener-m-s-vistas-en-youtube-shorts-la-gu-a-completa-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMasVistasEnYouTubeShorts />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/como-conseguir-mais-visualizacoes-youtube-shorts"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMaisVisualizacoesNoYouTubeShorts />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/mehr-aufrufe-auf-youtube-shorts-bekommen-der-vollst-ndige-leitfaden-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMehrAufrufeAufYouTubeShorts />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/comment-obtenir-plus-de-vues-sur-youtube-shorts-le-guide-complet-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostPlusDeVuesSurYouTubeShorts />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/youtube-shorts-par-jyada-views"
            element={
              <div className="secondary-page-fonts">
                <BlogPostYouTubeShortsParJyadaViews />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/youtube-shorts-pe-zyada-views-kaise-pao"
            element={
              <div className="secondary-page-fonts">
                <BlogPostYouTubeShortsPeZyadaViews />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/youtube-shorts-lo-more-views-ela-padayali"
            element={
              <div className="secondary-page-fonts">
                <BlogPostYouTubeShortsMoreViewsTelugu />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/youtube-shorts-views-2026-complete-guide"
            element={
              <div className="secondary-page-fonts">
                <BlogPostYouTubeShortsAdhigaViewsTamil />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/youtube-shorts-var-jast-views"
            element={
              <div className="secondary-page-fonts">
                <BlogPostYouTubeShortsVarJastViews />
              </div>
            }
          />
          <Route
            path="/blog/viral-hook-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralHookGenerator />
              </div>
            }
          />
          <Route
            path="/es/blog/generador-de-ganchos-virales-c-mo-escribir-ganchos-que-detengan-el-desplazamiento-cada-vez"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeneradorGanchosVirales />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/gerador-de-ganchos-virais"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeradorGanchosVirais />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/viraler-hook-generator-so-schreibst-du-hooks-die-den-scroll-jedes-mal-stoppen"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralerHookGenerator />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/g-n-rateur-d-accroches-virales-comment-crire-des-hooks-qui-arr-tent-le-scroll-chaque-fois"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGenerateurAccrochesVirales />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/viral-hook-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralHookGeneratorHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/viral-hook-generator-scroll-rokne-wale-hooks"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralHookGeneratorHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/viral-hook-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralHookGeneratorTelugu />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/viral-hook-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralKokkiUruvaakki />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/viral-hook-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostViralHookGeneratorMarathi />
              </div>
            }
          />
          <Route
            path="/blog/free-caption-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeCaptionGenerator />
              </div>
            }
          />
          <Route
            path="/es/blog/generador-de-subt-tulos-gratuito-las-mejores-herramientas-para-videos-y-reels-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeneradorSubtitulosGratuitoVideos />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/gerador-de-legendas-gratuito-para-videos"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeradorLegendasGratuitoVideos />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/kostenloser-caption-generator-beste-tools-f-r-videos-und-reels-in-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKostenloserCaptionGenerator />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/g-n-rateur-de-l-gendes-gratuit-meilleurs-outils-pour-vid-os-et-reels-en-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGenerateurLegendesGratuit />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/free-caption-generator-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeCaptionGeneratorHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/free-caption-generator-best-tools-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeCaptionGeneratorHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/free-caption-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostUchitaCaptionGenerator />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/free-caption-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostIlavasaThalaippuraiUruvaakki />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/mofat-mathala-nirmaata"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMofatMathalaNirmaata />
              </div>
            }
          />
          <Route
            path="/blog/free-subtitle-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeSubtitleGenerator />
              </div>
            }
          />
          <Route
            path="/es/blog/generador-de-subt-tulos-gratuito-las-mejores-opciones-en-2026-y-cu-ndo-actualizarte"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeneradorSubtitulosGratuito />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/generador-de-subtitulos-gratuito"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGeradorLegendasGratuito />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/kostenloser-untertitel-generator-die-besten-optionen-in-2026-und-wann-du-upgraden-solltest"
            element={
              <div className="secondary-page-fonts">
                <BlogPostKostenloserUntertitelGenerator />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/g-n-rateur-de-sous-titres-gratuit-les-meilleures-options-en-2026-et-quand-passer-la-version-payante"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGenerateurSousTitresGratuit />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/free-subtitle-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeSubtitleGeneratorHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/free-subtitle-generator-best-options-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFreeSubtitleGeneratorHinglish />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/free-subtitle-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostUchitaSubtitleGenerator />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/free-subtitle-generator"
            element={
              <div className="secondary-page-fonts">
                <BlogPostIlavasaVasanaVariUruvaakki />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/mofat-upshirshak-nirmaata"
            element={
              <div className="secondary-page-fonts">
                <BlogPostMofatUpshirshakNirmaata />
              </div>
            }
          />
          <Route
            path="/blog/grow-instagram-with-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostGrowInstagramWithReels />
              </div>
            }
          />
          <Route
            path="/es/blog/c-mo-crecer-en-instagram-con-reels-la-estrategia-completa-para-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostCrecerInstagramConReels />
              </div>
            }
          />
          <Route
            path="/pt-BR/blog/como-crescer-no-instagram-com-reels"
            element={
              <div className="secondary-page-fonts">
                <BlogPostCrescerInstagramComReels />
              </div>
            }
          />
          <Route
            path="/de-DE/blog/wie-du-instagram-mit-reels-w-chst-die-vollst-ndige-strategie-f-r-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInstagramMitReelsWachsen />
              </div>
            }
          />
          <Route
            path="/fr-FR/blog/comment-faire-cro-tre-instagram-avec-les-reels-la-strat-gie-compl-te-pour-2026"
            element={
              <div className="secondary-page-fonts">
                <BlogPostFaireCroitreInstagramAvecReels />
              </div>
            }
          />
          <Route
            path="/hi-IN/blog/reels-se-instagram-grow-karo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostReelsSeInstagramGrowKaroHindi />
              </div>
            }
          />
          <Route
            path="/en-IN/blog/instagram-ko-reels-se-kaise-grow-karo"
            element={
              <div className="secondary-page-fonts">
                <BlogPostInstagramKoReelsSeGrowKaro />
              </div>
            }
          />
          <Route
            path="/te-IN/blog/reels-tho-instagram-ela-penchukovaali"
            element={
              <div className="secondary-page-fonts">
                <BlogPostReelsThoInstagramPenchukovali />
              </div>
            }
          />
          <Route
            path="/ta-IN/blog/reels-instagram-grow-2026-complete-strategy"
            element={
              <div className="secondary-page-fonts">
                <BlogPostReelsMoolamInstagramGrowTamil />
              </div>
            }
          />
          <Route
            path="/mr-IN/blog/reels-ne-instagram-grow-kara"
            element={
              <div className="secondary-page-fonts">
                <BlogPostReelsNeInstagramGrowKara />
              </div>
            }
          />
          <Route
            path="/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuide /></div>}
          />
          <Route
            path="/es/blog/guia-marketing-video-ia-2026"
            element={<div className="secondary-page-fonts"><BlogPostGuiaMarketingVideoIA /></div>}
          />
          <Route
            path="/pt-BR/blog/guia-marketing-video-ia-2026"
            element={<div className="secondary-page-fonts"><BlogPostGuiaMarketingVideoComIA /></div>}
          />
          <Route
            path="/de-DE/blog/ki-video-marketing-leitfaden-2026"
            element={<div className="secondary-page-fonts"><BlogPostKiVideoMarketingLeitfaden /></div>}
          />
          <Route
            path="/fr-FR/blog/guide-du-marketing-vid-o-par-ia-le-syst-me-complet-pour-cr-ateurs-et-marques-en-2026"
            element={<div className="secondary-page-fonts"><BlogPostGuideMarketingVideoIA /></div>}
          />
          <Route
            path="/hi-IN/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuideHindi /></div>}
          />
          <Route
            path="/en-IN/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuideHinglish /></div>}
          />
          <Route
            path="/te-IN/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuideTelugu /></div>}
          />
          <Route
            path="/ta-IN/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuideTamil /></div>}
          />
          <Route
            path="/mr-IN/blog/ai-video-marketing-guide-2026"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoMarketingGuideMarathi /></div>}
          />
          <Route
            path="/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingTool /></div>}
          />
          <Route
            path="/es/blog/herramienta-recorte-video-ia"
            element={<div className="secondary-page-fonts"><BlogPostHerramientaRecorteVideoIA /></div>}
          />
          <Route
            path="/pt-BR/blog/ferramenta-clipping-video-ia"
            element={<div className="secondary-page-fonts"><BlogPostFerramentaClippingVideoIA /></div>}
          />
          <Route
            path="/de-DE/blog/ki-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostKiVideoClippingTool /></div>}
          />
          <Route
            path="/fr-FR/blog/outil-de-d-coupe-vid-o-par-ia-les-meilleures-options-pour-cr-ateurs-en-2026"
            element={<div className="secondary-page-fonts"><BlogPostOutilDecoupeVideoIA /></div>}
          />
          <Route
            path="/hi-IN/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingToolHindi /></div>}
          />
          <Route
            path="/en-IN/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingToolHinglish /></div>}
          />
          <Route
            path="/te-IN/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingToolTelugu /></div>}
          />
          <Route
            path="/ta-IN/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingToolTamil /></div>}
          />
          <Route
            path="/mr-IN/blog/ai-video-clipping-tool"
            element={<div className="secondary-page-fonts"><BlogPostAiVideoClippingToolMarathi /></div>}
          />
          <Route
            path="/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostConvertVideoToVerticalFormat /></div>}
          />
          <Route
            path="/es/blog/convertir-video-a-formato-vertical"
            element={<div className="secondary-page-fonts"><BlogPostConvertirVideoAFormatoVertical /></div>}
          />
          <Route
            path="/pt-BR/blog/converter-video-para-formato-vertical"
            element={<div className="secondary-page-fonts"><BlogPostConverterVideoParaFormatoVertical /></div>}
          />
          <Route
            path="/de-DE/blog/video-ins-vertikale-format-konvertieren"
            element={<div className="secondary-page-fonts"><BlogPostVideoInsVertikaleFormatKonvertieren /></div>}
          />
          <Route
            path="/fr-FR/blog/convertir-une-vid-o-au-format-vertical-le-guide-complet-pour-2026"
            element={<div className="secondary-page-fonts"><BlogPostConvertirVideoAuFormatVertical /></div>}
          />
          <Route
            path="/hi-IN/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostVideoKoVerticalFormatMeinConvertKarein /></div>}
          />
          <Route
            path="/en-IN/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostVideoKoVerticalFormatMeinConvertKaro /></div>}
          />
          <Route
            path="/te-IN/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostVideoNiluvaNirmitanikiMarchandi /></div>}
          />
          <Route
            path="/ta-IN/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostKaanoliyaiSenguthuVadivamagaMaatru /></div>}
          />
          <Route
            path="/mr-IN/blog/convert-video-to-vertical-format"
            element={<div className="secondary-page-fonts"><BlogPostVideoUbhaSwarupatRupantaritKara /></div>}
          />
          <Route
            path="/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostAutoCutSilenceFromVideo /></div>}
          />
          <Route
            path="/es/blog/corte-automatico-silencios-video"
            element={<div className="secondary-page-fonts"><BlogPostCorteAutomaticoSilenciosVideo /></div>}
          />
          <Route
            path="/pt-BR/blog/cortar-silencio-video-automaticamente"
            element={<div className="secondary-page-fonts"><BlogPostCortarSilencioVideoAutomaticamente /></div>}
          />
          <Route
            path="/de-DE/blog/stille-automatisch-aus-videos-schneiden"
            element={<div className="secondary-page-fonts"><BlogPostStilleAutomatischAusVideosSchneiden /></div>}
          />
          <Route
            path="/fr-FR/blog/couper-automatiquement-les-silences-dans-les-vid-os-les-meilleurs-outils-en-2026"
            element={<div className="secondary-page-fonts"><BlogPostCouperAutomatiquementSilencesVideos /></div>}
          />
          <Route
            path="/hi-IN/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostVideoSeSilenceAutoCutKarein /></div>}
          />
          <Route
            path="/en-IN/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostVideoSeSilenceAutoCutKaro /></div>}
          />
          <Route
            path="/te-IN/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostVideoNundiNisshabdamCut /></div>}
          />
          <Route
            path="/ta-IN/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostKaanoliyilirundhuMavunamVettu /></div>}
          />
          <Route
            path="/mr-IN/blog/auto-cut-silence-from-video"
            element={<div className="secondary-page-fonts"><BlogPostVideoMadhunMaunSwayanchalitKadha /></div>}
          />
          <Route
            path="/blog/face-tracking-videoeditor"
            element={<div className="secondary-page-fonts"><BlogPostFaceTrackingVideoeditor /></div>}
          />
          <Route
            path="/es/blog/editor-video-seguimiento-facial"
            element={<div className="secondary-page-fonts"><BlogPostEditorVideoSeguimientoFacial /></div>}
          />
          <Route
            path="/pt-BR/blog/editor-video-rastreamento-facial"
            element={<div className="secondary-page-fonts"><BlogPostEditorVideoRastreamentoFacial /></div>}
          />
          <Route
            path="/de-DE/blog/face-tracking-videoeditor"
            element={<div className="secondary-page-fonts"><BlogPostGermanFaceTrackingVideoeditor /></div>}
          />
          <Route
            path="/fr-FR/blog/editeur-video-suivi-visage"
            element={<div className="secondary-page-fonts"><BlogPostEditeurVideoSuiviVisage /></div>}
          />
          <Route
            path="/hi-IN/blog/face-tracking-video-editor-hindi"
            element={<div className="secondary-page-fonts"><BlogPostFaceTrackingVideoEditorHindi /></div>}
          />
          <Route
            path="/mr-IN/blog/chehra-tracking-video-sampadak"
            element={<div className="secondary-page-fonts"><BlogPostChehraTrackingVideoSampadak /></div>}
          />
          <Route
            path="/en-IN/blog/face-tracking-video-editor"
            element={<div className="secondary-page-fonts"><BlogPostFaceTrackingVideoEditorHinglish /></div>}
          />
          <Route
            path="/te-IN/blog/face-tracking-video-editor"
            element={<div className="secondary-page-fonts"><BlogPostFaceTrackingVideoEditorTelugu /></div>}
          />
          <Route
            path="/ta-IN/blog/mugam-kankaanippu-kaanoli-thoguppi"
            element={<div className="secondary-page-fonts"><BlogPostMugamKankaanippuKaanoliThoguppi /></div>}
          />
          <Route
            path="/blog/batch-create-youtube-shorts"
            element={<div className="secondary-page-fonts"><BlogPostBatchCreateYouTubeShorts /></div>}
          />
          <Route
            path="/en-IN/blog/batch-create-youtube-shorts"
            element={<div className="secondary-page-fonts"><BlogPostBatchCreateYouTubeShortsHinglish /></div>}
          />
          <Route
            path="/es/blog/crear-youtube-shorts-en-lote"
            element={<div className="secondary-page-fonts"><BlogPostCrearYouTubeShortsEnLote /></div>}
          />
          <Route
            path="/blog/:slug"
            element={
              <div className="secondary-page-fonts">
                <BlogComingSoonPost />
              </div>
            }
          />
          <Route path="/blog" element={<div className="secondary-page-fonts"><BlogPage /></div>} />
          <Route path="/blog/page/:pageNumber" element={<div className="secondary-page-fonts"><BlogPage /></div>} />
          <Route path="/pricing" element={<div className="secondary-page-fonts"><PricingPage /></div>} />
          <Route path="/calender" element={<div className="secondary-page-fonts"><CalendarPage /></div>} />
          <Route path="/dailycontent" element={<div className="secondary-page-fonts"><IdeationPage /></div>} />
          <Route path="/projects/:fileStem" element={<div className="secondary-page-fonts"><ProjectsPage /></div>} />
          <Route path="/policy" element={<div className="secondary-page-fonts"><PolicyPage /></div>} />
          <Route path="/terms" element={<div className="secondary-page-fonts"><TermsPage /></div>} />
          <Route path="/refund" element={<div className="secondary-page-fonts"><RefundPage /></div>} />
          <Route path="/reelsadmin" element={<div className="secondary-page-fonts"><ReelsAdminPage /></div>} />
          <Route path="/notfound" element={<div className="secondary-page-fonts"><NotFoundPage /></div>} />
          <Route path="*" element={<div className="secondary-page-fonts"><NotFoundPage /></div>} />
        </Routes>
        </Suspense>
        
        {/* Login Page Modal */}
        <LoginPage 
          isOpen={isSignupModalOpen} 
          onClose={() => {
            setIsSignupModalOpen(false);
            setLoginMode('signup'); // Reset to signup for next time
          }}
          mode={loginMode}
          onModeChange={(newMode) => setLoginMode(newMode)}
        />

        <ReferralReturnCouponModal suppress={showSuccessScreen} />

        <WhatsAppSupportFabForRoute supportNumber={whatsAppSupportNumber} isPremiumUser={isPremiumUser} />
        
        {/* Phone Number Popup */}
        {showPhonePopup && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: '20px'
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowPhonePopup(false);
              setPhonePopupMode(null);
            }
          }}
          >
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '32px',
              maxWidth: '400px',
              width: '100%',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              position: 'relative'
            }}>
              {/* Back button in top left */}
              <button
                onClick={() => {
                  setShowPhonePopup(false);
                  setPhonePopupMode(null);
                  setPhoneNumber('');
                  setPhoneNumberError('');
                }}
                style={{
                  position: 'absolute',
                  top: '16px',
                  left: '16px',
                  background: 'white',
                  border: '2px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  cursor: 'pointer',
                  color: '#6b7280',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  zIndex: 20,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#8b5cf6';
                  e.target.style.color = '#8b5cf6';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#e5e7eb';
                  e.target.style.color = '#6b7280';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Back</span>
              </button>
              
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                marginBottom: '8px',
                color: '#111827',
                marginTop: '56px'
              }}>
                {phonePopupMode === 'download' ? 'Phone Number Required' : 'Get Notified'}
              </h3>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                marginBottom: '24px'
              }}>
                {phonePopupMode === 'download' 
                  ? 'Please provide your phone number to download videos.' 
                  : 'We\'ll notify you when your viral shorts are ready!'}
              </p>
              
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                  // Clear error when user starts typing
                  if (phoneNumberError) {
                    setPhoneNumberError('');
                  }
                  // Validate on change to show error in real-time
                  if (e.target.value.trim()) {
                    const validation = validatePhoneNumber(e.target.value);
                    if (!validation.isValid) {
                      setPhoneNumberError(validation.message);
                    }
                  }
                }}
                placeholder="+91 9876543210"
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: `2px solid ${phoneNumberError ? '#ef4444' : '#e5e7eb'}`,
                  borderRadius: '8px',
                  fontSize: '16px',
                  marginBottom: phoneNumberError ? '8px' : '24px',
                  outline: 'none',
                  transition: 'border-color 0.2s'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = phoneNumberError ? '#ef4444' : '#8b5cf6';
                }}
                onBlur={(e) => {
                  const validation = validatePhoneNumber(phoneNumber);
                  if (!validation.isValid && phoneNumber.trim()) {
                    setPhoneNumberError(validation.message);
                  }
                  e.target.style.borderColor = phoneNumberError ? '#ef4444' : '#e5e7eb';
                }}
              />
              
              {/* Error message below input */}
              {phoneNumberError && (
                <div style={{
                  fontSize: '13px',
                  color: '#ef4444',
                  marginBottom: '20px',
                  padding: '8px 12px',
                  background: '#fef2f2',
                  borderRadius: '6px',
                  border: '1px solid #fecaca'
                }}>
                  {phoneNumberError}
                </div>
              )}
              
              {/* Gradient button matching Generate Shorts style */}
              <button
                onClick={handleUpdatePhoneNumber}
                disabled={isLoading || !phoneNumber.trim()}
                style={{
                  width: '100%',
                  background: isLoading || !phoneNumber.trim() 
                    ? '#d1d5db' 
                    : 'linear-gradient(90deg, #8b5cf6, #ec4899)',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: isLoading || !phoneNumber.trim() ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: isLoading || !phoneNumber.trim()
                    ? 'none'
                    : '0 4px 12px rgba(139, 92, 246, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px'
                }}
                onMouseEnter={(e) => {
                  if (!isLoading && phoneNumber.trim()) {
                    e.target.style.background = 'linear-gradient(90deg, #7c3aed, #db2777)';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(139, 92, 246, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isLoading && phoneNumber.trim()) {
                    e.target.style.background = 'linear-gradient(90deg, #8b5cf6, #ec4899)';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.3)';
                  }
                }}
              >
                <strong style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                  {isLoading ? (
                    'Adding...'
                  ) : (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}>
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <span>Notify Me</span>
                    </>
                  )}
                </strong>
              </button>
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;

